/// <reference path="Constants.js"/>
/// <reference path="Helpers.js"/>
/// <reference path="MyStory\MyStory.js"/>
var importFile = "";
window.GeneralSettings = {
	printSelectedSettings: [],
	hasGeneralSettings: function () {
		return (
			$("#pnlSettingsPanel .SettingsControl").filter(function() { return this.style.display !== "none"; }).length > 0 ||
			Storyboard.HFilterLayout.hasHFilterNodes() || 
			$("#languageContainer").css("display") !== "none"
		);
	},
	getSettingOptions: function (settings) {
		var options = [];

		for (var i = 0, setting; (setting = settings[i]); i++) {
			options.push({
				name: setting.Name,
				type: setting.SettingType,
				id: setting.SettingId,
				hasNoSelection: setting.HasNoSelection,
				items: setting.SettingItems
			});
		}

        return options;
    },
	getSelectedSettings: function () {
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
			return DeckFilters.getSelectedSettings();

		var selectedSettings = [];
		var setting;

		var doc = document;
		if (self != top && window.name == "print-frame" && !window.IsFormReport && !window.IsDrilldown)
			try {
				doc = window.parent.document;

				// returning same selection for the Print window, as they are on the Storyteller
				return top.window.GeneralSettings.printSelectedSettings;			
			} catch (e) { /* empty */ }

		$("#pnlSettingsPanel .SettingsControl", doc)
			.not('.HideFilter, .NoOptionsFilter, .myStorySettingsControl')
			.each(function () {
				var settingType = parseInt($(this).find(".hidSettingType").val(), 10);
				var selections = "";
				var compareAdd = "";

				if (!settingType) return;
				if (settingType == 2 && $('#lbSetting_2').attr('autoSelectInterval')) return;

				if (settingType == 5) {
					if ($(this).find("input:radio"))
						compareAdd = "-" + $(this).find("input:radio:checked").val();
				}

				$(this).find("select").not('#ddlPrepPeriodItem_3').each(function () {
					if (this.value != null) {
						if ($(this).attr("multiple")) {
							var tempSel = [];
							$("option:selected", this).each(function () { tempSel.push(this.value) });

							for (var selection in tempSel)
								if (tempSel.hasOwnProperty(selection)) {
									selections += tempSel[selection] + compareAdd + ",";
								}
						}
						else
							selections += $(this).val() + compareAdd + ",";
					}
				});

				var setting = GeneralSettings.getSettingByType(selectedSettings, settingType);
				if (!setting) {
					setting = {};
					selectedSettings.push(setting);
				}

				if (settingType == 5 && selections.indexOf("0-0-") > -1 && $(this).is(':visible')) {
					if ($(this).find("select option:eq(1)").val() != undefined)
						var NoSelectionFilterId = $(this).find("select option:eq(1)").val().split('-')[0];

					if (setting.NoSelectionFilterIds && setting.NoSelectionFilterIds.length)
						setting.NoSelectionFilterIds += ',' + NoSelectionFilterId;
					else
						setting.NoSelectionFilterIds = NoSelectionFilterId;
				}

				if (setting.SelectedSettings && setting.SelectedSettings.length)
					selections += setting.SelectedSettings + ",";

				if (selections.length == 0 && !setting.SelectedSettings)
					setting.SelectedSettings = "";
				else
					setting.SelectedSettings = selections.replace(/,$/g, '');

				if (settingType == 3) {
					var dateVariable = $('#lbSetting_3_DateVariable').val();

					if (dateVariable) {
						setting.DateVariableId = dateVariable;
					}

					if (setting.SelectedSettings == "-2") { // custom period
						if (self != top && window.name == "print-frame") {
							setting.StartDate = Helpers.readCookie('selectedStartDate');
							setting.EndDate = Helpers.readCookie('selectedEndDate');
						} else {
							setting.StartDate = $(this).find(".optCustomPeriodStart").datepicker('getDate').format('yyyy/MM/dd');
							setting.EndDate = $(this).find(".optCustomPeriodEnd").datepicker('getDate').format('yyyy/MM/dd');
						}
					} else if ($('#lbSetting_3 option[value="' + setting.SelectedSettings + '"]').attr('data-prep-time-period-type') > 0) {
						setting.StartDate = $('#ddlPrepPeriodItem_3 option:selected').attr('strStartDate');
						setting.EndDate = $('#ddlPrepPeriodItem_3 option:selected').attr('strStopDate');
						setting.PreparedPeriodItem = $('#ddlPrepPeriodItem_3').val();
					}

					if ($('#lbSetting_2').attr('autoSelectInterval')) {
						var intervalSetting = { SettingType: 2, SelectedSettings : '7' };

						if ($('#lbSetting_3 option[value="' + setting.SelectedSettings + '"]').attr('data-prep-time-period-type') > 0)
							intervalSetting.SelectedSettings = $('#lbSetting_3 option[value="' + setting.SelectedSettings + '"]').attr('data-prep-time-period-type');
						else if ($('#lbSetting_3 option[value="' + setting.SelectedSettings + '"]').attr('data-time-period-span') > 0)
							intervalSetting.SelectedSettings = $('#lbSetting_3 option[value="' + setting.SelectedSettings + '"]').attr('data-time-period-span');
						else if (setting.SelectedSettings == '18') // Year
							intervalSetting.SelectedSettings = '6';

						selectedSettings.push(intervalSetting);
					}
				}

				setting.SettingType = settingType.toString();
			});

		var selectedHFilters = Storyboard.GeneralSettings.hasHFilter() ? Storyboard.HFilterLayout.getSelectedIds("#hfilterTree") : false;

		if (selectedHFilters && selectedHFilters.length > 0) {
			setting = {};
			setting.SelectedSettings = selectedHFilters.toString();
			setting.SettingType = 6; //HFilter Type
			selectedSettings.push(setting);
		}

		var selectedLanguage = $("#ddlLng").val();
		if (selectedLanguage) {
			setting = {};
			setting.SelectedSettings = selectedLanguage;
			setting.SettingType = 7; // Language
			selectedSettings.push(setting);
		}

		return selectedSettings;
	},
	getSelectedIterateFilters: function () {
		//TODO - FOR SC
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
			return "";
			//return DeckFilters.getSelectedSettings();

		var selectedSettings = [];

		$("#downloadableNodesPowerpoint #regularFiltersPowerpoint .SettingsControl")
			.not('.HideFilter, .NoOptionsFilter, .myStorySettingsControl')
			.each(function () {
				var settingType = parseInt($(this).find(".hidSettingType").val(), 10);
				var selections = "";
				var compareAdd = "";

				if (!settingType) return;
				if (settingType == 2 && $('#lbSetting_2').attr('autoSelectInterval')) return;

				if (settingType == 5) {
					if ($(this).find("input:radio"))
						 compareAdd = "-" + $(this).find("input:radio:checked").val();
				}  

				$(this).find("select").not('#ddlPrepPeriodItem_3').each(function () {
					var $siblingButton = $(this).siblings('button');
					if (!$siblingButton.hasClass('ui-state-disabled')) {
						if (this.value != null) {
							if ($(this).attr("multiple")) {
								var tempSel = [];
								$("option:selected", this).each(function () { tempSel.push(this.value) });

								for (var selection in tempSel)
									if (tempSel.hasOwnProperty(selection)) {
										selections += tempSel[selection] + compareAdd + ",";
									}
							}
							else
								selections += $(this).val() + compareAdd + ",";
						}
					}
				});

				var setting = GeneralSettings.getSettingByType(selectedSettings, settingType);
				if (!setting) {
					setting = {};
					selectedSettings.push(setting);
				}

				if (settingType == 5 && selections.indexOf("0-0-") > -1 && $(this).is(':visible')) {
					if ($(this).find("select option:eq(1)").val() != undefined)
						var NoSelectionFilterId = $(this).find("select option:eq(1)").val().split('-')[0];

					if (setting.NoSelectionFilterIds && setting.NoSelectionFilterIds.length)
						setting.NoSelectionFilterIds += ',' + NoSelectionFilterId;
					else
						setting.NoSelectionFilterIds = NoSelectionFilterId;
				}

				if (setting.SelectedSettings && setting.SelectedSettings.length)
					selections += setting.SelectedSettings + ",";

				if (selections.length == 0 && !setting.SelectedSettings)
					setting.SelectedSettings = "";
				else
					setting.SelectedSettings = selections.replace(/,$/g, '');

				

				setting.SettingType = settingType.toString();
			});

		return selectedSettings && selectedSettings[0] && selectedSettings[0].SelectedSettings ? selectedSettings[0].SelectedSettings : "";
	},
	getSettingByType: function (selectedSettings, settingType) {
		if (selectedSettings)
			for (var settingIX in selectedSettings)
				if (selectedSettings.hasOwnProperty(settingIX)) {

					if (parseInt(selectedSettings[settingIX].SettingType, 10) === settingType) {
						return selectedSettings[settingIX];
					}
				}
		return null;
	},
	hideHiddenFilters: function (IsSplitBoxes, SettingItems) {
		if (IsSplitBoxes && !Storyboard.LayoutDesigner.isAdmin)
			for (var i = 0; i < SettingItems.length; i++) {
				if (SettingItems[i].IsHidden) {
					var lb = $('#lbSetting_5_' + SettingItems[i].DisplayID);
					$(lb).parent().hide(); //addClass('HideFilter'); for some reason adding this class does not hide filter
					$(lb).parent().addClass('HideFilterOption');
				}
			}
	},
	loadOptions: function (box, checkAll, callback) {
		var loadMore = checkAll ? checkAll : false;
		var filterDisplayId;

		if (!loadMore) {
			var menu = box.multiselect("widget").find(".ui-multiselect-checkboxes");
			
			var scrollPosition = $(menu).position().top + $(menu).height();
			var lastOption = $(menu).find("li:visible:last");
			var lastOptionY = lastOption.length ? (lastOption.height() + lastOption.position().top - 4) : scrollPosition;

			loadMore = scrollPosition > lastOptionY;
		}

		if (box.find("option[value!='0-0'][value!='0-1'][value!='0-2']").length >= box.attr("totaloptions"))
			loadMore = false;
		
		if (loadMore) {
			GeneralSettings.unbindLazyLoadScroll(box);

			var splitBoxId = box.attr("id").split('_');
			if (splitBoxId.length > 2)
				filterDisplayId = splitBoxId[2];
			else if (splitBoxId[0] == "ddlDefaultSelection")
				filterDisplayId = splitBoxId[1];
			else
				filterDisplayId = "0";

			var dynFilterRequest = null;
			if (Storyboard.DynamicFiltering.isEnabled() && box.closest(".SettingsControl").hasClass("dynamicFiltering") &&
				box.closest(".dynamicFiltering").data("dynamicFiltering") === Storyboard.Constants.DynamicFilteringStatus.OnHideOptionsWithNoData)
				dynFilterRequest = Storyboard.DynamicFiltering.getUserSelectedSettings();

			var startAtPosition = box.find("option").length - box.find("option[value^='0']").length;
			if (Storyboard.GeneralSettings.hfilterVsFiltersActive)
				startAtPosition += box.data('detachedOptions').length;

			var data = {
				filterDisplayId: filterDisplayId,
				startAt: startAtPosition,
				filterText: box.multiselect("widget").find(".ui-multiselect-filter input").val() || "",
				selectedIds: [],
				forceAll: checkAll ? checkAll : false,
				admin: Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview() && box.attr("id").indexOf("ddlDefaultSelection") > -1,
				dfRequest: dynFilterRequest,
				loadedFilterIds: dynFilterRequest ? Storyboard.GeneralSettings.getLoadedFilterOptionIds(filterDisplayId) : []
			};
			Helpers.perfJSonCall({
				method: "LoadFilterOptions",
				data: data,
				successCallback: function (extraOptions) {
					if (dynFilterRequest)
						Storyboard.GeneralSettings.addExtraOptionsToLoadedOptions(extraOptions);

					if (extraOptions.length > 0) {
						var selectedOpts = box.multiselect("getChecked").map(function () { return this.value; }).get();
						Storyboard.GeneralSettings.singleBoxes(extraOptions, box, filterDisplayId == "0", null, null, null, !!dynFilterRequest);
						box.hide();

						$(selectedOpts).each(function () {
							setDefaultSelected(box, this);
						});

						if (~selectedOpts.indexOf('0-2'))
							GeneralSettingsAdmin.checkAllAndFuture(box);

						box.multiselect("refresh");
					}

					if (extraOptions.length > 0)
						Storyboard.DynamicFiltering.applyPreviousNoDataSelections(box);

					if (callback)
						callback();

					if (checkAll) {
						$(box).multiselect("widget").find(":checkbox[value='" + Storyboard.GeneralSettings.NO_SELECTION_ID + "']").attr("checked", false);
						$(box).find("option[value='" + Storyboard.GeneralSettings.NO_SELECTION_ID + "']").attr("selected", false);
						$(box).multiselect("update");
					}
					
					GeneralSettings.getFiltersConnectedToHFilters();
					GeneralSettings.bindLazyLoadScroll(box);
				},
				service: "GeneralSettings"
			});
		} else if (callback)
			callback();
	},
	filterOptions: function (box) {
		var useServerSideFilter = box.find("option[value!='" + Storyboard.GeneralSettings.NO_SELECTION_ID + "']").length < box.attr("totalOptions");
		var filterDisplayId;

		if (useServerSideFilter) {
			var selectedOpts = box.multiselect("getChecked").map(function () { return this.value; }).get();
			var splitBoxId = box.attr("id").split('_');
			filterDisplayId = splitBoxId.length > 2 ? splitBoxId[2] : "0";

			var dynFilterRequest = null;
			if (Storyboard.DynamicFiltering.isEnabled() && box.closest(".SettingsControl").hasClass("dynamicFiltering") &&
				box.closest(".dynamicFiltering").data("dynamicFiltering") === Storyboard.Constants.DynamicFilteringStatus.OnHideOptionsWithNoData)
				dynFilterRequest = Storyboard.DynamicFiltering.getUserSelectedSettings();

			var data = {
				filterDisplayId: filterDisplayId,
				startAt: 0,
				filterText: box.multiselect("widget").find(".ui-multiselect-filter input").val(),
				selectedIds: selectedOpts,
				forceAll: false,
				admin: false,
				dfRequest: dynFilterRequest,
				loadedFilterIds: dynFilterRequest ?  Storyboard.GeneralSettings.getLoadedFilterOptionIds(filterDisplayId) : []
			};

			Helpers.perfJSonCall({
				method: "LoadFilterOptions",
				data: data,
				successCallback: function (options) {
					if (dynFilterRequest)
						Storyboard.GeneralSettings.addExtraOptionsToLoadedOptions(options);

					var hasNoSelection = box.find("option[value='" + Storyboard.GeneralSettings.NO_SELECTION_ID + "']").length > 0;
					document.getElementById(box.attr("id")).innerHTML = "";

					Storyboard.GeneralSettings.singleBoxes(options, box, filterDisplayId == "0", hasNoSelection, null, null, !!dynFilterRequest);
					box.hide();

					$(selectedOpts).each(function () {
						setDefaultSelected(box, this);
					});

					box.multiselect("refresh");

					if (options.length > 0) 
						Storyboard.DynamicFiltering.applyPreviousNoDataSelections(box);
				},
				service: "GeneralSettings"
			});
		} else {
			box.multiselectfilter("filter");
		}
	},
	unbindLazyLoadScroll: function (box) {
		box.multiselect("widget").find(".ui-multiselect-checkboxes").unbind("scroll");
	},
	bindLazyLoadScroll: function (box) {
		if (box.find("option[value!='" + Storyboard.GeneralSettings.NO_SELECTION_ID + "']").length >= box.attr("totalOptions"))
			return;
		if (Storyboard.GeneralSettings.hfilterVsFiltersActive && box.find("option[value!='" + Storyboard.GeneralSettings.NO_SELECTION_ID + "']").length >= box.attr("totalFilteredOptions"))
			return;
		box.multiselect("widget").find(".ui-multiselect-checkboxes").unbind("scroll").bind("scroll", function () {
			GeneralSettings.loadOptions(box);
		});
	},
	bindLazyLoadFilter: function (box) {
		box.multiselect("widget").find(".ui-multiselect-filter input").unbind("keyup").bind("keyup", function () {
			GeneralSettings.filterOptions(box);
		});
	},
	bindLazyLoadOpen: function (box) {
		box.bind("multiselectopen", function (event, ui) {
			if (box.closest(".SettingsControl").hasClass("dynamicFiltering") &&
				box.find("option[value!='" + Storyboard.GeneralSettings.NO_SELECTION_ID + "']").length < box.attr("totalOptions") && box.find("option:not([hidden]):not([disabled])").length < 7)
				GeneralSettings.loadOptions(box);
			else if (box.find("option[value^='0']").length == box.find("option").length && box.attr("totalOptions") > 0)
				GeneralSettings.loadOptions(box);
		});
	},
	validateMinMaxSelections: function ($this, numSel) {
		let hfilterTreeId = $this.attr('id')
		let isFromHfilter = hfilterTreeId === 'hfilterTree' || hfilterTreeId === 'downloadTreePowerpoint';
		const selectionRange = isFromHfilter ? $('#hfilterTree').data().optionSelectionRange : $this.closest('.SettingsControl').data().optionSelectionRange;

		if (selectionRange) {
			const noOfSelection = numSel || (isFromHfilter ? (Storyboard.HFilterLayout.getSelectedIds("#" + hfilterTreeId) || []).length : ($this.val() || []).length);
			let controlName = isFromHfilter ? $('#hfilterTree').siblings('.hFilterName').text() : $this.siblings('#lblName').text();

			var showMessage = function() {
				if ((selectionRange.min != null && noOfSelection < selectionRange.min) || (selectionRange.max != null && noOfSelection > selectionRange.max)) {
					let message = '<span style="display:block"><span>' + controlName + ': </span><em>You must choose ';

					if (selectionRange.min === selectionRange.max)
						message += selectionRange.min + ' option' + (selectionRange.min > 1 ? 's' : '');
					else if (selectionRange.min != null && selectionRange.max != null)
						message += 'a minimum of ' + selectionRange.min + ' option' + (selectionRange.min > 1 ? 's' : '') + ' and a maximum of ' + selectionRange.max;
					else if (selectionRange.min != null)
						message += 'a minimum of ' + selectionRange.min + ' option' + (selectionRange.min > 1 ? 's' : '');
					else if (selectionRange.max != null)
						message += 'a maximum of ' + selectionRange.max + ' option' + (selectionRange.max > 1 ? 's' : '');

					message += '.</em></span>';

					Storyboard.LayoutControls.showMessage(message);
				}
			}

			let $validationControl = null;
			if (isFromHfilter) {
				if (hfilterTreeId === 'downloadTreePowerpoint') {
					$validationControl = $('#downloadTreePowerpoint').children('button');
					if (!$validationControl.length)
						$validationControl = $('#downloadTreePowerpoint').children('select');
				} else
					$validationControl = $this.children('button');
            } else
				$validationControl = isFromHfilter ? $this.children('button') : $this.siblings('button');

			let isInvalid = (selectionRange.min != null && noOfSelection < selectionRange.min) || (selectionRange.max != null && noOfSelection > selectionRange.max);
			$validationControl.css('border-color', isInvalid ? 'red' : '');

			if (isInvalid)
				showMessage();
		}
    },
	addMultiselection: function (isExportPanel = false) {
		var noSelectionId = Storyboard.GeneralSettings.NO_SELECTION_ID;
		var multiSelElems = isExportPanel ? $("#exportRegularFilters #regularFiltersPowerpoint select") : $("#pnlSettingsPanel .SettingsControl select");
		multiSelElems.each(function () {
			var isMulti = isExportPanel ? true : $(this).attr("multiple");
			var isLazyLoad = $(this).attr("isLazyLoad");
			var multiSelectBox = this;
			var renderOnDemand = false;

            // project uses filters lazy render and this dropdown is a filter
            var boxId = $(multiSelectBox).attr("id");
			if (Storyboard.GeneralSettings.filterLazyRenderCount > 0 && boxId.indexOf("lbSetting_5") >= 0) {
                renderOnDemand = true;

				// render on demand can be disabled per filter via CC
				if (typeof (filtersToExcludeFromLazyRender) != 'undefined' && filtersToExcludeFromLazyRender.constructor === Array) {
					var filterId = 0; // 0 is for lbSetting_5, when filters are not split
					if (boxId.split('_').length > 2)
						filterId = parseInt(boxId.split('_')[2], 10);

					if ($.inArray(filterId, filtersToExcludeFromLazyRender) != -1) {
						renderOnDemand = false;
					}
				}
			}

			var options = {
				multiple: isMulti,
				selectedList: 3,
				classes: 'Theme-multiselect',
				renderOnDemand: renderOnDemand,
				renderOnDemandStep: Storyboard.GeneralSettings.filterLazyRenderCount
			};

			if (isLazyLoad)
				options.beforeCheckAll = function (callback) {
					GeneralSettings.loadOptions($(multiSelectBox), true, callback);
				};

			$(multiSelectBox)
				.multiselect(options)
				.multiselectfilter();

			if (isLazyLoad) {
				GeneralSettings.bindLazyLoadFilter($(multiSelectBox));
				GeneralSettings.bindLazyLoadScroll($(multiSelectBox));
				if (Storyboard.DynamicFiltering.isEnabled() && $(multiSelectBox).closest(".SettingsControl").hasClass("dynamicFiltering") &&
					$(multiSelectBox).closest(".dynamicFiltering").data("dynamicFiltering") === Storyboard.Constants.DynamicFilteringStatus.OnHideOptionsWithNoData)
					GeneralSettings.bindLazyLoadOpen($(multiSelectBox));
			}

			$(multiSelectBox)
				.bind("multiselectclick", function (event, ui) {
					if (ui.checked) {
						if (ui.value !== noSelectionId) {
							$(this).multiselect("widget").find(":checkbox[value='" + noSelectionId + "']").attr("checked", false);
							$(this).find("option[value='" + noSelectionId + "']").attr("selected", false);
						}
						else {
							$(this).multiselect("widget").find(":checkbox[value!='" + noSelectionId + "']").attr("checked", false);
							$(this).find("option[value!='" + noSelectionId + "']").attr("selected", false);
						}
					}

					if(!ui.checked && !$(this).multiselect('getChecked').length){
						// check "No Selection"
						$(this).multiselect("widget").find(":checkbox[value='" + noSelectionId + "']").attr("checked", true);
						$(this).find("option[value='" + noSelectionId + "']").attr("selected", true);
						$(this).multiselect("update");
					}

					if($(this).multiselect('getChecked').length){
						Storyboard.LayoutDesigner.invokeDynamicFiltering($(this).closest(".SettingsControl.dynamicFiltering"));
						if (boxId.indexOf("lbSetting_5") >= 0)
							Storyboard.ReferenceDataFiltering.showHideRefDataSets();
					}

				})
                .bind("multiselectcheckall", function () {
                    // uncheck "No Selection"
                    $(this).multiselect("widget").find(":checkbox[value='" + noSelectionId + "']").attr("checked", false);
                    $(this).find("option[value='" + noSelectionId + "']").attr("selected", false);
                    $(this).multiselect("update");
					Storyboard.LayoutDesigner.invokeDynamicFiltering($(this).closest(".SettingsControl.dynamicFiltering"));
					if (boxId.indexOf("lbSetting_5") >= 0)
						Storyboard.ReferenceDataFiltering.showHideRefDataSets();

					// TODO check min/max selections
                })
                .bind("multiselectuncheckall", function () {
                    // check "No Selection"
                    $(this).multiselect("widget").find(":checkbox[value='" + noSelectionId + "']").attr("checked", true);
                    $(this).find("option[value='" + noSelectionId + "']").attr("selected", true);
                    $(this).multiselect("update");
					Storyboard.LayoutDesigner.invokeDynamicFiltering($(this).closest(".SettingsControl.dynamicFiltering"));
					if (boxId.indexOf("lbSetting_5") >= 0)
						Storyboard.ReferenceDataFiltering.showHideRefDataSets();

					// TODO check min/max selections
				})
        });
	},
    hideHFilterPanel: function (showHFilter) {
        $("#hfilterContainer").css("display", showHFilter ? "block" : "none");
        $(".downloadcontainer [id^=downloadTree]").parent().css("display", showHFilter ? "block" : "none");
        $("#fsHFilters").css("display", showHFilter ? "block" : "none");

		if (!showHFilter && window.ContentType && window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
			$(".hierarhicalfilter", "#questionList_ct, #groupingTable_ct, #filtersList_ct, #filtersSelected_ct").remove();
			CrossTable2UI.deselectHierarhicalSplit();
			CrossTable2UI.deselectHierarhicalFilter();
		}

		if (window.ContentType && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
			ChartCreatorUI.setupHierarhicalFilterControl();
		}
	},
	loadHFilter: function (hFilterLayout, hfilters, isReset) {
		var mainTree = '#hfilterTree';
		var url = 'RHViewStoryboard.aspx/GetHFilters';
		if (isReset) url = 'RHViewStoryboard.aspx/GetHFiltersWithDefaultSelections';
		var urlForList = 'RHViewStoryboard.aspx/GetHFiltersForList';

		if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLIST)
			$(mainTree).hFilterControl("dropdown", urlForList, false, hfilters);
		else if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERMULTIBOX)
			$(mainTree).hFilterControl("multiBoxes", url, false, hfilters);
		else if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLISTPERLEVEL)
			$(mainTree).hFilterControl("multiDropdowns", url, false, hfilters);
		else if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERTREE)
			$(mainTree).hFilterControl("tree", url, false, hfilters);
		else
			$(mainTree).hFilterControl("dropdown", urlForList, true, hfilters);
	},
	reloadHFilter: function (hFilterLayout, hFilterSelectionMode, hFilterConnectionsLoaded, hfilters, useCheckAllTree) {
		var hfilterDef = $.Deferred();
		var varSubsetPromise;
		var filterConnectionsPromise;
		if (Storyboard.HFilterLayout.hasHFilterNodes()) {
			var options = {
				multi: hFilterSelectionMode === Storyboard.Constants.HFilterSelectionModes.MULTIPLE,
				advanced: hFilterSelectionMode === Storyboard.Constants.HFilterSelectionModes.ADVANCED,
				levels: Storyboard.GeneralSettings.getHFilterLevels(),
				useCheckAllTree: useCheckAllTree
			};

			if (!hFilterLayout || hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLIST)
				Storyboard.HFilterLayout.render('hfilterTree', "dropdown", options, hfilters);
			else if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERMULTIBOX)
				Storyboard.HFilterLayout.render('hfilterTree', "multiBoxes", options, hfilters);
			else if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLISTPERLEVEL)
				Storyboard.HFilterLayout.render('hfilterTree', "multiDropdowns", options, hfilters);
			else if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERTREE)
				Storyboard.HFilterLayout.render('hfilterTree', "tree", options, hfilters);

			// new code
			if (hFilterLayout) {
				var hf;
				if (hFilterLayout.hasOwnProperty('HFilterLayout'))
					hf = hFilterLayout.HFilterLayout;
				else
					hf = hFilterLayout;

				if (!hFilterConnectionsLoaded) {
					varSubsetPromise = GeneralSettings.fillVariableSubsetList();
					filterConnectionsPromise = GeneralSettings.getFiltersConnectedToHFilters();
				}

				if (hf === Storyboard.Constants.HFilterLayouts.HFILTERLIST)
					$("#hfilterTree select").bind("multiselectclick", function () {
						GeneralSettings.fillVariableSubsetList();
						GeneralSettings.getFiltersConnectedToHFilters();
					});
				else if (hf === Storyboard.Constants.HFilterLayouts.HFILTERTREE) {
					$('.DUITreeView').find('input[type="radio"]').bind('change', function () {
						GeneralSettings.fillVariableSubsetList();
						GeneralSettings.getFiltersConnectedToHFilters();
					});
					$('.DUITreeView').find('input[type="checkbox"]').bind('change', function () {
						GeneralSettings.fillVariableSubsetList();
						GeneralSettings.getFiltersConnectedToHFilters();
					});
				} // 'per level' layouts fill variable subsets from HFilterTree.js
			}
		}

		// resolve hfilterDef only when all inner work of this method is done
		$.when(varSubsetPromise, filterConnectionsPromise).then(function () { hfilterDef.resolve(); });

		return hfilterDef;
	},
	bindProjectLanguages: function (projectLanguages) {
		if (projectLanguages.length > 1) {
			if (!window.IsFormReport)
				$("#languageContainer").css({ 'display': 'block' });
			else
				$("#languageContainer").css({ 'display': 'inline-block' });

			$("#ddlLng").children().remove();
			$.each(projectLanguages, function () {
				$("#ddlLng").append($('<option>', { value: this.languageId, text: this.languageName, selected: this.isUilanguage }));
			});
			$("#ddlLng").multiselect({ multiple: false, selectedList: 1, classes: 'Theme-multiselect' });
		}
		else {
			$("#languageContainer").css({ 'display': 'none' });
		}
		$("#languageContainer").find("#languageText").text(locale.get("Language", 0));
		if (!window.IsFormReport)
			Storyboard.LayoutControls.showUpdateButton();
	},
	bindProjectLanguagesNew: function (projectLanguages) {
		if (projectLanguages.length > 1) {
			$("#ddlLng").children().remove();
			$.each(projectLanguages, function () {
				$("#ddlLng").append($('<option>', { value: this.languageId, text: this.languageName, selected: this.isUilanguage }));
			});

			if ($('#languageSelection').length > 0) {
				$('#languageSelection').append($("#ddlLng"));
				$("#languageSelection").find('> h4').text(locale.get("Select Language", 0));
				$("#lnkLanguageSelection").css('display', '').text(locale.get("Language", 0));
			} else {
				$("#languageContainer").css({ 'display': window.IsFormReport ? 'inline-block' : 'block' });
				$("#languageContainer").find("#languageText").text(locale.get("Language", 0));
				$("#ddlLng").multiselect({ multiple: false, selectedList: 1 });
			}
		}
		else {
			$("#languageContainer, #lnkLanguageSelection").css({ 'display': 'none' });
		}
		if (!window.IsFormReport)
			Storyboard.LayoutControls.showUpdateButton();
	},
	bindVariableSubsets: function (subsets) {
		var lb = $('#lbSetting_1');

		const parentNode = lb[0].parentNode;
		if (subsets.length <= 0 && !Storyboard.GeneralSettings.conditionalVisibilityForFilters)
			parentNode.style.display = "none";
		else{
			parentNode.style.display = "block";
			parentNode.style.height = "45px";
		}
			$.each(subsets, function (i, object) {
				var exists = false;
				$('#lbSetting_1 option').each(function () {
					if (this.value == object.TemplateID) {
						exists = true;
						return false;
					}
				});

				if (!exists) {
					lb.append($('<option>', { value: object.TemplateID, text: object.TemplateName, selected: object.Selected }));
				}
			});

			if (lb.find('option:selected').length === 0) {
				lb.val(lb.find('option').first().val());
			}

			if (lb.find('option').length === 0 ||
				lb.find('option:first-child:last-child').val() === Storyboard.GeneralSettings.NO_SELECTION_ID) {
				lb.parent().addClass('NoOptionsFilter');
				lb.multiselect("disable");
			} else {
				lb.parent().removeClass('NoOptionsFilter');
				lb.multiselect("enable");
			}

			lb.multiselect("refresh");

			lb.unbind("multiselectclick").bind("multiselectclick", function (event, ui) {
				if (typeof (variableSubsetSelectedNum) != 'undefined' && variableSubsetSelectedNum > 0) {
					var checkedList = lb.multiselect("getChecked").map(function () { return this.value; }).get();
					// don't let select more than allowed
					if (ui.checked && checkedList.length > variableSubsetSelectedNum) {
						alert("A maximum of " + variableSubsetSelectedNum + " options can be selected.");
						checkedList = jQuery.grep(checkedList, function (v) { return v != ui.value; });
						$('#lbSetting_1 option').removeAttr("selected");
						for (var i = 0; i < checkedList.length; i++)
							$('#lbSetting_1 option[value="' + checkedList[i] + '"]').attr("selected", "selected");
						lb.multiselect("refresh");
					}
				}
			});
			lb.unbind("multiselectbeforeclose").bind("multiselectbeforeclose", function () {
				if (typeof (variableSubsetSelectedNum) != 'undefined' && variableSubsetSelectedNum > 0) {
					var checkedList = lb.multiselect("getChecked").map(function () { return this.value; }).get();
					if (checkedList.length != variableSubsetSelectedNum) {
						alert(variableSubsetSelectedNum + " options should be selected.");
						return false;
					}
				}
			});
	},
	fillVariableSubsetList: function (callback) {
		if (!Storyboard.GeneralSettings.hfilterVsVarSubsetActive || $('#lbSetting_1').length < 1 || $("#hfilterContainer").css("display") === "none") {
			if (callback) callback();
			return;
		}

		var lb = $('#lbSetting_1');
		if (lb !== undefined && Storyboard !== undefined && Storyboard.HFilterLayout !== undefined) {
			var selectedIds = Storyboard.HFilterLayout.getSelectedIds("#hfilterTree");

			lb.empty();
			lb.multiselect("refresh");

			return Helpers.perfJSonCall({
				method: "getAvailableVariableSubsets",
				message: locale.get("Loading variable subsets"),
				data: { hfilterIds: selectedIds },
				successCallback: function (results) {
					GeneralSettings.bindVariableSubsets(results);
					if (callback) callback(results);
					$.event.trigger({ type: "varSubsetCallbackFinished" });
				}
			});
		}
	},
	getFiltersConnectedToHFilters: function (callback, isExportPanel = false) {
		if (!Storyboard.GeneralSettings.hfilterVsFiltersActive || isExportPanel ? $('#regularFiltersPowerpoint [id^="exportlbSetting_5_"]').length < 1
				: $('#pnlSettingsPanel [id^="lbSetting_5_"]').length < 1 || $("#hfilterContainer").css("display") === "none") {
			if (callback) callback();
			return;
		}

		var lb = isExportPanel ? $('#regularFiltersPowerpoint [id^="exportlbSetting_5_"]') : $('#pnlSettingsPanel [id^="lbSetting_5_"]');
		if (lb !== undefined && Storyboard !== undefined && Storyboard.HFilterLayout !== undefined) {
			var selectedIds = isExportPanel ? Storyboard.HFilterLayout.getSelectedIds("#downloadTreePowerpoint") : Storyboard.HFilterLayout.getSelectedIds("#hfilterTree");

			return Helpers.perfJSonCall({
				method: "getFiltersConnectedToHFilters",
				message: locale.get("Loading variable subsets"),
				data: { hfilterIds: selectedIds },
				successCallback: function (results) {
					GeneralSettings.bindFiltersConnectedToHFilters(results, isExportPanel);
					if (callback) callback(results);
					$.event.trigger({ type: "filtersVsHFilterCallbackFinished" });
				}
			});
		}
	},
	bindFiltersConnectedToHFilters: function(data, isExportPanel = false) {
		data.forEach(function (filter) {
			var filterSelectEl = isExportPanel ? $('#regularFiltersPowerpoint #exportlbSetting_5_' + filter.FilterId): $('#pnlSettingsPanel #lbSetting_5_'+ filter.FilterId);
			var parentNode = filterSelectEl[0].parentNode;
			var hiddenFilter = parentNode.classList.contains("HideFilterOption");
			if (filter.Answers.length <= 0 && !Storyboard.GeneralSettings.conditionalVisibilityForFilters)
				parentNode.style.display = "none";
			else if (!hiddenFilter){
				parentNode.style.display = "block";
				parentNode.style.height = "45px";
			}
				var detachedOptions = [];
				var defaultAnswerIDs = [];
				var answerIDs = filter.Answers.map(function(answer) {
					var isDefault = Boolean(answer.split('-')[1] === '1');
					var answerID = Number(answer.split('-')[0]);

					if (isDefault) defaultAnswerIDs.push(answerID);

					return answerID;
				});

				if (filterSelectEl) {
					detachedOptions = filterSelectEl.data('detachedOptions');

					if (detachedOptions) {
						filterSelectEl.append(detachedOptions);
					}

					detachedOptions = filterSelectEl.find('option')
						.filter(function() {
							var answerValue = $(this).val();
							var answerID = Number(answerValue.split('-')[1]);

							return !answerIDs.includes(answerID);
						}).each(function() {
							this.selected = false;
						});

					var options = filterSelectEl.find('option');
					filterSelectEl.attr('totalFilteredOptions', answerIDs.length.toString());
					options.detach().sort(function(a,b) {
						var at = Number($(a).attr('data-order')) || 0;
						var bt = Number($(b).attr('data-order')) || 0;
						return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
					});
					options.appendTo(filterSelectEl);

					filterSelectEl.data('detachedOptions', detachedOptions.detach());
				}

				if (defaultAnswerIDs.length > 0) {
					var filterSelectValues = defaultAnswerIDs
						.sort()
						.map(function(answerID) {
							return filter.FilterId + '-' + answerID;
						});
					if (filterSelectEl.attr('multiple')) {
						filterSelectEl.val(filterSelectValues);
					} else {
						filterSelectEl.val(filterSelectValues[0]);
					}
				}

				if (filterSelectEl.find('option:selected').length === 0) {
					filterSelectEl.val(filterSelectEl.find('option').first().val());
				}

				if (filterSelectEl.find('option').length === 0 ||
					filterSelectEl.find('option:first-child:last-child').val() === Storyboard.GeneralSettings.NO_SELECTION_ID) {
					filterSelectEl.attr('disabled', true).parent().addClass('NoOptionsFilter');
					filterSelectEl.multiselect("disable");
				} else {
					filterSelectEl.removeAttr('disabled').parent().removeClass('NoOptionsFilter');
					if (isExportPanel && filterSelectEl.parent().find("#chkSelectFilterForIterate").is(':checked'))
						filterSelectEl.multiselect("enable");
					else if (!isExportPanel)
						filterSelectEl.multiselect("enable");						
			}
			
			filterSelectEl.multiselect("refresh");
		});
	}
};

window.selectHFilterButtons = function (checked, displayID) {
	if (checked) {
		var hfilter;
		for (var i = 0; i < Storyboard.GeneralSettings.hFiltersAdmin.length; i++) {
			if (Storyboard.GeneralSettings.hFiltersAdmin[i].DisplayID == displayID) {
				hfilter = Storyboard.GeneralSettings.hFiltersAdmin[i];
				break;
			}
		}

		$('.DUITreeViewInlineMenuCheckSiblings').toggleClass('DUITreeViewMIChecked', hfilter.AlwaysShowSiblings);
		$('.DUITreeViewInlineMenuCheckChildnodes').toggleClass('DUITreeViewMIChecked', hfilter.AlwaysShowLevelBelow);
		$('.DUITreeViewInlineMenuCheckAncestors').toggleClass('DUITreeViewMIChecked', hfilter.AlwaysShowParents);
		$('.DUITreeViewInlineMenuCheckDescendants').toggleClass('DUITreeViewMIChecked', hfilter.AlwaysShowChildren);
	}
}

window.setDefaultSelected = function (comp, defaultID) {
	var defaultComp = comp.find("option[value='" + defaultID + "']");
	if (defaultComp.length == 0)
		comp.find("option").first().attr("selected", true);
	else
		defaultComp.attr("selected", true);
};

(function (sb) {
	sb.GeneralSettings = (sb.GeneralSettings || {});
	var generalSettings;
	var generalSettingsAdmin;
	var hFilterLayoutAdmin;
	var hFilterSelectionModeAdmin;
	var FLOATING_TIME_PERIODS_SETTING = 3;
	var FILTER_SETTING = 5;
	var HFILTER_SETTING = 6;
	var VARIABLE_SUBSET_SETTING = 1;
	var INTERVAL_SETTING = 2;
	var NO_SELECTION_ID = "0-0";
	var hFilterList = [];
	var hfLevelSettings = [];
	var hFilterSlideExclusions = [];
	var hFilterSlideExclusionsUnsaved = false;
	var favoriteSettings = [];
	var favSettingsRestoreInProgress = false;
	var filterNoSelectionLabel = '';
	var filterTranslatedControls = ["Day(s)", "Week(s)", "Month(s)", "Month(s)", "Quarter(s)", "Half year", "Year(s)", "Full period", "Year-to-Date", "Last", "Calendar control...", "Day selection", "Week selection", "Month selection", "Quarter selection", "Year selection"];
	var storyBoardAccess = { ExportPPT: true, ExportExcel: true, HeatMap: false, MyStories: false };
	var hfilterVsVarSubsetActive = false;
	var hfilterVsFiltersActive = false;
	var filterLazyRenderCount = 0;
	var storeSingleObjectExports = false;
	var respondentBlockCheckInterval = 0;
	var collaborationVersionCheckInterval;
	var _loadedFilterOptions = Object.create(null);
	var refDataSettingsAdmin;
	var drilldownSettingsGuid;
	var preparedTimePeriods;
	var listOfReportsToInheritFrom = {}
	var conditionalVisibilityForFilters = false;
	sb.GeneralSettings.prepPeriodItemsLoading = false;

	function getGeneralSettings() {
		return Object.freeze(generalSettings);
	}

	function getFilterSelectionFromCookies(displayId) {
		var selection = Helpers.readCookie('lbSetting_5_' + displayId) || Helpers.readCookie('lbSetting_5');

		if (selection != null) {
			selection = selection.split(',');

			var regex = new RegExp("^" + displayId);
			selection = $.grep(selection, function(s) { return s.match(regex); });
		}

		return selection;
	}

	function setSelectionsFromCookie(ddl, cookieName, deleteCookie, settingDisplayId) {
		if (ddl.length && $.cookie(cookieName)) {
			var strSelection = $.cookie(cookieName);

			// update No selection value from cookie
			if (typeof settingDisplayId !== 'undefined')
				strSelection = strSelection.replace('"0-0",', '').replace(',"0-0"', '').replace('"0-0"', '').replace(settingDisplayId + '-0', '0-0');

			var selections = JSON.parse(strSelection);

			if (cookieName === 'SBLinkOptionalFilters' && selections != null && selections.length > 0 && selections[0] === '0-1') {
				ddl.find('option:last').attr('selected', 'selected');
			} else {
				// Update ddl selections from cookie only if ddl contains any of selections from cookie
				ddl.children('option').each(function () {
					if (selections.indexOf($(this).val()) !== -1) {
						ddl.val(selections);
						return false;
					}
				});
			}

			if(deleteCookie)
				$.cookie(cookieName, null);
		}
	}

	function storeInitialOptionsForDynamicFiltering(settings) {
		_loadedFilterOptions = Object.create(null);
		var filters = settings.filter(function (filter) { return filter.SettingType == 5 });

		if (filters && filters.length) {
			filters = filters[0];

			for (var i = 0; i < filters.SettingItems.length; i++) {
				var filter = filters.SettingItems[i];
				for (var j = 0; j < filter.SubItems.length; j++) {
					if (!_loadedFilterOptions[filter.SubItems[j].DisplayID])
						_loadedFilterOptions[filter.SubItems[j].DisplayID] = true;
				}
			}
		}
	}
	
	function getLoadedFilterOptionIds(filterDisplayId){
		var result = [];
		for( var prop in _loadedFilterOptions) {
			if(prop.startsWith(filterDisplayId+"-"))
				result.push(prop);
		}

		return result;
	}

	function addExtraOptionsToLoadedOptions(extraOptions){
		extraOptions.forEach(function (opt) {
			if (!_loadedFilterOptions[opt.DisplayID])
				_loadedFilterOptions[opt.DisplayID] = true;
		})
	}

	function bindGeneralSettings(gs, hFilterLayout, hfLSettings, hfilters, isReset) {
		if (gs)
			generalSettings = gs;

		if (window.ContentType > 0 && window.ContentType == Storyboard.Constants.itemTypes.CHART) {
			DeckFilters.bindSettings(generalSettings);
		}

        storeInitialOptionsForDynamicFiltering(generalSettings);

		if (hfLSettings)
			hfLevelSettings = hfLSettings;

		var rankItems = [];

		$("#pnlSettingsPanel .SettingsControl").remove();

		var filterSetting;
		var isMultiSelectFilter;
		var hasHfilter = false;
		var restoreSelections;
		var selections;
		for (var setting in generalSettings)
			if (generalSettings.hasOwnProperty(setting)) {

				var storyboardSetting = generalSettings[setting];
				var settingTypes = sb.Constants.SettingTypes;

				if (storyboardSetting.SettingType === settingTypes.HFilter) {
					hasHfilter = true;
					sb.GeneralSettings.hFilters = storyboardSetting.SettingItems;
					GeneralSettings.hideHFilterPanel(storyboardSetting.ShowSetting);

					if (storyboardSetting.ShowSetting) {
						GeneralSettings.loadHFilter(hFilterLayout, hfilters, isReset);

						let $hfilterTree = $('#hfilterTree');
						if ((hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLIST
							|| hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERTREE)
							&& (Storyboard.LayoutDesigner.getHFilterSelectionMode() === Storyboard.Constants.HFilterSelectionModes.MULTIPLE)
							&& hasSelectionRange(storyboardSetting)) {
							const minSel = storyboardSetting.MinNoOfSelections;
							const maxSel = storyboardSetting.MaxNoOfSelections

							$hfilterTree.addClass('hasOptionSelectionRange');
							$hfilterTree.data('optionSelectionRange', {
								min: minSel,
								max: maxSel
							})
						} else {
							$hfilterTree.removeClass('hasOptionSelectionRange');
							$hfilterTree.removeData('optionSelectionRange');
						}
                    }

					if (Storyboard.LayoutDesigner.hideHFilterLayout)
						Storyboard.LayoutDesigner.hideHFilterLayout(storyboardSetting.ShowSetting || storyboardSetting.SettingItems.length > 0);

					rankItems.push({ value: "0", text: HTMLHelpers.htmlEncode(storyboardSetting.Name) });
				} else if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
					continue;

				if (!storyboardSetting.ShowSetting || storyboardSetting.SettingType === 6)
					continue;

				var settingControl = $(".SettingsControlTemplate").clone();

				settingControl.removeClass("SettingsControlTemplate");
				settingControl.find("#lblName").text(storyboardSetting.Name);
				settingControl.find("#hidSettingType").val(storyboardSetting.SettingType);
				
				settingControl.addClass((storyboardSetting.DynamicFiltering !== sb.Constants.DynamicFilteringStatus.Off) ? "dynamicFiltering" : "")
				settingControl.data('dynamicFiltering',storyboardSetting.DynamicFiltering);
				settingControl.data("dynamicFilteringMoveDisabledToBottom", storyboardSetting.DynamicFilteringMoveDisabledToBottom);
			

				$("#pnlSettingsPanel").find("#languageContainer").before(settingControl);

				bindSettingsItems(settingControl, storyboardSetting);

				if (storyboardSetting.SettingType === settingTypes.VariableSubset) {
					let $lb = $('#lbSetting_1');
					setSelectionsFromCookie($lb, 'SBLinkVariableSubsets', true);
					rankItems.push({
						value: "varsubset",
						text: HTMLHelpers.htmlEncode(storyboardSetting.Name)
					});

					settingControl.removeClass('hasOptionSelectionRange');
					if (hasSelectionRange(storyboardSetting)) {
						const minSel = storyboardSetting.MinNoOfSelections;
						const maxSel = storyboardSetting.MaxNoOfSelections

						settingControl.addClass('hasOptionSelectionRange');
						settingControl.data('optionSelectionRange', {
							min: minSel,
							max: maxSel
						})

						let selOpts = $lb.val() || [];

						if (storyboardSetting.MinNoOfSelections != null && selOpts.length < storyboardSetting.MinNoOfSelections) {
							$lb.find('option').each(function () {
								if (storyboardSetting.MinNoOfSelections == selOpts.length)
									return false;

								const optVal = $(this).val();
								if (!selOpts.includes(optVal))
									selOpts.push(optVal);
							});

							$lb.val(selOpts);
						} else if (storyboardSetting.MaxNoOfSelections != null && selOpts.length > storyboardSetting.MaxNoOfSelections) {
							$lb.val(selOpts.slice(0, storyboardSetting.MaxNoOfSelections));
						}
					}
				}
                else if (storyboardSetting.SettingType === settingTypes.Interval)
                    setSelectionsFromCookie($('#lbSetting_2'), 'SBLinkIntervals', true);
                else if (storyboardSetting.SettingType === settingTypes.TimePeriod){
                    if (storyboardSetting.AllowDateVariables) {
                        var dateVariablesSettingControl = $(".SettingsControlTemplate").clone();
                        dateVariablesSettingControl.removeClass("SettingsControlTemplate");
                        dateVariablesSettingControl.find("#lblName").text(storyboardSetting.DateVariablesName || locale.get('Date variable'));
                        $("#pnlSettingsPanel").find("#languageContainer").before(dateVariablesSettingControl);
                        bindDateVariableSettingsItems(dateVariablesSettingControl, storyboardSetting);
                        if (storyboardSetting.DynamicFiltering !== 0)
                            dateVariablesSettingControl.find("select").bind('change', function (evt) {
                                Storyboard.LayoutDesigner.invokeDynamicFiltering($(evt.target).closest(".SettingsControl").prev());
                            });
                    }

                    setSelectionsFromCookie($('#lbSetting_3'), 'SBLinkTimePeriods', true);
                    $('#lbSetting_3').trigger('change');
				}
				else if (storyboardSetting.SettingType === settingTypes.RefDataFilter) {
					Storyboard.ReferenceDataFiltering.setAvailableRefDataSetsType(storyboardSetting.AvailableRefDataSetsType);
				}
                else if (storyboardSetting.SettingType === settingTypes.MovingAverage)
                    setSelectionsFromCookie($('#lbSetting_4'), 'SBLinkMovingAverage', true);
                else if (storyboardSetting.SettingType === settingTypes.Filter) {
                    filterSetting = storyboardSetting;
					var lb;
					if (storyboardSetting.IsSplitBoxes) {
						isMultiSelectFilter = true;
                        // multiple filters
						for (var i = 0; i < storyboardSetting.SettingItems.length; i++) {
							let settingItem = storyboardSetting.SettingItems[i];
							let isMinMaxSelectionApplicable = () => settingItem.UseAsMultiSelect && !settingItem.HasNoSelection;

                            Storyboard.GeneralSettings.hfilterVsFiltersActive = Storyboard.GeneralSettings.hfilterVsFiltersActive || storyboardSetting.SettingItems[i].IsHFilterVsFilterActive;
							let $lb = $('#lbSetting_5_' + settingItem.DisplayID);
							$lb.find("option:selected").removeAttr("selected");
                            restoreSelections = (typeof (useStickyFilters) != 'undefined' && useStickyFilters) || (self != top && window.name == "print-frame");
                            selections = restoreSelections ?
								getFilterSelectionFromCookies(settingItem.DisplayID) : null;

							if (settingItem.AllowSeparateExport)
								$lb.attr("separateExport", "separateExport");
							if (selections != null && selections.length > 0) {
								if (isMinMaxSelectionApplicable) {
									if (settingItem.MinNoOfSelections != null && selections.length < settingItem.MinNoOfSelections) {
										$lb.find('option').each(function () {
											if (settingItem.MinNoOfSelections == selections.length)
												return false;

											let optVal = $(this).val();
											if (!selections.includes(optVal))
												selections.push(optVal);
										});
									} else if (settingItem.MaxNoOfSelections != null && selections.length > settingItem.MaxNoOfSelections) {
										$lb.val(selections.slice(0, settingItem.MaxNoOfSelections));
									} else
										$lb.val(selections);
								} else
									$lb.val(selections);
							} else if (settingItem.DefaultSelection !== null && settingItem.DefaultSelection !== undefined) {
								var selectedOptions = settingItem.DefaultSelection.split(',');

								let hasMultipleMinSelections = () => isMinMaxSelectionApplicable() && settingItem.MinNoOfSelections != null && settingItem.MinNoOfSelections > 1;

								if (hasMultipleMinSelections() && settingItem.DefaultSelection === '0-0')
									$lb.find('option').slice(0, settingItem.MinNoOfSelections).attr('selected', 'selected');
								else if (settingItem.DefaultSelection === '0-1')
									if (hasMultipleMinSelections())
										$lb.find('option').slice(-settingItem.MinNoOfSelections).attr('selected', 'selected');
									else
										$lb.find('option:last').attr('selected', 'selected');
								else if (settingItem.DefaultSelection === '0-2') {
									$lb.find('option').each(function (idx, elem) {
										if($(elem).val() != "0-0")
											$(elem).attr('selected', 'selected');
									})
								} else if (settingItem.UseAsMultiSelect) {
									if (isMinMaxSelectionApplicable()) {
										if (settingItem.MinNoOfSelections != null && selectedOptions.length < settingItem.MinNoOfSelections) {
											$lb.find('option').each(function () {
												if (settingItem.MinNoOfSelections == selectedOptions.length)
													return false;

												let optVal = $(this).val();
												if (!selectedOptions.includes(optVal))
													selectedOptions.push(optVal);
											});
											$lb.val(selectedOptions);
										} else if (settingItem.MaxNoOfSelections != null && selectedOptions.length > settingItem.MaxNoOfSelections) {
											$lb.val(selectedOptions.slice(0, settingItem.MaxNoOfSelections));
										} else
											$lb.val(selectedOptions);
									} else
										$lb.val(selectedOptions);

									if ($lb.find('option:selected').length == 0)
										$lb.find('option:first').attr('selected', 'selected');
								} else {
									$lb.val(selectedOptions[0]);
								}
							}

							rankItems.push({
								value: settingItem.DisplayID,
								text: HTMLHelpers.htmlEncode(settingItem.DisplayName) + " (Filter)"
							});
						}
					} else {
						// single filter
						isMultiSelectFilter = false;
						lb = $('#lbSetting_5');
						$(lb).find("option:selected").removeAttr("selected");
						for (let i = 0; i < storyboardSetting.SettingItems.length; i++) {
							restoreSelections = (typeof (useStickyFilters) != 'undefined' && useStickyFilters) || (self != top && window.name == "print-frame");
							selections = restoreSelections ?
								getFilterSelectionFromCookies(storyboardSetting.SettingItems[i].DisplayID) : null;
							if (selections != null) {
								if (storyboardSetting.IsMultiSelect) {
									if (!storyboardSetting.HasNoSelection && selections[0] === '0-0') {
										lb.find('option[value="' + storyboardSetting.SettingItems[i].SubItems[0].DisplayID + '"]').attr('selected', 'selected');
									}  
									else if (selections[0] === '0-1') 
										lb.find('option[value="' + storyboardSetting.SettingItems[i].SubItems.slice(-1)[0].DisplayID + '"]').attr('selected', 'selected');
									else (selections[0] !== '0-0')
										for (var si = 0; si < selections.length; si++) {
											lb.find('option[value="' + selections[si] + '"]').attr('selected', 'selected');
										}
									lb.multiselect('refresh');
								} else {
									if (selections[0] === '0-1')
										lb.find('option[value="' + storyboardSetting.SettingItems[i].SubItems.slice(-1)[0].DisplayID + '"]').attr('selected', 'selected');
									else
										lb.val(selections[0]);
									break;
							}
							}
							else if (storyboardSetting.SettingItems[i].DefaultSelection !== null && storyboardSetting.SettingItems[i].DefaultSelection !== undefined) {
								if (storyboardSetting.IsMultiSelect) {
									selectedOptions = storyboardSetting.SettingItems[i].DefaultSelection.split(',');
									if (!storyboardSetting.HasNoSelection && storyboardSetting.SettingItems[i].DefaultSelection === '0-0') {
											
											lb.find('option[value="' +storyboardSetting.SettingItems[i].SubItems[0].DisplayID + '"]').attr('selected', 'selected');
									}
									else if (storyboardSetting.SettingItems[i].DefaultSelection === '0-1')
										lb.find('option[value="' + storyboardSetting.SettingItems[i].SubItems.slice(-1)[0].DisplayID + '"]').attr('selected', 'selected');
									else if (storyboardSetting.SettingItems[i].DefaultSelection === '0-2') {
										storyboardSetting.SettingItems[i].SubItems.forEach(function(filterItem){
											lb.find('option[value="' + filterItem.DisplayID + '"]').attr('selected', 'selected');
										});
									}
									else if (storyboardSetting.SettingItems[i].DefaultSelection !== '0-0')
										for (var j = 0; j < selectedOptions.length; j++) {
											lb.find('option[value="' + selectedOptions[j] + '"]').attr('selected', 'selected');
										}
									lb.multiselect('refresh');
								}
								else if ((storyboardSetting.SettingItems[i].Attributes & Storyboard.Constants.Attributes.IsDefaultSelected) == Storyboard.Constants.Attributes.IsDefaultSelected) {
									selectedOptions = storyboardSetting.SettingItems[i].DefaultSelection.split(',');
									if (storyboardSetting.SettingItems[i].DefaultSelection === '0-1')
										lb.find('option[value="' + storyboardSetting.SettingItems[i].SubItems.slice(-1)[0].DisplayID + '"]').attr('selected', 'selected');
									else
										lb.val(storyboardSetting.SettingItems[i].UseAsMultiSelect ? selectedOptions : selectedOptions[0]);
							}
						}
						}
						if (lb.find('option:selected').length == 0) lb.find('option:first').attr('selected', 'selected');

						rankItems.push({
							value: "filter",
							text: HTMLHelpers.htmlEncode(storyboardSetting.Name)
						});
					}

					if ($.cookie('SBLinkOptionalFilters')) {
						if (storyboardSetting.IsSplitBoxes) {
							for (let i = 0; i < storyboardSetting.SettingItems.length; i++) {
								setSelectionsFromCookie($('#lbSetting_5_' + storyboardSetting.SettingItems[i].DisplayID), 'SBLinkOptionalFilters', (i === storyboardSetting.SettingItems.length - 1), storyboardSetting.SettingItems[i].DisplayID);
							}
						} else {
							setSelectionsFromCookie($('#lbSetting_5'), 'SBLinkOptionalFilters', true);
						}
					}
				} else if (self != top && window.name == "print-frame") { // restore selections in print preview
					var selectControlId = 'lbSetting_' + storyboardSetting.SettingType;
					var selection = Helpers.readCookie(selectControlId);
					if (selection != null) {
						lb = $('#' + selectControlId);
						$(lb).find("option:selected").removeAttr("selected");
						if (selection === '0-1')
							$(lb).find('option:last').attr('selected', 'selected');
						else
							lb.val(selection);
					}
				}

				settingControl.find('select[id^="lbSetting"]').unbind('multiselectclose').bind('multiselectclose', function () {
					GeneralSettings.validateMinMaxSelections($(this));
					// if prepared period is selected, autoUpdate will be called from bindPreparedPeriodItems after all items were loaded
					if ($(this).attr('id') !== 'lbSetting_3' || !$('#lbSetting_3 option:selected').attr('data-prep-time-period-type'))
						Storyboard.LayoutDesigner.autoUpdateLayoutElements();
				});
				settingControl.find('.selectOptDateSelection, #ddlPrepPeriodItem_3').change(function () {
					Storyboard.LayoutDesigner.autoUpdateLayoutElements();
				});

				if (storyboardSetting.SettingType === settingTypes.Interval && storyboardSetting.AutoSelectInterval) {
					$("#lbSetting_2").attr('autoSelectInterval', 'true');
				}
			}

		if (window.ContentType > 0 && window.ContentType == Storyboard.Constants.itemTypes.CHART) {
			DeckFilters.bindSettings(generalSettings);
		}

        if (GeneralSettings.hasGeneralSettings()) $('#GeneralControl').show();
        $('#pnlSettingsPanel .SettingsControl').not('.HideFilter').show();

        if (!hasHfilter)
            GeneralSettings.hideHFilterPanel(false);

        Storyboard.LayoutControls.showUpdateButton();

		GeneralSettings.addMultiselection();
		// hide time period selection box if only "Select dates..." or Select day/week/etc is available
		if ($("#lbSetting_3 option").length == 1 && ($("#lbSetting_3").val() == "-2" || $('#lbSetting_3 option:first').attr('data-prep-time-period-type') > 0)) {
			$("#lbSetting_3").parent().find("> .ui-multiselect").hide();
		}

		if ($('#lbSetting_2[autoSelectInterval]').length > 0)
			$("#lbSetting_2").closest('.SettingsControl').hide();

		if (filterSetting !== undefined)
			GeneralSettings.hideHiddenFilters(isMultiSelectFilter, filterSetting.SettingItems);

		setDropDownHeights();

		ChartSetupDataBinding.BindRankOptionalFilterItems(rankItems);
	}

	function setDropDownHeights() {
		$('.ui-multiselect', '#GeneralControl').each(function () {
			if ($(this).next('.ui-multiselect-menu').height() > ($(window).height() - $(this).offset().top)) {
				$(this).bind('click', function (e) {
					if ($(this).next('.ui-multiselect-menu').height() > ($(window).height() - $(this).offset().top)) {
						var retractHeight = $(this).offset().top + $(this).outerHeight() + $(this).scrollTop() + 20;
						$(this).next('.ui-multiselect-menu').children('ul').css('height', ($(window).height() - retractHeight) + 'px');
					}
				});
			}
		});
	}

    function loadHFiltersAdmin(callback, force) {
        if (!generalSettingsAdmin || !generalSettingsAdmin.filter(function(setting){return setting.SettingType == HFILTER_SETTING}).length || force) {
            Helpers.perfJSonCall({
                method: "GetHFilterSettingsAdmin",
                message: locale.get("Loading Filters"),
                service: "GeneralSettings",
                successCallback: function (settings) {
                    generalSettingsAdmin = [settings.hFilters];
                    hfLevelSettings = settings.hFilterLevelSettings;

                    var continueFn = function() {
                        bindHFilterSettingsAdmin(force);
                        if (callback) callback();
                    }

                    if (settings.hFilters.InheritedSettingsReportId) {
                        loadReportListForInheritedSettings(settings.hFilters.SettingType).then(continueFn);
                    } else {
                        continueFn();
                    }
                }
            });
        } else {
            bindHFilterSettingsAdmin();
        }
    }

    function loadExcludeSlidesHFiltersAdmin(callback, force) {
        if (!generalSettingsAdmin || !generalSettingsAdmin.filter(function(setting){return setting.SettingType == 6}).length || force) {
            Helpers.perfJSonCall({
                method: "GetHFilterSettingsAdmin",
                message: locale.get("Loading Filters"),
                service: "GeneralSettings",
                successCallback: function (settings) {
                    generalSettingsAdmin = [settings.hFilters];
                    hfLevelSettings = settings.hFilterLevelSettings;
                    loadHFilterSlideExclusions();
                    if (callback) callback();
                }
            });
        } else {
            loadHFilterSlideExclusions();
        }
	}

	function loadRefDataSettingsAdmin(callback, force) {
		if (!refDataSettingsAdmin || force) {
			Helpers.perfJSonCall({
				method: "GetRefDataSettingsAdmin",
				message: locale.get("Loading reference data filters"),
				service: "GeneralSettings",
				successCallback: function (refDataSettings) {
					refDataSettingsAdmin = refDataSettings;
					Storyboard.GeneralSettings.bindRefDataSettingsAdmin();
					if (callback) callback();
				}
			});
		} else {
			Storyboard.GeneralSettings.bindRefDataSettingsAdmin();
			if (callback) callback();
		}
	}

    function loadHFilterSlideExclusions(callback, setDefaultSlide) {
        Helpers.perfJSonCall({
            method: "GetHFilterSlideExclusions",
            message: locale.get("Loading slide exclusions"),
            service: "GeneralSettings",
            successCallback: function (data) {
                hFilterSlideExclusions = data;
                hFilterSlideExclusionsUnsaved = false;

                Storyboard.GeneralSettings.bindExcludeSlides('#ddlExcludeSlides');
                
                if (setDefaultSlide !== false) {
                    Storyboard.GeneralSettings.setExcludeSlidesDefaultValue();
                }

                Storyboard.GeneralSettings.bindExcludeSlidesHFiltersAdmin();

                Storyboard.EventBus.emit(Storyboard.Constants.Events.HFILTER_SLIDE_EXCLUSIONS_LOADED, data);

                if (callback) callback();
            }
        });
    }

    function bindHFilterSettingsAdmin(force) {
        if ($("#hfilterSetupContainerPanel .AdminSetting").length > 0 && !force) {
            $("#hfilterSettingsSetupContainer").append($('#hfilterShownNodeContainer, #hfilterLayoutTypeContainer, #hfilterLevelNamesContainer'));
            $("#hfilterSettingsSetupContainer #sbSettingHFilterTree").remove();
            $("#hfilterSetupContainerPanel .AdminSetting").remove();
            $("#hFilterShownLevelsWrapper").empty();
            unbindControls();
        }

        for (var settingIX in generalSettingsAdmin)
            if (generalSettingsAdmin.hasOwnProperty(settingIX)) {

                var storyboardSetting = generalSettingsAdmin[settingIX];
                var settingType = parseInt(storyboardSetting.SettingType, 10);

                if (settingType !== HFILTER_SETTING)
                    continue;

                if (settingType === HFILTER_SETTING && storyboardSetting.SettingItems.length === 0)
                    break;

                sb.GeneralSettings.hFiltersAdmin = storyboardSetting.SettingItems;

                if (force) {
                    let templateCopy = $('#hfilterSetupContainerPanel .AdminSetting');
                    forceHFilterUpdate(storyboardSetting, templateCopy);
                    bindSettingItemsAdmin(storyboardSetting, templateCopy.find("#grdItems"), force);
                } else {
                    let settingControl = $(".SettingsSetupControlTemplate").clone();
                    let templateCopy = settingControl.find(".AdminSetting");
                    templateCopy.removeClass("SettingsSetupControlTemplate");
                    templateCopy.css("width", "100%");
                    templateCopy.find("legend").html("Select Hierarchical Filter units");
                    templateCopy.find("#txtName").val(storyboardSetting.Name);
                    templateCopy.find("#chbUseSetting").attr("checked", storyboardSetting.ShowSetting);
                    templateCopy.find(".hidSettingType").val(storyboardSetting.SettingType);
                    templateCopy.find("#chbIsMultiSelect").attr("checked", storyboardSetting.IsMultiSelect);
                    templateCopy.find("#chbHasNoSelection").attr("checked", storyboardSetting.HasNoSelection);
                    templateCopy.find("#cbDynamicFilteringMoveDisabledToBottom").attr("checked", storyboardSetting.DynamicFilteringMoveDisabledToBottom);
                    setDefaultSelected(templateCopy.find('#ddlDynamicFilteringSetting'), storyboardSetting.DynamicFiltering ? storyboardSetting.DynamicFiltering: "0");
                    bindSetupType(storyboardSetting, templateCopy);

                    templateCopy.find(".header > div:first-child").removeClass("float-left w-50").find(" > span").removeClass("size-2-3");

                    templateCopy.find("#chbUseSetting").wrap('<label class="size-1-2 m-b-1"></label>')
                        .after(locale.get("Show Hierarchical Filters"));

                    templateCopy.find("#txtName").addClass("w-50 m-l-1")
                        .wrap('<label class="hfilterSetupLabel size-1-2 m-b-1 text-right"></label>')
                        .before(locale.get("Label of Hierarchical Filters"));

                    if (!storyboardSetting.ShowSetting){
                        templateCopy.find(".items, .hfilterSetupLabel").hide();
                        templateCopy.find("#dynamicFilteringProperties").hide();
                    } else {
                        templateCopy.find(".items, .hfilterSetupLabel").show();
                        templateCopy.find("#dynamicFilteringProperties").not(".reportDisabled").show();
                    }

                    var startLevel = 2;
                    for (var i = startLevel; i <= storyboardSetting.MaxHFilterLevel; i++) {
                        $("#hFilterShownLevelsWrapper").append("<span class='settingItem DUI-custom-checkbox'>" +
                            "<input id='cbShownHFilterLevel" + i + "' type='checkbox' class='shownHFilterLevel' value='" + i + "' />" +
                            "<label for='cbShownHFilterLevel" + i + "' >Level " + (i - 1) + "</label></span>");
                    }

                    $(storyboardSetting.EnabledLevels).each(function() {
                        $("#cbShownHFilterLevel" + this).attr("checked", true);
                    });

                    bindSettingItemsAdmin(storyboardSetting, templateCopy.find("#grdItems"));
                    GeneralSettingsAdmin.toggleMoveDisabledToBottom(templateCopy);
        
                    templateCopy.find(".items").append('<div class="hfilterSetupNodes size-1-2"></div><div class="hfilterSetupLayout size-1-2"></div>');
                    templateCopy.find(".hfilterSetupNodes").append($('#hfilterShownNodeContainer'));
                    templateCopy.find("#hfilterShownNodeContainer .settingsFieldsetContent").append('<ul id="sbSettingHFilterTree"></ul>');
                    templateCopy.find("#sbSettingHFilterTree").css('height', '267px');

                    templateCopy.find(".hfilterSetupLayout").append($('#hfilterLayoutTypeContainer, #hfilterLevelNamesContainer'));
                    templateCopy.find("#hfilterShownNodeContainer, #hfilterLevelNamesContainer, #hfilterLayoutTypeContainer, #hfilterShownNodesSetup, #hfilterLevelNamesContainer").show();
                    templateCopy.find("#divDynamicFilteringSetting").not(".reportDisabled").show();
                    templateCopy.find("#grdItems").remove();
                    templateCopy.find("#ofTimeIntervalProperties").remove();
                    templateCopy.find("#sbSettingHFilterTree").css('width', 'auto');

                    templateCopy.find('#lbHfilterLayoutType').val(hFilterLayoutAdmin || Storyboard.LayoutDesigner.getHFilterLayout());
                    templateCopy.find("input:radio[name='rgHfilterSelectionMode'][value='" + (hFilterSelectionModeAdmin || Storyboard.LayoutDesigner.getHFilterSelectionMode()) + "']").attr('checked', 'checked');

                    $("#hfilterSetupContainerPanel").append(templateCopy);
                }

                storyboardSetting.ShowSetting
                    ? $("#hfilterSetupContainerPanel").find(".items").show()
                    : $("#hfilterSetupContainerPanel").find(".items").hide();

                $("#hfilterSetupContainerPanel .SettingsControl").show();
            }

        if (!force)
            bindControls();

        $("#lbHfilterLayoutType").change();
        $("#rHfSTAdvanced").change();
    }

    function bindExcludeSlidesHFiltersAdmin() {
        var ddlExcludeSlidesValue = $('#ddlExcludeSlides').val();
        var selectedSlides = ddlExcludeSlidesValue ? ddlExcludeSlidesValue.split(',') : [];
        var hFilterSlideExclusion = hFilterSlideExclusions.find(function(exclusion) {
            return exclusion.SlideIDs.sort().join(",") === selectedSlides.sort().join(",");
        });

        if (selectedSlides.length === 0) {
            $('#btnExludeSlidesSetupSave, #excludeSlidesBulkEdit').attr('disabled', true);
            return;
        }

        if (!hFilterSlideExclusion) {
            hFilterSlideExclusion = {
                HFilterSlideExclusionID: 0,
                Include: false,
                HFilterSelectionType: 1,
                SelectedHFilterIDs: [],
                SelectedLevels: [],
                SlideIDs: selectedSlides.map(Number)
            }
            hFilterSlideExclusions.push(hFilterSlideExclusion);
        }

        // Bind Include/Exclude
        $('#chkExcludeSlides').attr('checked', !hFilterSlideExclusion.Include);
        $('#chkIncludeSlides').attr('checked', hFilterSlideExclusion.Include);

        // Bind paragraph
        bindExcludeSlidesParagraph(hFilterSlideExclusion);

        // Bind exclude slides by type
        $('#excludeSlidesBy input').attr('checked', false);
        $('#excludeSlidesBy input[value="'+ hFilterSlideExclusion.HFilterSelectionType +'"]').attr('checked', true);

        switch (hFilterSlideExclusion.HFilterSelectionType) {
            case 0: // Nodes
                $('#excludeSlidesHFilterTree').show();
                $('#excludeSlidesByLevels').hide();
                break;
            case 1: // Levels
                $('#excludeSlidesByLevels').show();
                $('#excludeSlidesHFilterTree').hide();
                break;
            case 2: // Branches
                $('#excludeSlidesHFilterTree').show();
                $('#excludeSlidesByLevels').hide();
                break;
        }

        // Bind levels
        var startLevel = 2;
        var storyboardSetting = generalSettingsAdmin.find(function(setting) {
            return parseInt(setting.SettingType, 10) === HFILTER_SETTING;
        });
        sb.GeneralSettings.hFiltersAdmin = storyboardSetting.SettingItems;
        
        $("#excludeSlidesByLevels").empty();

        for (var i = startLevel; i <= storyboardSetting.MaxHFilterLevel; i++) {
            $("#excludeSlidesByLevels").append("<span class='settingItem DUI-custom-checkbox'>" +
                "<input id='cbExcludeSlideByHFilterLevel" + i + "' type='checkbox' value='" + i + "'/>" +
                "<label for='cbExcludeSlideByHFilterLevel" + i + "' >Level " + (i - 1) + "</label></span>");
        }

        if (storyboardSetting.ShownHFiltersType == 3) { // Show selected levels
            $("#excludeSlidesByLevels input").attr('disabled', true);
            storyboardSetting.EnabledLevels.forEach(function(level) {
                $('#cbExcludeSlideByHFilterLevel' + level).attr('disabled', false);
            });
        }

        hFilterSlideExclusion.SelectedLevels.forEach(function(level) {
            $('#cbExcludeSlideByHFilterLevel' + level).attr('checked', true);
        });

        // Bind HFilter tree
        var chkExcludeSlidesByBranches = $("#chkExcludeSlidesByBranches").is(':checked');

        $('#excludeSlidesHFilterTree')
            .removeClass('DUITreeView DUITreeViewNoBorder')
            .removeData('DUITreeView')
            .unbind()
            .empty();

        $('#excludeSlidesHFilterTree').DUITreeView({
            inlineMenu: false,
            check: function (el) {
                var oThis = el;
                var chkExcludeSlidesByBranches = $("#chkExcludeSlidesByBranches").is(':checked');

                if (chkExcludeSlidesByBranches) {
                    oThis.parent().find(" > span").addClass("selected");
                    if (oThis.is(":checked")) {
                        $('#excludeSlidesHFilterTree').DUITreeView('checkDescendants', { rootElement: oThis.parent() });
                        oThis.parent().find('li > input').attr('disabled', true);
                    } else {
                        $('#excludeSlidesHFilterTree').DUITreeView('uncheckDescendants', { rootElement: oThis.parent() });

                        oThis.parent().find('li > input').each(function () {
                            var nodeId = $(this).val();
                            var node = Storyboard.GeneralSettings.hFiltersAdmin.find(function(n) {
                                return n.DisplayID == nodeId;
                            });

                            if (node && node.Attributes !== Storyboard.Constants.Attributes.None) {
                                $(this).removeAttr('disabled');
                            }
                        });
                    }
                    oThis.parent().find(" > span").removeClass("selected");
                }

                hFilterSlideExclusion.SelectedHFilterIDs = getCheckedHFilterTreeIDs();
                hFilterSlideExclusionsUnsaved = true;
            },
            cbCheckAll: function () {
                hFilterSlideExclusion.SelectedHFilterIDs = getCheckedHFilterTreeIDs();
                hFilterSlideExclusionsUnsaved = true;
            },
            cbUncheckAll: function () {
                hFilterSlideExclusion.SelectedHFilterIDs = getCheckedHFilterTreeIDs();
                hFilterSlideExclusionsUnsaved = true;
            }
        });

        $('#excludeSlidesHFilterTree').unbind('expanded').bind('expanded', function (evt, params) {
            var node = params.node, parentId = params.value, nodes = [];
            var chkExcludeSlidesByBranches = $("#chkExcludeSlidesByBranches").is(':checked');

            for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
                    var o = Storyboard.GeneralSettings.hFiltersAdmin[i];
                if (o.ParentSettingItemId == parentId) {
                    nodes.push({
                        name: o.Name.replace(/'/g, "\\'"),
                        value: o.DisplayID,
                        checked: hFilterSlideExclusion.SelectedHFilterIDs.includes(Number(o.DisplayID)),
                        disabled: (o.Attributes === Storyboard.Constants.Attributes.None) || 
                                (chkExcludeSlidesByBranches && 
                                    hFilterSlideExclusion.SelectedHFilterIDs.includes(Number(o.DisplayID)) &&
                                    hFilterSlideExclusion.SelectedHFilterIDs.includes(Number(o.ParentSettingItemId))
                                ),
                        alwaysShowSiblings: o.AlwaysShowSiblings,
                        alwaysShowLevelBelow: o.AlwaysShowLevelBelow,
                        alwaysShowParents: o.AlwaysShowParents,
                        alwaysShowChildren: o.AlwaysShowChildren,
                        expandable: !Storyboard.GeneralSettings.hFiltersAdmin.some(function(node) {
                            return node.ParentSettingItemId == o.DisplayID;
                        })
                    });
                }
            }
            $('#excludeSlidesHFilterTree')
                .css('width', 'auto')
                .DUITreeView('renderChildNodes', {
                    node: node.children('span'),
                    children: nodes
                });
        });

        //Add root hFilter element and direct children
        var rootId = 0, tmpChildNodes = [];
        for (let i in Storyboard.GeneralSettings.hFiltersAdmin) {
            var o = Storyboard.GeneralSettings.hFiltersAdmin[i];
            if (o.ParentSettingItemId == 0) {
                rootId = o.DisplayID;
                $('#excludeSlidesHFilterTree').DUITreeView('renderRootNode', {
                    selected: true,
                    child: {
                        name: o.Name.replace(/'/g, "\\'"),
                        value: o.DisplayID,
                        checked: hFilterSlideExclusion.SelectedHFilterIDs.includes(Number(o.DisplayID)),
                        disabled: (o.Attributes === Storyboard.Constants.Attributes.None),
                        alwaysShowSiblings: o.AlwaysShowSiblings,
                        alwaysShowLevelBelow: o.AlwaysShowLevelBelow,
                        alwaysShowParents: o.AlwaysShowParents,
                        alwaysShowChildren: o.AlwaysShowChildren,
                        expandable: !Storyboard.GeneralSettings.hFiltersAdmin.some(function(node) {
                            return node.ParentSettingItemId == o.DisplayID;
                        })
                    }
                });
                break;
            }
        }

        for (let i in Storyboard.GeneralSettings.hFiltersAdmin) {
            let o = Storyboard.GeneralSettings.hFiltersAdmin[i];
            if (o.ParentSettingItemId == rootId) {
                tmpChildNodes.push({
                    name: o.Name.replace(/'/g, "\\'"),
                    value: o.DisplayID,
                    checked: hFilterSlideExclusion.SelectedHFilterIDs.includes(Number(o.DisplayID)),
                    disabled: (o.Attributes === Storyboard.Constants.Attributes.None) || 
                            (chkExcludeSlidesByBranches && 
                                hFilterSlideExclusion.SelectedHFilterIDs.includes(Number(o.DisplayID)) &&
                                hFilterSlideExclusion.SelectedHFilterIDs.includes(Number(o.ParentSettingItemId))
                            ),
                    alwaysShowSiblings: o.AlwaysShowSiblings,
                    alwaysShowLevelBelow: o.AlwaysShowLevelBelow,
                    alwaysShowParents: o.AlwaysShowParents,
                    alwaysShowChildren: o.AlwaysShowChildren,
                    expandable: !Storyboard.GeneralSettings.hFiltersAdmin.some(function(node) {
                        return node.ParentSettingItemId == o.DisplayID;
                    })
                });
            }
        }

        $('#excludeSlidesHFilterTree').DUITreeView('renderChildNodes', { children: tmpChildNodes });
        $('#excludeSlidesHFilterTree').DUITreeView('expandNode', $('#excludeSlidesHFilterTree > li').first());

        setCheckedHFilterTreeNodes(hFilterSlideExclusion.SelectedHFilterIDs);

        // Gets ids of all ancestors up to top node
        function getParentPath(nodeID, roots) {
            var node = Storyboard.GeneralSettings.hFiltersAdmin.find(function(n) {
                return n.DisplayID == nodeID;
            });

            if (node) {
                if (node.DisplayID != rootId) {
                    if (!roots.includes(node.ParentSettingItemId)) {
                        roots.push(node.ParentSettingItemId);
                        getParentPath(node.ParentSettingItemId, roots);
                    }
                }
            }
        }

        function setCheckedHFilterTreeNodes(nodeIDs) {
            var treeEl = $("#excludeSlidesHFilterTree");

            treeEl.find("input[type=checkbox]").removeAttr("checked");

            nodeIDs.forEach(function(nodeID) {
                var nodeInput = treeEl.find("input[value='" + nodeID + "']");

                // if node already exists - set checked
                if (nodeInput.length > 0) {
                    nodeInput.first().attr("checked", "checked");
                } else { // otherwise expand ancestors first
                    var roots = [];
                    getParentPath(nodeID, roots);
                    roots = roots.reverse();
                    roots.forEach(function(rootID) {
                        var nodeInput = treeEl.find("input[value='" + rootID + "']");
                        if (!nodeInput.parent("li").hasClass('expanded')) {
                            treeEl.DUITreeView('expandNode', nodeInput.parent("li"));
                            nodeInput.parent("li").removeClass('expanded');
                        }
                    });
                    treeEl.find("input[value='" + nodeID + "']").first().attr("checked", "checked");
                }
            });
        }

        function getCheckedHFilterTreeIDs() {
            var chkExcludeSlidesByBranches = $("#chkExcludeSlidesByBranches").is(':checked');
            var hFilterIDs = $('#excludeSlidesHFilterTree')
                .DUITreeView("getCheckedValues", {
                    rootElement: $('#excludeSlidesHFilterTree')
                }).map(Number);

            function recursiveDescendantCheck(parentId) {
                for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
                    var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
                    if (item.ParentSettingItemId === parentId) {
                        if (!hFilterIDs.includes(Number(item.DisplayID))) {
                            hFilterIDs.push(Number(item.DisplayID));
                        }
                        recursiveDescendantCheck(Number(item.DisplayID));
                    }
                }
            }

            if (chkExcludeSlidesByBranches) {
                hFilterIDs.forEach(recursiveDescendantCheck);
            }

            return hFilterIDs.sort(function(a, b) { return a - b; });
        }

        // Bind events
        $('#chkExcludeSlides, #chkIncludeSlides').unbind('change').bind('change', function() {
            hFilterSlideExclusion.Include = $('#chkIncludeSlides').is(':checked');
            hFilterSlideExclusionsUnsaved = true;
            bindExcludeSlidesParagraph(hFilterSlideExclusion);
        });

        $('#excludeSlidesBy input').unbind('change').bind('change', function() {
            var excludeSlidesByType = $('#excludeSlidesBy input:checked').val();
            var settings = $('#excludeSlidesHFilterTree').data('DUITreeView').settings;
            var rootElement = $('#excludeSlidesHFilterTree').first();
            
            $('#excludeSlidesByLevels input').attr('checked', false);
            $('#excludeSlidesHFilterTree').DUITreeView('uncheckAll', { rootElement: rootElement });
            settings.cbUncheckAll()

            $('#excludeSlidesHFilterTree').find('li > input').each(function () {
                var nodeId = $(this).val();
                var node = Storyboard.GeneralSettings.hFiltersAdmin.find(function(n) {
                    return n.DisplayID == nodeId;
                });

                if (node && node.Attributes !== Storyboard.Constants.Attributes.None) {
                    $(this).removeAttr('disabled');
                }
            });

            hFilterSlideExclusion.HFilterSelectionType = Number(excludeSlidesByType);
            hFilterSlideExclusion.SelectedHFilterIDs = [];
            hFilterSlideExclusion.SelectedLevels = [];
            hFilterSlideExclusionsUnsaved = true;

            switch (excludeSlidesByType) {
                case '0': // Nodes
                    $('#excludeSlidesHFilterTree').show();
                    $('#excludeSlidesByLevels').hide();
                    break;
                case '1': // Levels
                    $('#excludeSlidesByLevels').show();
                    $('#excludeSlidesHFilterTree').hide();
                    break;
                case '2': // Branches
                    $('#excludeSlidesHFilterTree').show();
                    $('#excludeSlidesByLevels').hide();
                    break;
            }
        });

        $('#excludeSlidesByLevels input').unbind('change').bind('change', function(event) {
            var level = Number($(event.target).val());

            if (event.target.checked) {
                if (!hFilterSlideExclusion.SelectedLevels.includes(level)) {
                    hFilterSlideExclusion.SelectedLevels.push(level);
                }
            } else {
                hFilterSlideExclusion.SelectedLevels = hFilterSlideExclusion.SelectedLevels
                    .filter(function(l) { return l !== level; })
            }

            hFilterSlideExclusion.SelectedHFilterIDs = Storyboard.GeneralSettings.hFiltersAdmin
                .filter(function(node) {
                    return hFilterSlideExclusion.SelectedLevels.includes(node.HFilterLevel); 
                })
                .map(function(node) {
                    return Number(node.DisplayID);
                });

            hFilterSlideExclusionsUnsaved = true;
        });

        $('#btnExludeSlidesSetupSave, #excludeSlidesBulkEdit').attr('disabled', false);
    }

    function bindExcludeSlidesParagraph(hFilterSlideExclusion) {
        var selectedSlides = $('#ddlExcludeSlides').val().split(',');
        var note = 'Note, the slide is  hidden in Preview mode only and not in setup mode.';

        if (selectedSlides.length === 1) {
            var slide = Storyboard.LayoutDesigner.getSlideById(Number(selectedSlides[0]));
            var slideName = slide.slideName ? slide.slideName : 'slide ' + slide.slideIndex;

            if (hFilterSlideExclusion.Include) {
                $('.exclude-slides-paragraph').html('Include <b>'+ slideName +'</b> in the following Hierarchical filters nodes.<br>' + note);
            } else {
                $('.exclude-slides-paragraph').html('Exclude <b>'+ slideName +'</b> from the following Hierarchical filters nodes.<br>' + note);
            }
        } else if (selectedSlides.length > 1) {
            if (hFilterSlideExclusion.Include) {
                $('.exclude-slides-paragraph').html('Include <b>'+ selectedSlides.length +' slides</b> in the following Hierarchical filters nodes.<br>' + note);
            } else {
                $('.exclude-slides-paragraph').html('Exclude <b>'+ selectedSlides.length +' slides</b> from the following Hierarchical filters nodes.<br>' + note);
            }
        }
	}

	function bindRefDataSettingsAdmin() {
		if (Storyboard.GeneralSettings.hasHFilter()) {
			$('input.chbRefSetBy[value="4"]').siblings('label').text('Show Filter sets of every Optional filter selection independent of Hierarchical filter selections');
			$('input.chbRefSetBy[value="8"]').siblings('label').text('Show Filter sets of combined Optional filter selections independent of Hierarchical filter selections');
		} else {
			$('input.chbRefSetBy[value="4"]').siblings('label').text('Show Filter sets of every Optional filter selection');
			$('input.chbRefSetBy[value="8"]').siblings('label').text('Show Filter sets of combined Optional filter selections');
		}

		$('#chbEnableRefData').attr('checked', refDataSettingsAdmin.ShowSetting);
		$('#txtRefDataName').val(refDataSettingsAdmin.Name);
		$('#refDataAddNoSelection').attr('checked', refDataSettingsAdmin.HasNoSelection);

		$('#rbShowAllRefSets').attr('checked', refDataSettingsAdmin.AvailableRefDataSetsType == 0);
		$('#rbShowLimitedRefSets').attr('checked', refDataSettingsAdmin.AvailableRefDataSetsType > 0);
		HTMLHelpers.setBitFlags('.chbRefSetBy', refDataSettingsAdmin.AvailableRefDataSetsType);
		$('input[name=rbgMatchRefDataByHFType][value="' + refDataSettingsAdmin.RefSetHFilterMatchType + '"]').attr('checked', 'checked');

		GeneralSettingsAdmin.showHideRefDataSettings();
		GeneralSettingsAdmin.showHideMatchRefDataByHFType();

		$('#refDataCategoriesContainer .refDataCategoryAdmin').remove();
		$('#ddlRefDataAlwaysShownSets option').remove();

		var enabledOptionsHtml = '';

		for (var i = 0; i < refDataSettingsAdmin.SettingItems.length; i++) {
			var category = refDataSettingsAdmin.SettingItems[i];
			var isCategorySelected = category.AlwaysShowChildren;

			var categoryBox = $('.refDataCategoryAdminTemplate').clone();
			categoryBox.removeClass('refDataCategoryAdminTemplate').addClass('refDataCategoryAdmin');
			if ((i + 1) % 3 == 0)
				categoryBox.addClass('size-last');
			categoryBox.find('#hidRefDataCategoryDisplayId').val(category.DisplayID);
			categoryBox.find('#refDataCategoryNameAdmin').text(category.Name);
			categoryBox.find('#refDataIncludeAllFilterSets').attr('checked', isCategorySelected);

			var filterSetHtml = '';
			for (var fsi = 0; fsi < category.SubItems.length; fsi++) {
				var filterSet = category.SubItems[fsi];
				var isFilterSetSelected = isCategorySelected || (filterSet.Attributes & Storyboard.Constants.Attributes.IsUserEnabled) == Storyboard.Constants.Attributes.IsUserEnabled;
				var checked = isFilterSetSelected ? ' checked="checked"' : '';
				var disabled = isCategorySelected ? ' disabled="disabled"' : '';
				filterSetHtml += '<tr><td style="width: 30px;">' +
					'<input type="checkbox" class="refDataFilterSetEnabledAdmin" value="' + filterSet.DisplayID + '"' + checked + disabled +' /></td><td> ' +
					'<label>' + filterSet.Name + '</label></td></tr>';

				var hidden = isFilterSetSelected ? '' : ' hidden';
				var excludedFromLimit = filterSet.ExcludeFromLimiting ? ' selected="selected"' : '';
				enabledOptionsHtml += '<option value="' + filterSet.DisplayID + '"' + hidden + excludedFromLimit + '>' + category.Name + ' -> ' + filterSet.Name + '</option>';
			}

			categoryBox.find('#tblRefDataFilterSets').append(filterSetHtml);
			$('#refDataCategoriesContainer').append(categoryBox);
		}
		GeneralSettingsAdmin.validateRefDataSettings();

		var tooltip;
		$('.matchRefDataByHFType [data-tooltip]').unbind('mouseenter mouseleave')
			.bind('mouseenter', function () {
				var that = this;
				tooltip = setTimeout(function () {
					$('<div/>', {
						text: locale.get($(that).attr('data-tooltip')),
						'class': 'DUIContextMenu-tooltip',
						css: {
							'width': '400px',
							'left': (that.offsetLeft - 55) + 'px'
						}
					}).insertAfter($(that));
				}, 400);
			}).bind('mouseleave', function () {
				clearTimeout(tooltip);
				$(this).next('.DUIContextMenu-tooltip').remove();
			});

		$('#ddlRefDataAlwaysShownSets').append(enabledOptionsHtml);
		$('#ddlRefDataAlwaysShownSets').multiselect({
			header: true,
			minWidth: 300,
			classes: 'DUI-multiselect',
			multiple: true,
			selectedList: 2,
			appendTo: $('#refDataSetupContainer')
		}).multiselectfilter({
			label: '',
		});

		GeneralSettingsAdmin.showHideSelectFilterSetsToShow();

		$('#refDataSetupContainerPanel .refDataIncludeAllFilterSets').bind('click', function () {
			if ($(this).is(':checked')) {
				$(this).closest('.refDataCategoryAdmin').find('#tblRefDataFilterSets tr td input.refDataFilterSetEnabledAdmin').attr({ 'checked': 'checked', 'disabled': 'disabled' });
				var categoryId = $(this).closest('.refDataCategoryAdmin').find('#hidRefDataCategoryDisplayId').val();
				$('#ddlRefDataAlwaysShownSets option[value^="' + categoryId + '-"]').removeAttr('hidden');
				$('li[id^="li_ddlRefDataAlwaysShownSets-' + categoryId + '-"]').removeClass('ui-multiselect-hidden');
				$('li[id^="li_ddlRefDataAlwaysShownSets-' + categoryId + '-"] input[type="checkbox"]').removeAttr('hidden');
			} else
				$(this).closest('.refDataCategoryAdmin').find('#tblRefDataFilterSets tr td input.refDataFilterSetEnabledAdmin').removeAttr('disabled');
			GeneralSettingsAdmin.validateRefDataSettings();
		});
		$('#refDataSetupContainerPanel table .refDataFilterSetEnabledAdmin').bind('click', function () {
			var filterSetId = $(this).val();
			if ($(this).is(':checked')) {
				$('#ddlRefDataAlwaysShownSets option[value="' + filterSetId + '"]').removeAttr('hidden');
				$('li[id="li_ddlRefDataAlwaysShownSets-' + filterSetId + '"]').removeClass('ui-multiselect-hidden');
				$('li[id="li_ddlRefDataAlwaysShownSets-' + filterSetId + '"] input[type="checkbox"]').removeAttr('hidden');
			} else {
				$('#ddlRefDataAlwaysShownSets option[value="' + filterSetId + '"]').attr('hidden', 'hidden');
				$('#ddlRefDataAlwaysShownSets option[value="' + filterSetId + '"]').removeAttr('selected');
				$('li[id="li_ddlRefDataAlwaysShownSets-' + filterSetId + '"]').addClass('ui-multiselect-hidden');
				$('li[id="li_ddlRefDataAlwaysShownSets-' + filterSetId + '"] input[type="checkbox"]').removeAttr('checked');
				$('li[id="li_ddlRefDataAlwaysShownSets-' + filterSetId + '"] input[type="checkbox"]').attr('hidden', 'hidden');
				$('#ddlRefDataAlwaysShownSets').multiselect('update');
			}
			GeneralSettingsAdmin.validateRefDataSettings();
		});
		$('#refDataSetupContainerPanel .SettingsControl, #refDataSetupContainerPanel .refDataCategoryAdmin').show();
	}

	function getCurrentDateFormat() {
		var custFormat = 'yyyy/mm/dd';
		if (custDateFormatDP != null && custDateFormatDP != "")
			custFormat = custDateFormatDP;

		return custFormat;
	}

	function bindDatePickerToOptionalFilters() {
		var custFormat = getCurrentDateFormat();

		$('.of-datepicker').datepicker('destroy');
		$('.of-datepicker').datepicker({
			dateFormat: custFormat,
			showWeek: true,
			firstDay: 1,
			changeMonth: true,
			changeYear: true
		});

		var strToDate = function (str) {
			var arr = str.split(',');
			var date = new Date(arr[0], arr[1], arr[2]);
			if (isNaN(date)) {
				date = moment(str, custFormat.toUpperCase()).toDate();
			}
			return date;
		};


		$('.of-datepicker').each(function () {
			$(this).datepicker('setDate', strToDate($(this).attr('defaultdate')));
			$(this).datepicker('option', 'defaultDate', strToDate($(this).attr('defaultdate')));
		});
		$('.of-datepicker').each(function () {
			$(this).datepicker('setDate', strToDate($(this).attr('defaultdate')));
			$(this).datepicker('option', 'defaultDate', strToDate($(this).attr('defaultdate')));
		});


		$(".timePeriodSelections").find('.of-datepicker').each(function () {
			$(this).attr('defaultdate', $(this).prev().val());
			$(this).datepicker('setDate', strToDate($(this).attr('defaultdate')));
			$(this).datepicker('option', 'defaultDate', strToDate($(this).attr('defaultdate')));
		});
		$(".timePeriodSelections").find('.of-datepicker').each(function () {
			$(this).attr('defaultdate', $(this).prev().val());
			$(this).datepicker('setDate', strToDate($(this).attr('defaultdate')));
			$(this).datepicker('option', 'defaultDate', strToDate($(this).attr('defaultdate')));
		});
	}

	function loadGeneralSettingsAdmin() {
		if (!generalSettingsAdmin || (generalSettingsAdmin.length == 1 && parseInt(generalSettingsAdmin[0].SettingType, 10) === HFILTER_SETTING)) {
			Helpers.perfJSonCall({
				method: "GetStoryboardSettingsAdmin",
				message: locale.get("Loading Filters"),
				service: "GeneralSettings",
				successCallback: function (settings) {
					var inheritedSettings = settings.filter(setting => setting.InheritedSettingsReportId > 0);

					generalSettingsAdmin = settings;

					if (inheritedSettings.length > 0) {
						Promise.all(inheritedSettings
							.map(setting => setting.SettingType)
							.map(loadReportListForInheritedSettings)
						).then(bindGeneralSettingsAdmin);
					} else {
						bindGeneralSettingsAdmin();
					}
				}
			});
		} else {
			bindGeneralSettingsAdmin();
		}
	}

	function loadReportListForInheritedSettings(settingTypeId) {
		if (listOfReportsToInheritFrom[settingTypeId]) {
			return Promise.resolve(listOfReportsToInheritFrom[settingTypeId]);
		}

		return Helpers.perfJSonCall({
			method: "GetListOfReportsToInheritFrom",
			message: locale.get("Loading Filters"),
			service: "GeneralSettings",
			data: {
				settingTypeId: settingTypeId
			},
			successCallback: function(data) {
				listOfReportsToInheritFrom[settingTypeId] = data;
			}
		});
	}

	function loadStoryboardSettingBasedOnType(reportId, settingTypeId) {
		if (settingTypeId === HFILTER_SETTING) return;

		return Helpers.perfJSonCall({
			method: "GetStoryboardSettingBasedOnType",
			message: locale.get("Loading Filters"),
			service: "GeneralSettings",
			data: {
				reportId: reportId,
				settingTypeId: settingTypeId
			},
			successCallback: function(data) {
				if (data.length !== 1) return;

				var storyboardSetting = Object.assign(data[0], {
					InheritedSettingsReportId: reportId,
					IsParentForInheritedSettingType: false
				});

				unbindControls();
				bindGeneralSettingAdmin(storyboardSetting);
				bindControls();
				bindDatePickerToOptionalFilters();
				GeneralSettingsAdmin.initTabs();
			}
		});
	}

	function loadHFilterInheritedSettingsAdmin(reportId) {
		return Helpers.perfJSonCall({
			method: "GetHFilterInheritedSettingsAdmin",
			message: locale.get("Loading Filters"),
			service: "GeneralSettings",
			data: {
				reportId: reportId,
			},
			successCallback: function(settings) {
				generalSettingsAdmin = [Object.assign(settings.hFilters[0], {
					InheritedSettingsReportId: reportId,
					IsParentForInheritedSettingType: false,
				})];
				hFilterLayoutAdmin = settings.hFilterLayout
				hFilterSelectionModeAdmin = settings.hFilterSelectionMode;
				hfLevelSettings = settings.hFilterLevelSettings;
				sb.GeneralSettings.hFiltersAdmin = settings.hFilters[0].SettingItems;

				bindHFilterSettingsAdmin();
			}
		});
	}

	function bindGeneralSettingsAdmin() {
		if ($("#setupcontainer .AdminSetting").length > 1) {
			$("#setupTabsContainer ul li").remove();
			$("#setupTabsContainer ul li").remove();
			$("#setupTabsContainer .AdminSetting").remove();
			unbindControls();
		}

		function notHFilter(storyboardSetting) {
			return parseInt(storyboardSetting.SettingType, 10) !== HFILTER_SETTING;
		}

		generalSettingsAdmin
			.filter(notHFilter)
			.forEach(bindGeneralSettingAdmin);

		bindControls();

		if (typeof (settingsBound) != "undefined") {
			settingsBound();
		}

		GeneralSettingsAdmin.initTabs();
		GeneralSettingsAdmin.initShowSettings();

		bindDatePickerToOptionalFilters();
	}

	function bindGeneralSettingAdmin(storyboardSetting) {
		var settingType = parseInt(storyboardSetting.SettingType, 10);

		var settingControl = $(".SettingsSetupControlTemplate").clone();
		var templateCopy = settingControl.find(".AdminSetting");

		templateCopy.removeClass("SettingsSetupControlTemplate");
		templateCopy.find("#txtName").val(storyboardSetting.Name);
		templateCopy.find("#chbUseSetting").attr("checked", storyboardSetting.ShowSetting);
		templateCopy.find(".hidSettingType").val(storyboardSetting.SettingType);
		templateCopy.find("#chbIsMultiSelect").attr("checked", storyboardSetting.IsMultiSelect);
		templateCopy.find("#vsMinNoOfSelections").val(storyboardSetting.MinNoOfSelections);
		templateCopy.find("#vsMaxNoOfSelections").val(storyboardSetting.MaxNoOfSelections);
		templateCopy.find("#chbHasNoSelection").attr("checked", storyboardSetting.HasNoSelection);
		templateCopy.find("#cbNestCompareSeries").attr("checked", storyboardSetting.NestCompare);
		templateCopy.find("#cbDynamicFilteringMoveDisabledToBottom").attr("checked", storyboardSetting.DynamicFilteringMoveDisabledToBottom);
		setDefaultSelected(templateCopy.find('#ddlDynamicFilteringSetting'), storyboardSetting.DynamicFiltering ? storyboardSetting.DynamicFiltering: "0");
		templateCopy.find("#txtMaxCompareSeries").val(storyboardSetting.MaxCompareSeries);
		templateCopy.find("#chbAutoSelectIntervalForTp").attr("checked", storyboardSetting.AutoSelectInterval);

		bindSetupType(storyboardSetting, templateCopy);

		if (storyboardSetting.FilterBehaviour != undefined)
			setDefaultSelected(templateCopy.find('#ddlGlobalBehaviour'), storyboardSetting.FilterBehaviour);

		if (storyboardSetting.DefaultBehaviour != undefined)
			setDefaultSelected(templateCopy.find('#ddlGlobalDefaultBehaviour'), storyboardSetting.DefaultBehaviour ? "1" : "0");
		
		templateCopy.find('.settingChbItemDefault').hide();
		templateCopy.find('.settingChkItemHide').hide();
		templateCopy.find('.settingChkAllowSeparateExport').hide();
		if (settingType === FILTER_SETTING) {
			templateCopy.find("#filtersProperties").show();
			templateCopy.find("#dynamicFilteringProperties").show();

			templateCopy.find("#chbSplitBoxes").parent().show();

			templateCopy.find("#chbSplitBoxes").attr("checked", storyboardSetting.IsSplitBoxes);
			if (storyboardSetting.IsSplitBoxes) {
				templateCopy.find([
					'.settingChkItemHide',
					'.settingHasNoSelection',
					'.settingIsMultiSelect',
					'.settingMinNoOfSelections',
					'.settingMaxNoOfSelections',
					'.settingBehaviour',
					'.settingDefaultCompare',
					'.settingDynamicFiltering',
					'.settingChkAllowSeparateExport'
				].join()).show();
				if (Storyboard.HFilterLayout.isMultiSelect('#hfilterTree')) {
					templateCopy.find('.settingHFilterVsFilterBehavior').show();
				}
				templateCopy.find(".settingSortOrderType").show();
			} else {
				templateCopy.find("#varSubsetsProperties").show();
				templateCopy.find("#globalSettingsFilter").show();

				templateCopy.find([
					"#divDynamicFilteringMoveDisabledToBottom",
					"#hfVsSubsetsBehavior",
					'.settingChkItemHide',
					'.settingHasNoSelection',
					'.settingIsMultiSelect',
					'.settingMinNoOfSelections',
					'.settingMaxNoOfSelections',
					'.settingBehaviour',
					'.settingDefaultCompare',
					'.settingDynamicFiltering',
					'.settingHFilterVsFilterBehavior',
					".settingSortOrderType",
					'.settingChkAllowSeparateExport'
				].join()).hide();
			}

			templateCopy.find(".settingHeaderTemplate").show();

			if (storyboardSetting.IsSplitBoxes) {
				templateCopy.find("#cbFHasNoSelection").parent().show();
				templateCopy.find("#cbFIsMultiSelect").parent().show();
				templateCopy.find("#ddlFilterBehaviour").parent().show();
				templateCopy.find("#ddlDefaultBehaviour").parent().show();
				templateCopy.find("#ddlSortOrderType").parent().show();

				templateCopy.find([
					"#ddlFilterBehaviour",
					"#ddlDefaultBehaviour",
					"#ddlSortOrderType",
					"#ddlDynamicFiltering",
				].join()).show();
			}

			templateCopy.find("#ddlDefaultSelection").parent().show();
			templateCopy.find(".settingRdbItemDefault").css('display', 'none');

			templateCopy.find("#chbHide").show();
			templateCopy.find('.settingChbItemDefault').css('display', 'none');

			templateCopy.css('width', 'auto');

			templateCopy.find("#chbAllowSeparateExport").show();
		}
		else if (settingType === VARIABLE_SUBSET_SETTING) {
			templateCopy.find("#varSubsetsProperties").show();
			templateCopy.find("#noSelection").hide();
			templateCopy.find(".settingDefaultSelection").hide();
			templateCopy.find(".settingRdbItemDefault").hide();
			templateCopy.find(".settingChbItemDefault").show();
			templateCopy.find('#hfVsSubsetsBehavior').toggle(Storyboard.GeneralSettings.hasHFilter() && Storyboard.GeneralSettings.hfilterVsVarSubsetActive);

			templateCopy.find(".settingHeaderTemplate").show().find('> th').hide();
			templateCopy.find(".settingHeaderTemplate").find(".settingChbItemActive, .settingItemName, .settingChbItemDefault").show();

			templateCopy.find('input[name="optHFilterVsSubsetsBehavior"]').removeAttr('checked');
			templateCopy.find('input[name="optHFilterVsSubsetsBehavior"][value="' + (storyboardSetting.HFilterVsSubsetsBehavior || 2) + '"]').attr('checked', 'checked');
		}

		if (settingType != FILTER_SETTING && settingType != FLOATING_TIME_PERIODS_SETTING) {
			templateCopy.find("#dynamicFilteringProperties").remove();
		}

		if (settingType != INTERVAL_SETTING) {
			templateCopy.find("#ofTimeIntervalProperties").remove();
		}

		var panelId = 'setupPanel_' + storyboardSetting.SettingType;
		var settingTab = "<li><a href='#" + panelId + "'>" + Storyboard.Constants.SettingTypes.getTypeText(settingType) + "</a></li>";

		templateCopy.attr("id", panelId).hide();

		if ($('#setupTabsContainer #' + panelId).length > 0) {
			$('#setupTabsContainer #' + panelId).remove();
			settingTab = '';
		}

		$("#setupTabsContainer").append(templateCopy);

		bindSettingItemsAdmin(storyboardSetting, templateCopy.find("#grdItems"));

		if (settingType === FILTER_SETTING) {
			GeneralSettingsAdmin.toggleMoveDisabledToBottom(templateCopy);
			// Filter should be 1st
			$("#setupTabsContainer ul").prepend(settingTab);
		} else {
			$("#setupTabsContainer ul").append(settingTab);
		}

		if (settingType === FLOATING_TIME_PERIODS_SETTING) {
			templateCopy.find("#dynamicFilteringProperties").show();
			templateCopy.find("#divDynamicFilteringSetting").show();
			GeneralSettingsAdmin.toggleMoveDisabledToBottom(templateCopy);
			bindDateVariablesSection(storyboardSetting, templateCopy);
		}

		templateCopy.find('.validateMinMaxOnLeave').unbind('focusout').bind('focusout', function () {
			const $this = $(this);
			const $ddlDefaultSelection = $this.closest("td").siblings(".settingDefaultSelection").find("select");
			if ($this.attr('id') === "minNoOfSelections") {
				if ($this.val() !== '' && parseInt($this.val()) > 1) {
					$ddlDefaultSelection.find("option[value='0-0']").text(`First ${$this.val()} items will be selected`);
					$ddlDefaultSelection.find("option[value='0-1']").text(`Last ${$this.val()} items will be selected`);
				} else {
					$ddlDefaultSelection.find("option[value='0-0']").text(`First item will be selected`);
					$ddlDefaultSelection.find("option[value='0-1']").text(`Last item will be selected`);
				}

				$ddlDefaultSelection.multiselect("refresh");
			}
				
			const sss = [Storyboard.GeneralSettings.getSetting($('#setupPanel_1')), Storyboard.GeneralSettings.getSetting($('#setupPanel_5'))];
			$.when(GeneralSettingsAdmin.validateMinMaxSelections(sss))
				.then(function (validationData) {
					$('#lblMinMaxValidationMessage').html('').hide();
					$('#setupPanel_5 .validateMinMaxOnLeave').css('border-color', '')
					$('#setupPanel_5 .validateMinMaxOnLeave').siblings('button').css('border-color', '');
					GeneralSettingsAdmin.showMinMaxValidation(validationData, false, true);
				});
		});

		templateCopy.show();

		showHideAutoSelectIntervalOption();
		GeneralSettingsAdmin.showSettings(templateCopy.find("#chbUseSetting"));
		GeneralSettingsAdmin.setDefaultSelected(templateCopy.find("#checkAll"));
	}

	function bindSetupType(storyboardSetting, templateCopy) {
		if (storyboardSetting.IsParentForInheritedSettingType) {
			GeneralSettingsAdmin.bindSetupTypeParent(templateCopy);
		} else {
			templateCopy.find("#ddlSetupTypeInheritFromReport")
				.val(storyboardSetting.InheritedSettingsReportId ?? 0)
				.attr('data-default-value', storyboardSetting.InheritedSettingsReportId ?? 0);

			if (storyboardSetting.InheritedSettingsReportId > 0) {
				GeneralSettingsAdmin.setSetupType(templateCopy.find('#btnsSetupType > button[value="inherit"]'));
				templateCopy.find('fieldset.header, fieldset.items').attr('disabled', 'disabled');
			} else {
				GeneralSettingsAdmin.setSetupType(templateCopy.find('#btnsSetupType > button[value="report-specific"]'));
			}
		}
	}

	function showHideAutoSelectIntervalOption() {
		var canAutoSelect = false;

		if ($('#setupPanel_2.AdminSetting .chbUseSetting:checked').length > 0) {
			var tpSetting = getSetting($('#setupPanel_3.AdminSetting'), false);
			if (tpSetting && tpSetting.showSetting && tpSetting.settingItems && tpSetting.settingItems.length > 0) {
				for (var settingItemIX in tpSetting.settingItems)
					if (tpSetting.settingItems.hasOwnProperty(settingItemIX)) {

						var settingItem = tpSetting.settingItems[settingItemIX];

						if (settingItem.isSelected && settingItem.prepPeriodType > 0 || (settingItem.Attributes & Storyboard.Constants.Attributes.IsUserEnabled)) {
							canAutoSelect = true;
							break;
						}
					}
			}
		}

		$('#ofTimeIntervalProperties').toggle(canAutoSelect);
		if (!canAutoSelect)
			$('#chbAutoSelectIntervalForTp').attr('checked', false);
		enableDisableIntervalOptions();
	}

	function enableDisableIntervalOptions() {
		var autoSelectOn = $('#chbAutoSelectIntervalForTp').is(':checked');
		if (autoSelectOn) {
			$('#setupPanel_2.AdminSetting .chbIsSelected > input').attr('checked', true);
			$('#setupPanel_2.AdminSetting .chbIsSelected > input, #setupPanel_2.AdminSetting .checkAll').attr('disabled', 'disabled');
		} else {
			$('#setupPanel_2.AdminSetting .chbIsSelected > input, #setupPanel_2.AdminSetting .checkAll').removeAttr('disabled');
		}
	}

	function bindDateVariablesSection(storyboardSetting, templateCopy) {
		var dvSection =
			'<div class="dateVariablesSection">' +
				'<div class="header cf">' +
					'<span class="size-1-3">'+
						'<input id="chbAllowDateVariablesSelection" type="checkbox" title="Select date variables" {{CheckUncheckAlowDateVariables}}>' +
						'<input type="text" id="txtDateVariablesName" autocomplete="off" value="{{DateVariablesName}}">'+
					'</span>'+
				'</div>'+
				'<div class="items">' +
					'<table class="dateVariablesItems DUITable" style="{{ShowHideVariableSelection}}"><tbody>{{DateVariableHtmlItem}}</tbody></table>' +
				'</div>'+
			'</div>';

		var itemTemplate =
			'<tr data-dateVariableId="{{DateVariableId}}">' +
				'<td><input id="chbDateVariable_{{DateVariableId}}" type="checkbox" title="{{DateVariableText}}" {{IsSelectedDateVariable}}"></td>' +
				'<td><label for="chbDateVariable_{{DateVariableId}}">{{DateVariableText}}</label></td>' +
				'<td><input type="radio" id="chbDateVariableDefault_{{DateVariableId}}" name="chbDateVariableDefault" {{IsDefault}} {{IsDefaultDisabled}}></td>' +
			'</tr>';

		var htmlItems = '';
		storyboardSetting.DateVariables.forEach(function (dateVar) {
			var htmlItem = itemTemplate
				.replace(/{{DateVariableId}}/g, dateVar.DateVariableId)
				.replace(/{{DateVariableText}}/g, dateVar.Text)
				.replace(/{{IsSelectedDateVariable}}/g, dateVar.IsSelected ? 'checked="checked"' : '')
				.replace(/{{IsDefaultDisabled}}/g, dateVar.IsSelected ? '' : 'disabled="disabled"')
				.replace(/{{IsDefault}}/g, dateVar.IsDefault ? 'checked="checked"' : '');

			htmlItems += htmlItem;
		})

		dvSection = dvSection
			.replace(/{{CheckUncheckAlowDateVariables}}/g, storyboardSetting.AllowDateVariables ? 'checked="checked"' : '')
			.replace(/{{DateVariablesName}}/g, storyboardSetting.DateVariablesName || locale.get('Date variable'))
			.replace(/{{ShowHideVariableSelection}}/g, storyboardSetting.AllowDateVariables ? '' : 'display:none')
			.replace(/{{DateVariableHtmlItem}}/g, htmlItems);

		var $divSection = $(dvSection);
		templateCopy.append($divSection);

		// bind events
		$divSection.find('#chbAllowDateVariablesSelection').bind('change', function () {
			var $dateVariableItems = $('#setupcontainer .dateVariablesItems');
			
			if ($(this).is(':checked'))
				$dateVariableItems.show();
			else 
				$dateVariableItems.hide();
		});

		$divSection.find('input[id^="chbDateVariable_"]').bind('change', function(){
			var $chbDefault = $(this).closest('tr').find('input[name="chbDateVariableDefault"]');

			if ($(this).is(':checked')){
				$chbDefault.removeAttr('disabled');

				if ($(this).closest('.dateVariablesItems').find('input[name="chbDateVariableDefault"]:checked').length === 0)
					$chbDefault.attr('checked', true);
			} else {
				$chbDefault.attr('disabled', 'disabled');

				if ($chbDefault.is(':checked')) {
					$chbDefault.attr('checked', false);

					var $selectedVars = $(this).closest('.dateVariablesItems').find('input[id^="chbDateVariable_"]:checked');
					if ($selectedVars.length)
						$selectedVars.first().closest('tr').find('input[name="chbDateVariableDefault"]').attr('checked', true);
				}
			}
		});
	}

	function bindSettingsItems(settingControl, storyboardSetting) {
		if (storyboardSetting.SettingType != 3) {
			settingControl.find(".selectOptDateSelection, .prepPeriodItemSelection").remove();
		}

		var comp = settingControl.find("#lbSetting");
		var defaultID;

		if (storyboardSetting.IsSplitBoxes) {
			splitBoxes(storyboardSetting, settingControl, false);
		}
		else {
			comp.attr("id", "lbSetting_" + storyboardSetting.SettingType);
			comp.attr("multiple", storyboardSetting.IsMultiSelect);

			defaultID = 0;

			//5 == filter and it's children is what should be bound
			if (storyboardSetting.SettingType === 5) {
				for (var settingItemIX in storyboardSetting.SettingItems)
					if (storyboardSetting.SettingItems.hasOwnProperty(settingItemIX)) {

						var settingItem = storyboardSetting.SettingItems[settingItemIX];
						if ((settingItem.Attributes & Storyboard.Constants.Attributes.IsUserEnabled) && settingItem.SubItems.length > 0) {
							singleBoxes(settingItem.SubItems, comp, true, storyboardSetting.HasNoSelection, storyboardSetting.TotalItems, storyboardSetting.LazyLoad);

							if (settingItem.Attributes & Storyboard.Constants.Attributes.IsDefaultSelected)
								setDefaultSelected(comp, settingItem.SubItems[0].DisplayID);
						}
					}
				var spanComp = settingControl.find("#spanCompare");
				if (storyboardSetting.FilterBehaviour == 3) {
					spanComp.show();
					if (storyboardSetting.DefaultBehaviour)
						spanComp.find("input:radio[name='fCompare'][value='1']").attr('checked', 'checked');
					else
						spanComp.find("input:radio[name='fCompare'][value='0']").attr('checked', 'checked');

					spanComp.find("input:radio[name='fCompare']").unbind('change').bind('change', function () {
						Storyboard.LayoutDesigner.autoUpdateLayoutElements();
					});
				}
				else if (storyboardSetting.FilterBehaviour == 1) {
					spanComp.find("input:radio[name='fCompare'][value='0']").attr('checked', 'checked');
					spanComp.hide();
				}
				else if (storyboardSetting.FilterBehaviour == 2) {
					spanComp.find("input:radio[name='fCompare'][value='1']").attr('checked', 'checked');
					spanComp.hide();
				}

                if (storyboardSetting.HasNoSelection && comp.find("option:selected").length === 0)
					setDefaultSelected(comp, NO_SELECTION_ID);
			} else if (storyboardSetting.SettingType == Storyboard.Constants.SettingTypes.RefDataFilter) {
				// reference data, bind categories (SettingItems) and filters sets (SettingItems.SubItems)
				settingControl.find("input:radio[name='fCompare']").hide();
				settingControl.find("#spanCompare").hide();

				for (let settingItemIX in storyboardSetting.SettingItems)
					if (storyboardSetting.SettingItems.hasOwnProperty(settingItemIX)) {
						var categoryItem = storyboardSetting.SettingItems[settingItemIX];
						categoryItem.DisplayName = '--- ' + categoryItem.DisplayName + ' ---';
						if ((categoryItem.Attributes & Storyboard.Constants.Attributes.IsUserEnabled) && categoryItem.SubItems.length > 0) {
							singleBoxes($.merge([categoryItem], categoryItem.SubItems), comp, true, storyboardSetting.HasNoSelection);
							comp.find('option[value="' + categoryItem.DisplayID + '"]').attr('disabled', 'disabled');
						}
					}
				setDefaultSelected(comp, storyboardSetting.HasNoSelection ? NO_SELECTION_ID : comp.find('option:not([disabled])').first().val());
				comp.multiselect({ noneSelectedText: '' });
			} else {
                settingControl.find("input:radio[name='fCompare']").hide();
                settingControl.find("#spanCompare").hide();
                var itemsForFilters = storyboardSetting.SettingItems;
                if (storyboardSetting.SettingType == 3) {
                	itemsForFilters = $.grep(storyboardSetting.SettingItems, function (n, i) {
                		return (n.DisplayID !== "0" && n.DisplayID !== "27" && !n.IsDynamic && n.DisplayID !== '-3');
                	});

					var custFormat = getCurrentDateFormat();
					
					settingControl.find(".dateInput").datepicker('destroy');
					settingControl.find(".dateInput").datepicker({
						dateFormat: custFormat,
						showWeek: true,
						firstDay: 1,
						changeMonth: true,
						changeYear: true,
						yearRange: "c-25:c+25",
						beforeShowDay: function (date) { return Storyboard.DynamicDates.applyDayStyle(date, $("#lbSetting_3_DateVariable")); },
						afterShow: function (date) { return Storyboard.DynamicDates.applyYearMonthStyle($("#lbSetting_3_DateVariable")); }
					});
					settingControl.find(".optCustomPeriodStart").bind("change", function() {
						var startDate = settingControl.find(".optCustomPeriodStart").datepicker("getDate");
						var endDate = settingControl.find(".optCustomPeriodEnd").datepicker("getDate");

						if (moment(startDate).isAfter(endDate)) {
							settingControl.find(".optCustomPeriodEnd").datepicker("setDate", startDate);
						}
					});
					settingControl.find(".optCustomPeriodEnd").bind("change", function() {
						var startDate = settingControl.find(".optCustomPeriodStart").datepicker("getDate");
						var endDate = settingControl.find(".optCustomPeriodEnd").datepicker("getDate");

						if (moment(endDate).isBefore(startDate)) {
							settingControl.find(".optCustomPeriodStart").datepicker("setDate", endDate);
						}
					});
					var dynamicPeriodItems = $.grep(storyboardSetting.SettingItems, function (n, i) {
						return (n.IsDynamic);
					});
					if (dynamicPeriodItems.length > 0) {
						settingControl.find(".optCustomPeriodStart").datepicker('setDate', moment(dynamicPeriodItems[0].StartDate, dynamicPeriodItems[0].DateFormat.toUpperCase()).toDate());
						settingControl.find(".optCustomPeriodStart").bind('change', function (evt) {
							Storyboard.LayoutDesigner.invokeDynamicFiltering($(evt.target).closest(".SettingsControl.dynamicFiltering"));
						});
						
						settingControl.find(".optCustomPeriodEnd").datepicker('setDate', moment(dynamicPeriodItems[0].StopDate, dynamicPeriodItems[0].DateFormat.toUpperCase()).toDate());
						settingControl.find(".optCustomPeriodEnd").bind('change', function (evt) {
							Storyboard.LayoutDesigner.invokeDynamicFiltering($(evt.target).closest(".SettingsControl.dynamicFiltering"));
						});
					}

					if (self != top && window.name == "print-frame") {
						settingControl.find(".optCustomPeriodStart").datepicker('setDate', new Date(Helpers.readCookie('selectedStartDate')));
						settingControl.find(".optCustomPeriodEnd").datepicker('setDate', new Date(Helpers.readCookie('selectedEndDate')));
					}

					settingControl.find('#lbSetting_3').bind("change", function () {
						var visibleHeight = ($(this).find("option").length <= 1 && $(this).val() == "-2") ? "120px" : "150px";

						if ($(this).val() == "-2") { // select dates...
							settingControl.find(".selectOptDateSelection").show();
							settingControl.find('.prepPeriodItemSelection').hide();
							//translate controls
							settingControl.find("#lblStartDate").text(locale.get("Start date:"));
							settingControl.find("#lblEndDate").text(locale.get("Stop date:"));
							settingControl.css("height", visibleHeight);
						} else if ($(this).find('option[value="' + $(this).val() + '"]').attr('data-prep-time-period-type')) {
							settingControl.find('.prepPeriodItemSelection').show();
							settingControl.find(".selectOptDateSelection").hide();
							// load options
							var periodType = $(this).find('option[value="' + $(this).val() + '"]').attr('data-prep-time-period-type');
							var dateVarId = $('#lbSetting_3_DateVariable').val() || 1;
							//if periodType has changed OR dateVarId has changed OR if #ddlPrepPeriodItem_3 content is not loaded
							if ($('#ddlPrepPeriodItem_3').attr('data-loaded-period-type') != periodType || $('#ddlPrepPeriodItem_3').attr('data-loaded-date-var') != dateVarId || $('#ddlPrepPeriodItem_3').val() == 'undefined')
								loadPreparedTimePeriods(periodType, dateVarId, function (items) {
									bindPreparedPeriodItems(periodType, dateVarId, items);
								});
						} else {
							settingControl.find(".selectOptDateSelection").hide();
							settingControl.find('.prepPeriodItemSelection').hide();
							settingControl.css("height", "");
						}
					});
				}

				singleBoxes(itemsForFilters, comp, true, storyboardSetting.HasNoSelection);
				if (storyboardSetting.SettingType != 3) // for TP it will be fired in bindGeneralSettings
					settingControl.find("select").change();

				if (storyboardSetting.SettingType === 1 && !storyboardSetting.IsMultiSelect) { // 1 = variable subset
					defaultID = 0;
					for (let settingItemIX in storyboardSetting.SettingItems) {
						if (storyboardSetting.SettingItems[settingItemIX].Attributes & Storyboard.Constants.Attributes.IsDefaultSelected) {
							var currentDisplayID = storyboardSetting.SettingItems[settingItemIX].DisplayID;

							if (comp.find("option[value='" + currentDisplayID + "']").length > 0) {
								defaultID = currentDisplayID;
							}
						}
					}
					setDefaultSelected(comp, defaultID);
				}

				if (storyboardSetting.SettingType == 3) {
					settingControl.find(".prepPeriodItemSelection select").attr("id", "ddlPrepPeriodItem_3");

					var selectedTp = $('#lbSetting_3').val();
					var dateVariableId = 1;
					if (storyboardSetting.AllowDateVariables) {
						storyboardSetting.DateVariables
							.filter(function (settingItem) { return settingItem.IsSelected; })
							.forEach(function (settingItem) {
								if ((settingItem.Attributes & Storyboard.Constants.Attributes.IsDefaultSelected) === Storyboard.Constants.Attributes.IsDefaultSelected)
									dateVariableId = settingItem.DateVariableId;
							});
					}
					if ($('#lbSetting_3').find('option[value="' + selectedTp + '"]').attr('data-prep-time-period-type')) {
						for (var itemIx in itemsForFilters) {
							if (itemsForFilters[itemIx].DisplayID == selectedTp) {
								Helpers.fixDotnetCasing(itemsForFilters[itemIx].PreparedPeriodItems);
								bindPreparedPeriodItems(itemsForFilters[itemIx].PrepPeriodType, dateVariableId, itemsForFilters[itemIx].PreparedPeriodItems, itemsForFilters[itemIx].DefaultSelection, true);
							}
						}
					}
				}
			}
		}
	}

	function bindPreparedPeriodItems(preparedPeriodType, dateVariableId, items, defaultSelection, skipAutoUpdate) {
		$('#ddlPrepPeriodItem_3').attr('data-loaded-period-type', preparedPeriodType);
		$('#ddlPrepPeriodItem_3').attr('data-loaded-date-var', dateVariableId);

		var selection = defaultSelection || $('#ddlPrepPeriodItem_3').val();
		HTMLHelpers.bindSelect('#ddlPrepPeriodItem_3', items, 'displayId', 'displayName', null, false, null, false, ['strStartDate', 'strStopDate']);
		if (selection && $('#ddlPrepPeriodItem_3 option[value="' + selection + '"]').length > 0)
			$('#ddlPrepPeriodItem_3').val(selection);
		else
			$('#ddlPrepPeriodItem_3').val($('#ddlPrepPeriodItem_3 option:first').val());

		$('#ddlPrepPeriodItem_3.ui-multiselect-element').multiselect('refresh');

		if (!skipAutoUpdate)
			Storyboard.LayoutDesigner.autoUpdateLayoutElements();
	}

	function bindDateVariableSettingsItems(settingControl, storyboardSetting) {
		var comp = settingControl.find("#lbSetting");

		comp.attr("id", "lbSetting_3_DateVariable");
		settingControl.find("#spanCompare").remove();
		settingControl.find(".selectOptDateSelection, .prepPeriodItemSelection").remove();

		storyboardSetting.DateVariables
			.filter(function(settingItem) { return settingItem.IsSelected; })
			.forEach(function(settingItem) {
				comp.append("<option value='" + settingItem.DateVariableId + "'>" + HTMLHelpers.htmlEncode(settingItem.Text) + "</option>");

				if ((settingItem.Attributes & Storyboard.Constants.Attributes.IsDefaultSelected) === Storyboard.Constants.Attributes.IsDefaultSelected) {
					setDefaultSelected(comp, settingItem.DateVariableId);
				}
			});

		$('#lbSetting_3_DateVariable').bind('change', function () {
			if ($('#lbSetting_3').find('option[value="' + $('#lbSetting_3').val() + '"]').attr('data-prep-time-period-type')) {
				// load options
				var periodType = $('#lbSetting_3').find('option[value="' + $('#lbSetting_3').val() + '"]').attr('data-prep-time-period-type');
				var dateVarId = $('#lbSetting_3_DateVariable').val() || 1;
				//if periodType has changed OR dateVarId has changed OR if #ddlPrepPeriodItem_3 content is not loaded
				if ($('#ddlPrepPeriodItem_3').attr('data-loaded-period-type') != periodType || $('#ddlPrepPeriodItem_3').attr('data-loaded-date-var') != dateVarId || $('#ddlPrepPeriodItem_3').val() == 'undefined')
					loadPreparedTimePeriods(periodType, dateVarId, function (items) {
						bindPreparedPeriodItems(periodType, dateVarId, items);
					});
			}
		});
		settingControl.unbind('multiselectclose').bind('multiselectclose', Storyboard.LayoutDesigner.autoUpdateLayoutElements);
	}

	function singleBoxes(settingItems, comp, isDisplayPath, hasNoSelection, totalOptions, isLazyLoad, reSortItems) {
		//console.time();
		comp.show();
		var optionsHtml = "";
		var optionsArr = [];

		if (reSortItems) {
			var options = document.getElementById(comp.attr("id")).options;
			var length = options.length;

			for (var i = 0; i < length; i++) {
				var option = options[i];
				var order = option.dataset["order"] || 0;
				optionsArr[order] = option.outerHTML;
			}
		}
		else {
			optionsHtml = document.getElementById(comp.attr("id")).innerHTML;
		}

		var defaultSelected = [];

        for (var setting in settingItems){
			if (settingItems.hasOwnProperty(setting)) {

				var settingItem = settingItems[setting];
				if (settingItem.Attributes & Storyboard.Constants.Attributes.IsUserEnabled) {
					var displayName = isDisplayPath ? settingItem.DisplayName : settingItem.Name;
					if (displayName.substring(0, 4).trim().toLowerCase() == 'last') {
						var origObject = $(displayName.trim().split(' '));
						var translatedObjects = [];
						for (let i = 0; i < origObject.length; i++) {
							translatedObjects.push(locale.get(origObject[i].trim()));
						}

						for (let j = 0; j < translatedObjects.length; j++) {
							displayName = displayName.replace(origObject[j], translatedObjects[j]);
						}

					} else if (settingItem.DisplayID == NO_SELECTION_ID || filterTranslatedControls.indexOf(displayName.trim()) !== -1) { // translate but only No Selection and filters
						displayName = locale.get(displayName);
					}

					var refDataFilters = '';
					if (settingItem.RefDataFilters && settingItem.RefDataFilters.length > 0) {
						refDataFilters = ' data-ref-data-filters="' + settingItem.RefDataFilters.map(function (filter) { return filter.Key + '-' + filter.Value; }).join(',') + '"';
					}

					var prepTimePeriodType = '';
					if (settingItem.PrepPeriodType && settingItem.PrepPeriodType > 0) {
						prepTimePeriodType = ' data-prep-time-period-type="' + settingItem.PrepPeriodType + '"';
					}

					var tpSpan = '';
					if (settingItem.TimePeriodSpan > 0)
						tpSpan = ' data-time-period-span="' + settingItem.TimePeriodSpan + '"';

					if (reSortItems)
						optionsArr[settingItem.SortOrder] = "<option value='" + settingItem.DisplayID + "' data-order='" + settingItem.SortOrder + "'" + tpSpan + prepTimePeriodType + refDataFilters + ">" + HTMLHelpers.htmlEncode(displayName) + "</option > "
                    else
						optionsHtml += "<option value='" + settingItem.DisplayID + "' data-order='" + settingItem.SortOrder + "'" + tpSpan + prepTimePeriodType + refDataFilters + ">" + HTMLHelpers.htmlEncode(displayName) + "</option>";

                    if (settingItem.Attributes & Storyboard.Constants.Attributes.IsDefaultSelected) {
                        defaultSelected.push(settingItem.DisplayID);
					}

					if (settingItem.IsInputVariable)
						comp.attr('isInputVariable', 'true');
                }

				if (settingItem.SubItems.length > 0) {
					singleBoxes(settingItem.SubItems, comp, isDisplayPath);
				}
			}
		}
		
		if(reSortItems)
			optionsHtml = optionsArr.filter(function(x){return x != undefined }).join('')

		if (hasNoSelection && optionsHtml.indexOf("option value=\"" + NO_SELECTION_ID + "\"") < 0) {
			var noSelection = hasNoSelection ? "<option value='" + NO_SELECTION_ID + "'>" + HTMLHelpers.htmlEncode(Storyboard.GeneralSettings.filterNoSelectionLabel) + "</option>" : "";
			optionsHtml = noSelection + optionsHtml;
		}
		document.getElementById(comp.attr("id")).innerHTML = optionsHtml;
		if (isLazyLoad) {
			comp.attr("isLazyLoad", isLazyLoad);
			comp.attr("totalOptions", totalOptions);
		}

		for (let i = 0; i < defaultSelected.length; i++)
			setDefaultSelected(comp, defaultSelected[i]);
		//console.timeEnd();
	}

	function hasItemSelectionRange(settingItem) {
		return settingItem.UseAsMultiSelect && (!isNaN(parseInt(settingItem.MinNoOfSelections)) || !isNaN(parseInt(settingItem.MaxNoOfSelections)));
	}

	function hasSelectionRange(setting) {
		return (setting.SettingType == 6 || setting.IsMultiSelect) && (!isNaN(parseInt(setting.MinNoOfSelections)) || !isNaN(parseInt(setting.MaxNoOfSelections)));
    }

	function splitBoxes(storyboardSetting, settingControl) {
		for (var setting in storyboardSetting.SettingItems)
			if (storyboardSetting.SettingItems.hasOwnProperty(setting)) {

				var settingItem = storyboardSetting.SettingItems[setting];

				if ((settingItem.Attributes & Storyboard.Constants.Attributes.IsUserEnabled) != Storyboard.Constants.Attributes.IsUserEnabled)
					continue;

				var selectID = "lbSetting_" + storyboardSetting.SettingType + "_" + settingItem.DisplayID + "";
				var fCompareID = "fCompare_" + storyboardSetting.SettingType + "_" + settingItem.DisplayID + "";
				var spanControlID = "spanCompare_" + storyboardSetting.SettingType + "_" + settingItem.DisplayID + "";

				var newControl = settingControl.clone();

				if (settingItem.IsInputVariable)
					newControl.attr('isInputVariable', 'true');
                //translate controls
                newControl.find("#lCompare0").text(locale.get('Filter'));
				newControl.find("#lCompare1").text(locale.get('Compare'));

				newControl.addClass((settingItem.DynamicFiltering !== sb.Constants.DynamicFilteringStatus.Off) ? "dynamicFiltering" : "")
				newControl.data('dynamicFiltering',settingItem.DynamicFiltering);
				newControl.data("dynamicFilteringMoveDisabledToBottom", storyboardSetting.DynamicFilteringMoveDisabledToBottom);

				newControl.removeClass("singleBoxes");
				newControl.addClass("splitBoxes");

				newControl.removeClass('hasOptionSelectionRange');
				if (hasItemSelectionRange(settingItem)) {
					if (settingItem.HasNoSelection)
						settingItem.MinNoOfSelections = 1;
					newControl.addClass('hasOptionSelectionRange');
					newControl.data('optionSelectionRange', {
						min: settingItem.MinNoOfSelections, 
						max: settingItem.MaxNoOfSelections
					})
				}

				newControl.find("#lblName").text(settingItem.DisplayName);
				var fCompareControl = newControl.find("input:radio[name='fCompare']");
				fCompareControl.attr("name", fCompareID);
				var spanControl = newControl.find("#spanCompare");
				spanControl.attr("id", spanControlID);

				if (settingItem.FilterBehaviour == 3) {
					newControl.find(spanControlID).show();
					if (settingItem.DefaultBehaviour)
						newControl.find("input:radio[name='" + fCompareID + "'][value='1']").attr('checked', 'checked');
					else
						newControl.find("input:radio[name='" + fCompareID + "'][value='0']").attr('checked', 'checked');
				}
				else if (settingItem.FilterBehaviour == 1) {
					newControl.find("input:radio[name='" + fCompareID + "'][value='0']").attr('checked', 'checked');
					newControl.find("#" + spanControlID).hide();
					newControl.find("#" + fCompareID).hide();
				}
				else if (settingItem.FilterBehaviour == 2) {
					newControl.find("input:radio[name='" + fCompareID + "'][value='1']").attr('checked', 'checked');
					newControl.find("#" + spanControlID).hide();
					newControl.find("#" + fCompareID).hide();
				}

				var settingItemControl = newControl.find("select");
				settingItemControl.attr("id", selectID);
				settingItemControl.attr("multiple", settingItem.UseAsMultiSelect);

				settingControl.before(newControl);
				singleBoxes(settingItem.SubItems, settingItemControl, false, settingItem.HasNoSelection, settingItem.TotalItems, settingItem.LazyLoad);

				var isDefault = (settingItem.Attributes & Storyboard.Constants.Attributes.IsDefaultSelected) == Storyboard.Constants.Attributes.IsDefaultSelected;
				var defaultID = NO_SELECTION_ID;
				if (isDefault && settingItem.SubItems.length > 0) {
					defaultID = settingItem.SubItems[0].DisplayID;
					setDefaultSelected(settingItemControl, defaultID);
				}
				else {
					if (settingItem.HasNoSelection)
						setDefaultSelected(settingItemControl, defaultID);
				}

				settingItemControl.unbind('multiselectclose').bind('multiselectclose', function () {
					GeneralSettings.validateMinMaxSelections($(this));
					Storyboard.LayoutDesigner.autoUpdateLayoutElements();
				});
			}
		settingControl.remove();

	}


	function forceHFilterUpdate(storyboardSetting, templateCopy) {
		templateCopy.find("#txtName").val(storyboardSetting.Name);
		templateCopy.find("#chbUseSetting").attr("checked", storyboardSetting.ShowSetting);
		templateCopy.find(".hidSettingType").val(storyboardSetting.SettingType);
		templateCopy.find("#chbIsMultiSelect").attr("checked", storyboardSetting.IsMultiSelect);
		templateCopy.find("#chbHasNoSelection").attr("checked", storyboardSetting.HasNoSelection);
		templateCopy.find("#cbDynamicFilteringMoveDisabledToBottom").attr("checked", storyboardSetting.DynamicFilteringMoveDisabledToBottom);
		setDefaultSelected(templateCopy.find('#ddlDynamicFilteringSetting'), storyboardSetting.DynamicFiltering ? storyboardSetting.DynamicFiltering: "0");
		GeneralSettingsAdmin.toggleMoveDisabledToBottom(templateCopy);

		templateCopy.find('#sbSettingHFilterTree').remove();
		if (templateCopy.find('#sbSettingHFilterTree').length === 0)
			templateCopy.find("#hfilterShownNodeContainer .settingsFieldsetContent").append('<ul id="sbSettingHFilterTree"></ul>');
		templateCopy.find("#sbSettingHFilterTree").css('width', 'auto');

		if (!storyboardSetting.ShowSetting){
			templateCopy.find(".items, .hfilterSetupLabel").hide();
			templateCopy.find("#dynamicFilteringProperties").hide();
		} else {
			templateCopy.find(".items, .hfilterSetupLabel").show();
			templateCopy.find("#dynamicFilteringProperties").not(".reportDisabled").show();
		}
	}

	function bindSettingItemsAdmin(storyboardSetting, itemsTable, force) {
		for (var settingItemIX in storyboardSetting.SettingItems)
			if (storyboardSetting.SettingItems.hasOwnProperty(settingItemIX)) {

				var settingItem = storyboardSetting.SettingItems[settingItemIX];
				var settingItemTemplate = itemsTable.find(".settingItemTemplate").clone();
				var globalMultiselect;

				if (storyboardSetting.SettingType == 3) {
					if (!settingItem.IsDatePeriod)
						settingItemTemplate.appendTo(itemsTable);
					if (settingItem.IsDynamic)
						settingItemTemplate.hide();
					if (settingItem.DisplayID == '-3')
						settingItemTemplate.find('.chbIsSelected, .itemDisplayName').hide();
				} else {
					settingItemTemplate.appendTo(itemsTable);
				}

				settingItemTemplate.find(".settingItemValue .itemDisplayName").text(settingItem.DisplayName);
				settingItemTemplate.find(".settingItemSelected #hidSettingDisplayID").val(settingItem.DisplayID);

				if (storyboardSetting.SettingType == 3) {
					if (settingItem.TimePeriodSpanAmount > 0) {
						settingItemTemplate.find(".settingItemValue .itemDisplayName")
							.attr('TimePeriodSpanAmount', settingItem.TimePeriodSpanAmount)
							.attr('TimePeriodSpan', settingItem.TimePeriodSpan)
							.addClass('selectLastFilter');
					}

					if (settingItem.PrepPeriodType > 0) {
						settingItemTemplate.find(".settingItemValue .itemDisplayName")
							.attr('PrepPeriodType', settingItem.PrepPeriodType)
							.addClass('prepPeriodFilter');
					}

					if (settingItem.DisplayID == "0" || settingItem.DisplayID == "-2") {
						var dynamicPeriodItems = $.grep(storyboardSetting.SettingItems, function (n, i) {
							return (settingItem.DisplayID == "0" ? n.IsDatePeriod : n.IsDynamic);
						});
						if (dynamicPeriodItems.length > 0) {
							var currentFormat = getCurrentDateFormat();
							settingItem.StartDate = moment(dynamicPeriodItems[0].StartDate, dynamicPeriodItems[0].DateFormat.toUpperCase()).format(currentFormat.toUpperCase());
							settingItem.StopDate = moment(dynamicPeriodItems[0].StopDate, dynamicPeriodItems[0].DateFormat.toUpperCase()).format(currentFormat.toUpperCase());
						}

						$(settingItemTemplate).find("#hidStartDate").val(settingItem.StartDate);
						$(settingItemTemplate).find("#hidStopDate").val(settingItem.StopDate);
						$(settingItemTemplate).find("#startDate").attr("defaultdate", settingItem.StartDate);
						$(settingItemTemplate).find("#stopDate").attr("defaultdate", settingItem.StopDate);

						$(settingItemTemplate).find("#startDate").addClass("of-datepicker");
						$(settingItemTemplate).find("#stopDate").addClass("of-datepicker");
						$(settingItemTemplate).find("#startDate").addClass("startDate");
						$(settingItemTemplate).find("#stopDate").addClass("stopDate");
						$(settingItemTemplate).find("#startDate").removeAttr("id"); //Because of datepicker we have to remove id
						$(settingItemTemplate).find("#stopDate").removeAttr("id");
					}
				}

				var isSelected = (settingItem.Attributes & Storyboard.Constants.Attributes.IsUserEnabled) == Storyboard.Constants.Attributes.IsUserEnabled;
				settingItemTemplate.find(".settingItemSelected #chbIsSelected").attr("checked", isSelected);
				GeneralSettingsAdmin.disableDefault(settingItemTemplate.find(".settingItemSelected #chbIsSelected"));

				if (storyboardSetting.SettingType === HFILTER_SETTING) {
					break;
				}

				if (storyboardSetting.SettingType === FILTER_SETTING) {
					var ddl = settingItemTemplate.find('#ddlDefaultSelection').first();
					ddl.attr("id", 'ddlDefaultSelection_' + settingItem.DisplayID);
					ddl.attr("multiple", (settingItem.UseAsMultiSelect) ? "multiple" : "");
					globalMultiselect = !storyboardSetting.IsSplitBoxes && storyboardSetting.IsMultiSelect;

					// if there are any filters connected to weight -> show the Dynamic Weight column
					if (settingItem.IsConnectedToWeights) {
						itemsTable.find(".settingHeaderTemplate > .settingChkDynamicWeighting").show();
						var dynamicWeightSetting = settingItemTemplate.find('.settingChkDynamicWeighting').show();
						
						var dynamicWeightSettingChk = dynamicWeightSetting.find('#chbDynamicWeighting');
						dynamicWeightSettingChk.data('isConnectedToWeights',settingItem.IsConnectedToWeights);

						(settingItem.UseDynamicWeighting)
							? dynamicWeightSettingChk.attr("checked", "checked")
							: dynamicWeightSettingChk.removeAttr("checked");
					}

					var ddlOptionsHtml = document.getElementById('ddlDefaultSelection_' + settingItem.DisplayID).innerHTML;
					for (var i = 0; i < storyboardSetting.SettingItems[settingItemIX].SubItems.length; i++) {
						var filterAnswer = storyboardSetting.SettingItems[settingItemIX].SubItems[i];
						ddlOptionsHtml += "<option value='" + filterAnswer.DisplayID + "'>" + filterAnswer.Name + "</option>";
					}

					document.getElementById('ddlDefaultSelection_' + settingItem.DisplayID).innerHTML = ddlOptionsHtml;

					if (settingItem.IsHidden)
						settingItemTemplate.find("#chbHide").attr("checked", "checked");

					if (settingItem.HasNoSelection) {
						settingItemTemplate.find("#cbFHasNoSelection").attr("checked", "checked");
					}

					if (!settingItem.HasNoSelection) {
						var firstItemWillBeSelected = settingItemTemplate.find("#ddlDefaultSelection_" + settingItem.DisplayID + " option:first");
						firstItemWillBeSelected.text('First item will be selected');
						var lastItemWillBeSelected = $('<option value="0-1">Last item will be selected</option>');

						if (settingItem.UseAsMultiSelect && settingItem.MinNoOfSelections != null && settingItem.MinNoOfSelections > 1) {
							firstItemWillBeSelected.text(`First ${settingItem.MinNoOfSelections} items will be selected`);
							lastItemWillBeSelected = $(`<option value="0-1">Last ${settingItem.MinNoOfSelections} items will be selected</option>`);
						}

						lastItemWillBeSelected.insertAfter(firstItemWillBeSelected);
					}   

					if (settingItem.UseAsMultiSelect || globalMultiselect){
						settingItemTemplate.find("#cbFIsMultiSelect").attr("checked", "checked");
						settingItemTemplate
							.find("#ddlDefaultSelection_" + settingItem.DisplayID + " option[value^='0-']:last")
							.after('<option value="0-2">All existing and future items</option>');
					}

					if (settingItem.HasNoSelection || (!settingItem.UseAsMultiSelect && !globalMultiselect)) {
						settingItemTemplate.find('#minNoOfSelections').attr('disabled', 'disabled');
					}

					if ((!settingItem.UseAsMultiSelect && !globalMultiselect)) {
						settingItemTemplate.find('#maxNoOfSelections').attr('disabled', 'disabled');
					}

					settingItemTemplate.find('#minNoOfSelections').val(settingItem.MinNoOfSelections);
					settingItemTemplate.find('#maxNoOfSelections').val(settingItem.MaxNoOfSelections);

					if (settingItem.FilterBehaviour != undefined)
						setDefaultSelected(settingItemTemplate.find('#ddlFilterBehaviour'), settingItem.FilterBehaviour);

					if (settingItem.DefaultBehaviour != undefined)
						setDefaultSelected(settingItemTemplate.find('#ddlDefaultBehaviour'), settingItem.DefaultBehaviour ? "1" : "0");

					if (settingItem.SortOrderType != undefined)
						setDefaultSelected(settingItemTemplate.find('#ddlSortOrderType'), settingItem.SortOrderType|| "0");

					if (settingItem.DynamicFiltering != undefined){
						var dynamicFiltering = settingItem.DynamicFiltering ? settingItem.DynamicFiltering : 0;
						if(dynamicFiltering) {
							settingItemTemplate.find("#cbFHasNoSelection").attr("checked", "checked").attr("disabled", "disabled").addClass('dynamicFilteringNoSelection');
						}

						setDefaultSelected(settingItemTemplate.find('#ddlDynamicFiltering'), dynamicFiltering);
					}

                    if (settingItem.IsHFilterVsFilterActive) {
                        if (settingItem.HFilterVsFilterBehavior != undefined) {
                            setDefaultSelected(settingItemTemplate.find('#ddlHFilterVsFilterBehavior'), settingItem.HFilterVsFilterBehavior || "2");
                        }
                    } else {
                        settingItemTemplate.find('#ddlHFilterVsFilterBehavior').remove();
                    }

					if (settingItem.IsInputVariable) {
						var dF = settingItemTemplate.find('#ddlDynamicFiltering');
						if (storyboardSetting.IsSplitBoxes) dF.hide(); else dF.hide().parent().hide();
						dF.addClass('isInputVariable');
					}

					if (settingItem.AllowSeparateExport)
						settingItemTemplate.find("#chbAllowSeparateExport").attr("checked", "checked");
				}

				if (settingItem.DefaultSelection != undefined) {
					var defaultSelectionArray = settingItem.DefaultSelection.split(",");
					var defaultDropdownSelector = "#ddlDefaultSelection" + (storyboardSetting.SettingType === FILTER_SETTING ? "_" + settingItem.DisplayID : "");

					if(~defaultSelectionArray.indexOf('0-2')){
						GeneralSettingsAdmin.checkAllAndFuture($(defaultDropdownSelector))
					}
					else {
						for (let i = 0; i < defaultSelectionArray.length; i++) {
							settingItemTemplate.find(defaultDropdownSelector + " option[value='" + defaultSelectionArray[i] + "']").attr("selected", 1);
						}
					}
				}

				var isDefault = (settingItem.Attributes & Storyboard.Constants.Attributes.IsDefaultSelected) == Storyboard.Constants.Attributes.IsDefaultSelected;

				if (storyboardSetting.IsMultiSelect && storyboardSetting.SettingType !== FILTER_SETTING)
					settingItemTemplate.find("#chbDefault").attr("disabled", !isSelected).attr("checked", isDefault).show();
				else {
					settingItemTemplate.find("#rdbDefault").attr("disabled", !isSelected).attr("checked", isDefault).show();
					if (storyboardSetting.SettingType === FILTER_SETTING) {
						if (settingItem.UseAsMultiSelect && settingItemTemplate.find("#ddlDefaultSelection_" + settingItem.DisplayID + " option:selected").length > 1) {
							settingItemTemplate.find("#ddlDefaultSelection_" + settingItem.DisplayID + " option[value='0-0']").attr("selected", 0);
						}
						globalMultiselect = !storyboardSetting.IsSplitBoxes && storyboardSetting.IsMultiSelect;
						var renderOnDemandStep = Storyboard.GeneralSettings.filterLazyRenderCount;
						var renderOnDemand = renderOnDemandStep > 0;
						var selectBox = settingItemTemplate.find("#ddlDefaultSelection_" + settingItem.DisplayID).first();

						selectBox.multiselect({
							header: false,
							minWidth: null,
							classes: 'DUI-multiselect',
							multiple: (settingItem.UseAsMultiSelect || globalMultiselect),
							selectedList: 2,
							renderOnDemand: renderOnDemand,
							renderOnDemandStep: renderOnDemandStep
						}).multiselect(isSelected ? 'enable' : 'disable');

						if (settingItem.LazyLoad) {
							selectBox.attr("isLazyLoad", settingItem.LazyLoad);
							selectBox.attr("totalOptions", settingItem.TotalItems);

							if (settingItem.SubItems.length == 0 && settingItem.TotalItems > 0) {
								GeneralSettings.bindLazyLoadOpen(selectBox);
							} else if (settingItem.SubItems.length < settingItem.TotalItems) {
								GeneralSettings.bindLazyLoadScroll(selectBox);
							}
						}
					} else {
						settingItemTemplate.find("#ddlDefaultSelection").attr("disabled", !isSelected).attr("checked", isDefault).show();
					}
				}

				if (storyboardSetting.SettingType === FILTER_SETTING) {
					settingItemTemplate.attr('class', 'settingItemInline');
				} else {
					settingItemTemplate.attr('class', 'settingItem');
					if (storyboardSetting.SettingType == 3 && settingItem.DisplayID == "-3")
						settingItemTemplate.addClass('nohovertr');
				}

				if (settingItem.DisplayID != "0" && settingItem.DisplayID != "-2") {
					settingItemTemplate.find('.selectDateSelection').remove();
				} else if (isSelected)
					settingItemTemplate.find('.selectDateSelection').show();
				else
					settingItemTemplate.find('.selectDateSelection').hide();

				if (storyboardSetting.SettingType != 3 || settingItem.DisplayID != "27") {
					settingItemTemplate.find('.selectDatePeriod').remove();
					settingItemTemplate.find('.addNewPeriodItem').remove();
				}

				if (storyboardSetting.SettingType != 3 || settingItem.DisplayID != "-3")
					settingItemTemplate.find('.selectPreparedPeriod').remove();
			}

		// Add optional custom time period filter
		if (storyboardSetting.SettingType == 3) {

			$(itemsTable).find('.selectLastFilter').each(function (i) {
				var ofItemTable = $(this).closest('table').find('#selectDatePeriodTable')[1];

				if ($(ofItemTable).find('tr').length == 2 && i == 0) {
					$(ofItemTable).find('#periodNum1').val($(this).attr('TimePeriodSpanAmount'));
					$(ofItemTable).find('#settingControlFull').val($(this).attr('TimePeriodSpan'));
					$(ofItemTable).find('.ofSettingDisplayID').val($(this).closest('tr').find('#hidSettingDisplayID').val());
					$(ofItemTable).find('.settingDefaultComp').attr('checked', $(this).closest('tr').find('#rdbDefault').is(':checked'));
				} else {

					var templateRow = $(ofItemTable).find('.periodTableTemplate').clone();
					templateRow.css('display', '');
					$(templateRow).removeClass('periodTableTemplate');
					$(templateRow).find('.periodNumber').val($(this).attr('TimePeriodSpanAmount'));
					$(templateRow).find('.periodType').val($(this).attr('TimePeriodSpan'));
					$(templateRow).find('.settingDefaultComp').attr('checked', $(this).closest('tr').find('#rdbDefault').is(':checked'));
					$(templateRow).find('.ofSettingDisplayID').val($(this).closest('tr').find('#hidSettingDisplayID').val());
					$(ofItemTable).append(templateRow);
				}

				$(this).closest('tr').remove();
			});


			$('.chbPreparedPeriodType').removeAttr('checked');
			$('.tblPreparedPeriodSettings .settingDefaultComp').attr('disabled', 'disabled').removeAttr('checked');

			$(itemsTable).find('.prepPeriodFilter').each(function (i) {
				var prepPeriodType = $(this).attr('PrepPeriodType');
				var isDefault = $(this).closest('tr').find('#rdbDefault').is(':checked');

				var prepPeriodRow = $('.chbPreparedPeriodType[value="' + prepPeriodType + '"]').closest('tr');
				$(prepPeriodRow).find('.chbPreparedPeriodType').attr('checked', 'checked');
				$(prepPeriodRow).find('.settingDefaultComp').removeAttr('disabled').attr('checked', isDefault);

				$(this).closest('tr').remove();
			});

			$(itemsTable).find('#hidSettingDisplayID:input[value="27"], #hidSettingDisplayID:input[value="-3"]').closest('tr').find('.settingRdbItemDefault').hide();
		}

		// Transform hFilter settings to TreeView
		if (parseInt(storyboardSetting.SettingType, 10) === HFILTER_SETTING) {
			if (storyboardSetting.ShownHFiltersType == 1)
				for (let i in Storyboard.GeneralSettings.hFiltersAdmin)
					Storyboard.GeneralSettings.hFiltersAdmin[i].Attributes = Storyboard.Constants.Attributes.IsUserEnabled;

			setTimeout(function () {
				$('#sbSettingHFilterTree').DUITreeView({
					inlineMenu: true,
					check: function (el) {
						var nodeId = el.val(), sbAttr = Storyboard.Constants.Attributes;
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
							if (parseInt(item.DisplayID, 10) === parseInt(nodeId, 10)) {
								item.Attributes = (el.is(':checked')) ? sbAttr.IsUserEnabled : sbAttr.None;
							}
						}
					},
					cbCheckAll: function () {
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							Storyboard.GeneralSettings.hFiltersAdmin[i].Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
						}
					},
					cbUncheckAll: function () {
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							Storyboard.GeneralSettings.hFiltersAdmin[i].Attributes = Storyboard.Constants.Attributes.None;
						}
					},
					cbCheckChildren: function (parentId) {
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
							if (item.ParentSettingItemId === parseInt(parentId, 10)) {
								item.Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
							}
						}
					},
					cbUncheckChildren: function (parentId) {
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
							if (item.ParentSettingItemId === parseInt(parentId, 10)) {
								item.Attributes = Storyboard.Constants.Attributes.None;
							}
						}
					},
					cbCheckSiblings: function (parentId) {
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
							if (item.ParentSettingItemId === parseInt(parentId, 10)) {
								item.Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
							}
						}
					},
					cbUncheckSiblings: function (parentId) {
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
							if (item.ParentSettingItemId === parseInt(parentId, 10)) {
								item.Attributes = Storyboard.Constants.Attributes.None;
							}
						}
					},
					cbCheckAncestors: function (nodeId) {
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
							if (parseInt(item.DisplayID, 10) === parseInt(nodeId, 10)) {
								var prevParentId = item.ParentSettingItemId;
								while (prevParentId !== 0) {
									for (var y in Storyboard.GeneralSettings.hFiltersAdmin) {
										if (parseInt(Storyboard.GeneralSettings.hFiltersAdmin[y].DisplayID, 10) === parseInt(prevParentId, 10)) {
											Storyboard.GeneralSettings.hFiltersAdmin[y].Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
											prevParentId = parseInt(Storyboard.GeneralSettings.hFiltersAdmin[y].ParentSettingItemId, 10);
											break;
										}
									}
								}
								break;
							}
						}
					},
					cbUncheckAncestors: function (nodeId) {
						//same code as cbCheckAncestor, but different end-result flag. :( needs optimization
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
							if (parseInt(item.DisplayID, 10) === parseInt(nodeId, 10)) {
								var prevParentId = item.ParentSettingItemId;
								while (prevParentId !== 0) {
									for (var y in Storyboard.GeneralSettings.hFiltersAdmin) {
										if (parseInt(Storyboard.GeneralSettings.hFiltersAdmin[y].DisplayID, 10) === parseInt(prevParentId, 10)) {
											Storyboard.GeneralSettings.hFiltersAdmin[y].Attributes = Storyboard.Constants.Attributes.None;
											prevParentId = parseInt(Storyboard.GeneralSettings.hFiltersAdmin[y].ParentSettingItemId, 10);
											break;
										}
									}
								}
								break;
							}
						}
					},
					cbCheckDescendants: function (nodeId) {
						function recursiveDescendantCheck(parentId) {
							for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
								var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
								if (item.DisplayID == nodeId) {
									item.AlwaysShowChildren = true;
								}
								if (item.ParentSettingItemId === parseInt(parentId, 10)) {
									item.Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
									recursiveDescendantCheck(item.DisplayID);
								}
							}
						}

						recursiveDescendantCheck(nodeId);
					},
					cbUncheckDescendants: function (nodeId) {
						//same code as cbCheckDescendants, but different end-result flag. :( needs optimization
						function recursiveDescendantUncheck(parentId) {
							for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
								var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
								if (item.DisplayID == nodeId)
									item.AlwaysShowChildren = false;
								if (item.ParentSettingItemId === parseInt(parentId, 10)) {
									item.Attributes = Storyboard.Constants.Attributes.None;
									recursiveDescendantUncheck(item.DisplayID);
								}
							}
						}

						recursiveDescendantUncheck(nodeId);
					},
					cbCheckNodeLevel: function (nodeLevel) {
						//use simplest way to calculate it :/ based on root=1
						for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
							var item = Storyboard.GeneralSettings.hFiltersAdmin[i];
							if (item.Path.split(' -> ').length === parseInt(nodeLevel, 10)) {
								item.Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
							}
						}
					}
				});

                $("#ddlShownHFiltersType").val(storyboardSetting.ShownHFiltersType);
                if ($("#ddlShownHFiltersType").val() != 2) {
                  $("#selectedNodes").css("display", "none");
                } else {
                  $("#selectedNodes").css("display", "")
                }
                $("#sbSettingHFilterTree").css("visibility", storyboardSetting.ShownHFiltersType != 2 && storyboardSetting.ShownHFiltersType != 4 ? "hidden" : "visible");
				$("#hFilterShownLevelsWrapper").css("display", storyboardSetting.ShownHFiltersType != 3 ? "none" : "");
				$('input[name="rgHFNonSelectableMode"][value="' + (storyboardSetting.HideNonSelectableHFLevels ? 2 : 1) + '"]').attr('checked', 'checked');
				$('#hfMinNoOfSelections').val(storyboardSetting.MinNoOfSelections);
				$('#hfMaxNoOfSelections').val(storyboardSetting.MaxNoOfSelections);

                showHideHFilterQuickButtons();
            }, 0);

			//Add root hFilter element and direct children
			var rootId = 0, tmpChildNodes = [];
			for (let i in Storyboard.GeneralSettings.hFiltersAdmin) {
				var o = Storyboard.GeneralSettings.hFiltersAdmin[i];
				if (o.ParentSettingItemId == 0) {
					rootId = o.DisplayID;
					var r = Object.assign({}, o);
					setTimeout(function () {
						$('#sbSettingHFilterTree').DUITreeView('renderRootNode', {
							selected:true,
							child: {
								name: r.DisplayName.replace(/'/g, "\\'"),
								value: r.DisplayID, 
								alwaysShowSiblings: r.AlwaysShowSiblings,
								alwaysShowLevelBelow: r.AlwaysShowLevelBelow,
								alwaysShowParents: r.AlwaysShowParents,
								alwaysShowChildren: r.AlwaysShowChildren,
								checked: (r.Attributes == Storyboard.Constants.Attributes.IsUserEnabled)
							}
						});
					}, 0);
					break;
				}
			}

			for (let i in Storyboard.GeneralSettings.hFiltersAdmin) {
				let o = Storyboard.GeneralSettings.hFiltersAdmin[i];
				if (o.ParentSettingItemId == rootId) {
					tmpChildNodes.push({
						name: o.Name.replace(/'/g, "\\'"), value: o.DisplayID, checked: (o.Attributes == Storyboard.Constants.Attributes.IsUserEnabled),
						disabled: $("#ddlShownHFiltersType").val() == 4 && (o.Attributes == Storyboard.Constants.Attributes.IsUserEnabled) && !o.AlwaysShowChildren,
						expandable: !Storyboard.GeneralSettings.hFiltersAdmin.some(function(node) {
							return node.ParentSettingItemId == o.DisplayID;
						}),
						alwaysShowSiblings: o.AlwaysShowSiblings, alwaysShowLevelBelow: o.AlwaysShowLevelBelow,
						alwaysShowParents: o.AlwaysShowParents, alwaysShowChildren: o.AlwaysShowChildren
					});
				}
			}

			setTimeout(function () {
				$('#sbSettingHFilterTree').DUITreeView('renderChildNodes', { children: tmpChildNodes })

				//Attach events
				$('#sbSettingHFilterTree').bind('expanded', function (evt, params) {
					var node = params.node, parentId = params.value, nodes = [];
					for (var i in Storyboard.GeneralSettings.hFiltersAdmin) {
						var o = Storyboard.GeneralSettings.hFiltersAdmin[i];
						if (o.ParentSettingItemId == parentId) {
							nodes.push({
								name: o.Name.replace(/'/g, "\\'"), value: o.DisplayID, checked: (o.Attributes == Storyboard.Constants.Attributes.IsUserEnabled),
								disabled: $("#ddlShownHFiltersType").val() == 4 && (o.Attributes == Storyboard.Constants.Attributes.IsUserEnabled) && !o.AlwaysShowChildren,
								expandable: !Storyboard.GeneralSettings.hFiltersAdmin.some(function(node) {
									return node.ParentSettingItemId == o.DisplayID;
								}),
								alwaysShowSiblings: o.AlwaysShowSiblings, alwaysShowLevelBelow: o.AlwaysShowLevelBelow,
								alwaysShowParents: o.AlwaysShowParents, alwaysShowChildren: o.AlwaysShowChildren
							});
						}
					}
					$('#sbSettingHFilterTree').DUITreeView('renderChildNodes', { node: node.children('span'), children: nodes });
				});
			}, 0);

			restoreHFilterLevels();
		}
	}

	function loadGeneralSettings() {
		var params = {
			method: "GetStoryboardSettings",
			message: locale.get("Loading Filters"),
			service: "GeneralSettings"
		};

		return Helpers.perfJSonCall(params);
	}

	function loadDefaultOptionalFilters() {

		return Helpers.perfJSonCall({
			method: "GetStoryboardSettingsDefaults",
			message: locale.get("Reseting Filters"),
			data: { flattenItems: true, isRenew: false },
			service: "GeneralSettings",
		});

	}

	function onPreparedTimePeriodsLoaded(items) {
		Helpers.fixDotnetCasing(items);
		preparedTimePeriods = items;
		$(document).trigger('DAPI.hashedPreparedTimePeriodsLoaded');
		sb.GeneralSettings.prepPeriodItemsLoading = false;
	}

	function loadPreparedTimePeriods(prepPeriodType, dateVariableId, callback) {
		function hashedPreparedTimePeriodsLoaded() {
			callback(preparedTimePeriods);
		}

		$(document).unbind("DAPI.hashedPreparedTimePeriodsLoaded").bind("DAPI.hashedPreparedTimePeriodsLoaded", hashedPreparedTimePeriodsLoaded);

		sb.GeneralSettings.prepPeriodItemsLoading = true;
		Helpers.perfJSonCall({
			method: "GetPreparedPeriodItemsHash",
			data: {
				preparedPeriodType: prepPeriodType,
				dateVariableId: dateVariableId
			},
			service: "GeneralSettings",
			successCallback: function (itemsHash) { Storyboard.GeneralSettings.insertHashDataScript("preparedTimePeriodsCacheScript", itemsHash, "Storyboard.GeneralSettings.onPreparedTimePeriodsLoaded"); },
			fixCasing: true
		});
	}

	function loadStorySlideSettings() {
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
			return null;

		var storySlideId = Helpers.getURLParameter("mssId");
		if (storySlideId && storySlideId.length > 0) {
			var ids = storySlideId.split("-");
			if (ids.length == 2) {
				var params = {
					data: { storyId: ids[0], slideId: ids[1] },
					method: "GetStorySlideSettings",
					message: locale.get("Loading story settings"),
					service: "MyStory"
				};

				return Helpers.perfJSonCall(params);
			}
		}

		return null;
	}

	function loadGeneralSettingsWithRenew() {
		var params = {
			method: "GetStoryboardSettingsWithRenew",
			message: locale.get("Loading Filters"),
			service: "GeneralSettings"
		};

		return Helpers.perfJSonCall(params);
	}

	function loadHFilterLevelSettings() {
		var params = {
			method: "GetHFilterLevelSettings",
			message: locale.get("Loading Filters")
		};

		return Helpers.perfJSonCall(params);
	}

	function loadGeneralSettingsForReport(reportID) {
		var params = {
			method: "GetStoryboardSettingsForPreload",
			data: { reportID: reportID },
			service: "../storyboard/services/GeneralSettings.aspx/"
		};

		return Helpers.perfJSonCall(params);
	}

	function getPreloadCalculations(reportIDS, hfilterIDS, layoutElements) {
		var params = {
			method: "GetNumberOfCombinations",
			data: { reportsIDs: reportIDS, hfilterIDS: hfilterIDS, layoutElements: layoutElements },
			service: "../storyboard/services/GeneralSettings.aspx/"
		};

		return Helpers.perfJSonCall(params);
	}

	function savePreloadSettingsForReport(reportID, settings, combineWithNO, sCb, fCb) {
		var params = {
			method: "SavePreloadSelections",
			data: { reportID: reportID, selections: settings, combineWithNO: combineWithNO },
			service: "../storyboard/services/GeneralSettings.aspx/",
			failCallback: fCb,
			successCallback: sCb
		};

		return Helpers.perfJSonCall(params);
	}

	function bindControls() {
		$(".AdminSetting .chbUseSetting").bind("click", function (evt) {
			GeneralSettingsAdmin.showSettings(evt.currentTarget);

			showHideAutoSelectIntervalOption();
		});

		$(".AdminSetting .settingDefaultComp[type='radio']").bind("click", function (evt) {
			GeneralSettingsAdmin.checkRadioButtons(evt.currentTarget);
		});

		$(".AdminSetting .chbIsSelected input").bind("click", function (evt) {
			showHideAutoSelectIntervalOption();

			GeneralSettingsAdmin.disableDefault(evt.currentTarget);
			GeneralSettingsAdmin.setDefaultSelected(evt.currentTarget);
			GeneralSettingsAdmin.updateCheckAllCheckbox(evt.currentTarget);
		});

		$('.chbAutoSelectIntervalForTp').bind('click', function () {
			enableDisableIntervalOptions();
		});

		$('#chbAutoSelectIntervalShowInfo').unbind('click').bind('click', function () {
			var html =
				'<h2>Auto-select interval based on user selected Time period</h2>' +
				'<p>Applied interval is based on user selected time-period,  the Interval filter is hidden and not shown for users.</p>' +
				'<p><ul>' +
				'<li>Time period = Full period,  Interval = Full period</li>' +
				'<li>Time period = Day selection,   Interval = Days</li>' +
				'<li>Time period = Week selection, Interval = Weeks</li>' +
				'<li>Time period = Month selection, Interval = Months</li>' +
				'<li>Time period = Quarter selection, Interval = Quarters</li>' +
				'<li>Time period = Year selection,  Interval = Years</li>' +
				'<li>Time period = Last X Days,  Interval = Days</li>' +
				'<li>Time period = Last X Weeks, Interval = Weeks</li>' +
				'<li>Time period = Last X Months, Interval = Months</li>' +
				'<li>Time period = Last X Quarters, Interval = Quarters</li>' +
				'<li>Time period = Last X Years, Interval = Years</li>' +
				'<li>Time period= start and stope date defined in calendar control, Interval = Full period</li>' +
				'</ul></p>';

			new DUIwindow2({
				title: "",
				width: 510,
				padding: 45,
				buttonsHeight: 50,
				buttons: [],
				html: html,
				modal: true,
				preWrapSpace: false
			});
		});

		$('.AdminSetting input.chbPreparedPeriodType').unbind('change').bind('change', function (evt) {
			if ($(evt.currentTarget).is(':checked')) {
				$(evt.currentTarget).closest('tr').find('.settingDefaultComp').removeAttr('disabled');
			} else {
				$(evt.currentTarget).closest('tr').find('.settingDefaultComp').attr('disabled', 'disabled').removeAttr('checked');
			}

			showHideAutoSelectIntervalOption();

			GeneralSettingsAdmin.disableDefault(evt.currentTarget);
			GeneralSettingsAdmin.setDefaultSelected(evt.currentTarget);
		});

		$(".AdminSetting td.settingHasNoSelection input").bind("change", function (evt) {
			GeneralSettingsAdmin.changeNoSelectionItemDefaultSelection(evt.currentTarget);
			GeneralSettingsAdmin.updateAddNoSelectionForAllCheckbox(evt.currentTarget);

			if (!$(this).is(':checked') && $(this).closest('.settingHasNoSelection').siblings('.settingIsMultiSelect').find('#cbFIsMultiSelect').is(':checked')) {
				$(this).closest('.settingHasNoSelection').siblings('.settingMinNoOfSelections').find('#minNoOfSelections').removeAttr('disabled');
			} else {
				$(this).closest('.settingHasNoSelection').siblings('.settingMinNoOfSelections').find('#minNoOfSelections').attr('disabled', 'disabled');
			}
		});

		$(".AdminSetting td.settingIsMultiSelect input").bind("change", function (evt) {
			GeneralSettingsAdmin.changeMultiselectDefaultSelection(evt.currentTarget);
			GeneralSettingsAdmin.updateMultiselectForAllCheckbox(evt.currentTarget);

			let hasNoSelection = $(this).closest('.settingIsMultiSelect').siblings('.settingHasNoSelection').find('#cbFHasNoSelection').is(':checked');
			let $minNoOfSelections = $(this).closest('.settingIsMultiSelect').siblings('.settingMinNoOfSelections').find('#minNoOfSelections');
			let $maxNoOfSelections = $(this).closest('.settingIsMultiSelect').siblings('.settingMaxNoOfSelections').find('#maxNoOfSelections');
			let $ddlDefaultSelection = $(this).closest('.settingIsMultiSelect').siblings('.settingDefaultSelection').find('select');
			if ($(this).is(':checked')) {
				if (!hasNoSelection)
					$minNoOfSelections.removeAttr('disabled');
				$maxNoOfSelections.removeAttr('disabled');

				if ($minNoOfSelections.val() > 1 && !hasNoSelection) {
					$ddlDefaultSelection.find("option[value='0-0']").text(`First ${$minNoOfSelections.val()} items will be selected`);
					$ddlDefaultSelection.find("option[value='0-1']").text(`Last ${$minNoOfSelections.val()} items will be selected`);
				} else {
					$ddlDefaultSelection.find("option[value='0-0']").text(`First item will be selected`);
					$ddlDefaultSelection.find("option[value='0-1']").text(`Last item will be selected`);
				}
			} else {
				$minNoOfSelections.attr('disabled', 'disabled');
				$maxNoOfSelections.attr('disabled', 'disabled');

				$ddlDefaultSelection.find("option[value='0-0']").text(`First item will be selected`);
				$ddlDefaultSelection.find("option[value='0-1']").text(`Last item will be selected`);
			}

			$ddlDefaultSelection.multiselect("refresh");
		});

		function enforcePositiveNumber() {
			if ($(this).val() == '')
				return;

			if (parseInt($(this).val()) < 1)
				$(this).val('1');
        }

		$(".AdminSetting .settingMinNoOfSelections input").bind("keyup mouseup", enforcePositiveNumber);
		$(".AdminSetting .settingMaxNoOfSelections input").bind("keyup mouseup", enforcePositiveNumber);

		$("#vsMinNoOfSelections").bind("keyup mouseup", enforcePositiveNumber);
		$("#vsMaxNoOfSelections").bind("keyup mouseup", enforcePositiveNumber);

		$("#hfMinNoOfSelections").bind("keyup mouseup", enforcePositiveNumber);
		$("#hfMaxNoOfSelections").bind("keyup mouseup", enforcePositiveNumber);

		$(".AdminSetting td.settingDefaultCompare select").bind("change", function (evt) {
			GeneralSettingsAdmin.updateDefaultBehaviourForAllSelect(evt.currentTarget);
		});

		$(".AdminSetting td.settingDefaultSelection select").bind("multiselectclick", function (event, ui) {
			GeneralSettingsAdmin.changeDefaultSelection(event, ui);
			GeneralSettingsAdmin.changeDefaultSelectionForDynamicFiltering(event.currentTarget);
		});

		$(".AdminSetting select.validateMinMaxOnLeave").bind("multiselectclose", function (event, ui) {
			let sss = [Storyboard.GeneralSettings.getSetting($('#setupPanel_1')), Storyboard.GeneralSettings.getSetting($('#setupPanel_5'))];
			$.when(GeneralSettingsAdmin.validateMinMaxSelections(sss))
				.then(function (validationData) {
					$('#lblMinMaxValidationMessage').html('').hide();
					$('#setupPanel_5 .validateMinMaxOnLeave').css('border-color', '');
					$('#setupPanel_5 .validateMinMaxOnLeave').siblings('button').css('border-color', '');
					GeneralSettingsAdmin.showMinMaxValidation(validationData, false, true);
				});
		});

		$(".AdminSetting td.settingDynamicFiltering select").bind("change", function (evt) {
			if (Number($(evt.currentTarget).val()) !== 0) GeneralSettingsAdmin.checkInMemory(evt);
			GeneralSettingsAdmin.setDynamicFilteringDefaultSelections(evt.currentTarget);
			GeneralSettingsAdmin.updateDynamicFilteringForAllSelect(evt.currentTarget);
			GeneralSettingsAdmin.toggleMoveDisabledToBottom(evt.currentTarget);
		});

		$(".AdminSetting .ddlDynamicFilteringSetting").bind("change", function (evt) {
			if (Number($(evt.currentTarget).val()) !== 0) GeneralSettingsAdmin.checkInMemory(evt);
			GeneralSettingsAdmin.toggleMoveDisabledToBottom(evt.currentTarget);
		});

		$(".AdminSetting .checkAll").bind("change", function (evt) {
			GeneralSettingsAdmin.checkAll(evt.currentTarget);
		});

		$(".AdminSetting .chbHasNoSelectionForAll").bind("change", function (evt) {
			GeneralSettingsAdmin.addNoSelectionForAll(evt.currentTarget);
		});

		$(".AdminSetting .chbIsMultiSelectForAll").bind("change", function (evt) {
			GeneralSettingsAdmin.setMultiselectForAll(evt.currentTarget);
		});

		$(".AdminSetting .ddlFilterBehaviourForAll").bind("change", function (evt) {
			GeneralSettingsAdmin.setBehaviourForAll(evt.currentTarget);
		});

		$(".AdminSetting .ddlDefaultBehaviourForAll").bind("change", function (evt) {
			GeneralSettingsAdmin.setDefaultBehaviourForAll(evt.currentTarget);
		});

		$(".AdminSetting .ddlDynamicFilteringForAll").bind("change", function (evt) {
			if (Number($(evt.currentTarget).val()) > 0) GeneralSettingsAdmin.checkInMemory(evt);
			GeneralSettingsAdmin.setDynamicFilteringForAll(evt.currentTarget);
			GeneralSettingsAdmin.toggleMoveDisabledToBottom(evt.currentTarget);
		});

		$(".AdminSetting td.settingHFilterVsFilterBehavior select").bind("change", function (evt) {
			GeneralSettingsAdmin.updateHFilterVsFilterBehaviorForAllSelect(evt.currentTarget);
		});

		$(".AdminSetting .ddlHFilterVsFilterBehaviorForAll").bind("change", function (evt) {
			GeneralSettingsAdmin.setHFilterVsFilterBehaviorForAll(evt.currentTarget);
		});

		$('.AdminSetting #btnsSetupType > .DUIButton').bind('click', function() {
			if ($(this).hasClass('active')) return;

			var buttonEl = $(this);
			var inherit = buttonEl.is('[value="inherit"]');
			var adminSettingEl = buttonEl.closest('.AdminSetting');
			var adminSettingsChecked = adminSettingEl.find("#chbUseSetting").is(":checked");

			if (inherit && adminSettingsChecked) {
				GeneralSettingsAdmin.confirmInheritFromAnotherReport(function() {
					GeneralSettingsAdmin.setSetupType(buttonEl);
				});
			} else {
				GeneralSettingsAdmin.setSetupType(buttonEl);
			}
		});

		$('.AdminSetting #ddlSetupTypeInheritFromReport').bind('change', function() {
			GeneralSettingsAdmin.changeInheritedSettingsReport(this);
		});

		$("#btnSaveSettingsSetup").unbind("click").bind("click", function () {
			GeneralSettingsAdmin.saveSettings();
        });

		$("#btnHFilterSetupSave").unbind("click").bind("click", function (evt) {
          evt.stopPropagation()
			GeneralSettingsAdmin.saveHFilterSettings();
        });

        $("#btnExludeSlidesSetupSave").unbind("click").bind("click", function (evt) {
            evt.stopPropagation()
            GeneralSettingsAdmin.saveHFilterSlideExclusions(function() {
                DUImessage.show('Slide settings were saved successfully', 'Message-success', 5000);
            });
		});

		$('#btnRefDataSetupSave').unbind('click').bind('click', function (evt) {
			evt.stopPropagation()
			GeneralSettingsAdmin.saveRefDataSettings();
		});

		$("#bulkUploadsAndEditsContainer .DUI-Setup-close").bind("click", function (evt) {
            $("#bulkUploadsAndEditsContainer").css('display', 'none')
                .removeClass('excludeSlidesBulkEdit')
                .parent().removeClass('DUISetupOuter');
            $("#file-upload").val(null);
            $('#btn-template').attr('disabled', false);
            $("#btn-import").attr('disabled', true);
        });

        $("#btnHFilterSetupCancel, #hfilterSettingsSetupContainer .DUI-Setup-close").bind("click", function (evt) {
            GeneralSettingsAdmin.closeHFilterSettingsPanel(evt.currentTarget);
            restoreHFilterLevels();
            generalSettingsAdmin = null;
            hFilterLayoutAdmin = null;
            hFilterSelectionModeAdmin = null;
        });

        $("#btnExludeSlidesSetupCancel, #excludeSlidesSetupContainer .DUI-Setup-close").bind("click", function (evt) {
            if (hFilterSlideExclusionsUnsaved === false) {
                GeneralSettingsAdmin.closeExcludeSlidesPanel();
            } else {
                new DUIwindow2({
                    html: '<p class="Message Message-warning">You have made changes which are unsaved.</p>'+
                            '<p>Are you sure you want to close setup?</p>',
                    width: '360px',
                    preWrapSpace: false,
                    buttons: [
                        { text: 'Cancel', },
                        { text: 'Yes', focused: true, onClick: GeneralSettingsAdmin.closeExcludeSlidesPanel }
                    ]
                });
            }
		});

		$("#btnRefDataSetupCancel, #refDataSetupContainer .DUI-Setup-close").bind("click", function (evt) {
			GeneralSettingsAdmin.closeRefDataSettingsPanel();
		});

		$('input.chbRefSetBy').bind('change', GeneralSettingsAdmin.showHideMatchRefDataByHFType);

        $('#excludeSlidesBulkEdit').bind('click', function(evt) {
            if (hFilterSlideExclusionsUnsaved === false) {
                GeneralSettingsAdmin.openExcludeSlidesBulkEdit();
            } else {
                new DUIwindow2({
                    closeButton: false,
                    height: 'auto',
                    width: 460,
                    html: '<p class="Message Message-info">To use bulk edit node selections feature, the exclude slides by hierarchical filter settings need to be saved first.</p>'+
                            '<p>Do you want to save the settings now?</p>',
                    buttons: [{
                            text: locale.get("Cancel"),
                        }, {
                            text: locale.get('Save'),
                            focused: true,
                            onClick: function () {
                                GeneralSettingsAdmin.saveHFilterSlideExclusions(GeneralSettingsAdmin.openExcludeSlidesBulkEdit);
                            }
                        }
                    ]
                });
            }

            evt.stopPropagation();
        });

		$('#btnMultiEditSettings').bind('click', function (evt) {
			MultiEdit.MultiEditAsDialog();
			MultiEdit.SetupType("optional filters");
			MultiEdit.BindMultiEditValues();
		});

		$('#btnHFilterMultiEdit').bind('click', function (evt) {
			MultiEdit.MultiEditAsDialog();
			MultiEdit.SetupType("hierarchical filters");
			MultiEdit.BindMultiEditValues();
		});

		$(".addNewPeriodItem #btnAddNewPeriodItem").bind("click", function (evt) {
			GeneralSettingsAdmin.appendTimePeriodToOptionalFilters(evt.currentTarget);
		});

		let showHFilterMinMax = () => [Storyboard.Constants.HFilterLayouts.HFILTERLIST, Storyboard.Constants.HFilterLayouts.HFILTERTREE].includes(parseInt($("#lbHfilterLayoutType").val(), 10)) && $('#rHfSTMultiple').is(':checked');

		$("input:radio[name='rgHfilterSelectionMode']").bind('change', function () {
			$('#tblHFLevelNames td:nth-child(3), #tblHFLevelNames th:nth-child(3)').toggle($('#rHfSTAdvanced').is(':checked'))
			$(this).closest('.SettingsControl').find('.hfSelectionRange').toggle(showHFilterMinMax());
		});

		$("#lbHfilterLayoutType").bind("change", function (evt) {
			var hfilterLayout = parseInt($("#lbHfilterLayoutType").val(), 10);

			if(hfilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERMULTIBOX){
				// hide dynamic filtering controls
				var $dynamicFilteringProperties = $(evt.target).closest("#hfilterSetupContainerPanel").find("#dynamicFilteringProperties");
				$dynamicFilteringProperties.find("#ddlDynamicFilteringSetting").val(Storyboard.Constants.DynamicFilteringStatus.Off);
				$dynamicFilteringProperties.find("#cbDynamicFilteringMoveDisabledToBottom").removeAttr('checked');
				$dynamicFilteringProperties.css("display", "none");
			}
			else {
				// show dynamic filtering controls
				if($("#hfilterSetupContainerPanel").find("#chbUseSetting").is(":checked"))
					$(evt.target).closest("#hfilterSetupContainerPanel").find("#dynamicFilteringProperties").css("display", "block");
			}

			if (hfilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLISTPERLEVEL ||
				hfilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERMULTIBOX) {
                $(".hfilterLayoutAdvanced").show();
				$("#hfilterLevelNamesContainer").show();
            } else {
                $(".hfilterLayoutAdvanced").hide();
				$("#hfilterLevelNamesContainer").hide();
                if ($("input:radio[name='rgHfilterSelectionMode']:checked").val() === Storyboard.Constants.HFilterSelectionModes.ADVANCED)
                    $("input:radio[name='rgHfilterSelectionMode'][value='1']").attr('checked', 'checked');
			}

			$(this).closest('.SettingsControl').find('.hfSelectionRange').toggle(showHFilterMinMax());
			$('#hfilterNonSelectableMode').toggle(hfilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERTREE);
        });

        $("#hfilterSetupContainerPanel #chbUseSetting").bind("click", function() {
            $("#hfilterSetupContainerPanel .hfilterSetupLabel").toggle($(this).is(":checked"));
            $("#hfilterSetupContainerPanel #dynamicFilteringProperties").not(".reportDisabled").toggle($(this).is(":checked"));
		});

		$('#refDataSetupContainerPanel #chbEnableRefData').bind('click', GeneralSettingsAdmin.showHideRefDataSettings);
		$('input:radio[name="rbgLimitRefSets"]').bind('change', GeneralSettingsAdmin.showHideLimitRefDataSettings);
		$('#chbShowSpecificFilterSets').bind('change', GeneralSettingsAdmin.showHideSelectFilterSetsToShow);

        $("#btnSettingsCancel, #setupcontainer .DUI-Setup-close").bind("click", function (evt) {
            GeneralSettingsAdmin.closeSettingsPanel(evt.currentTarget);
            $('#setupTabsContainer').removeAttr('open-setting-type');
        });

		$(".hidSettingType[value=5]").parent(".header").children('#varSubsetsProperties').find('label .chbHasNoSelection').first().bind("change", function (evt) {
			$(this).parents(".AdminSetting").children(".items").children(".grdSettings").children("tbody").find("tr.settingItemInline .settingHasNoSelection input").each(function () {
				$(this).attr("checked", $(evt.currentTarget).is(":checked"));
				$(this).trigger("change");
			});
		});
	
		$(".hidSettingType[value=5]").parent(".header").children('#varSubsetsProperties').find('label .chbIsMultiSelect').first().bind("change", function (evt) {
			$(this).parents(".AdminSetting").children(".items").children(".grdSettings").children("tbody").find("tr.settingItemInline .settingIsMultiSelect input").each(function () {  
				$(this).attr("checked", $(evt.currentTarget).is(":checked"));
				$(this).trigger("change");
			});
		});

		$(".hidSettingType[value=5]").parent().children('.splitFilterBoxes').children('.chbIsMultiSelect').bind("click", function (evt) {
			if ($(this).is(':checked')) {
				var c = confirm("NOTE: RESULT FOR MULTIPLE FILTER SELECTION WITHIN A FILTER BOX CAN NOT BE PRE-GENERATED.\n\nWhen result is being pre-generated it can only be pre-generated for single Filter selection with one or multiple Filter boxes. As soon as multiple Filter options are selected within a Filter box the result will not be pre-generated.\n\nTip: If any specific combined Filter within a Filter box is needed create Grouped Answers to get the needed Filter options.");
				if (!c) {
					$(this).removeAttr('checked');
				}
			}
			GeneralSettingsAdmin.toggleMultiSelection(evt.currentTarget);
		});
		$(".chbSplitBoxes").bind("click", function (evt) {
			GeneralSettingsAdmin.toggleMultiSelection(evt.currentTarget);
			if ($(this).is(':checked')) {
				$(this).closest('.header').find("#varSubsetsProperties").hide();
				$(this).closest('.header').find("#globalSettingsFilter").hide();
				$(this).closest('.header').find("#divDynamicFilteringMoveDisabledToBottom").show();
				$(this).closest('.header').siblings('.items').find('.settingChkItemHide').show();
				$(this).closest('.header').siblings('.items').find('.settingChkAllowSeparateExport').show();
				$(this).closest('.header').siblings('.items').find('.settingHasNoSelection').show();
				$(this).closest('.header').siblings('.items').find('.settingIsMultiSelect').show();
				$(this).closest('.header').siblings('.items').find('.settingMinNoOfSelections').show();
				$(this).closest('.header').siblings('.items').find('.settingMaxNoOfSelections').show();
				$(this).closest('.header').siblings('.items').find('.settingBehaviour').show();
				$(this).closest('.header').siblings('.items').find('.settingDefaultCompare').show();
				$(this).closest('.header').siblings('.items').find('th.settingDynamicFiltering').show();
				if (Storyboard.HFilterLayout.isMultiSelect('#hfilterTree')) {
					$(this).closest('.header').siblings('.items').find('th.settingHFilterVsFilterBehavior').show();
					$(this).closest('.header').siblings('.items').find('.settingHFilterVsFilterBehavior select').show().parent().show();
				}
				$(this).closest('.header').siblings('.items').find('.settingSortOrderType').show();
				$(this).closest('.header').siblings('.items').find('.settingDynamicFiltering select').each(function () {
					var sdf = $(this);
					if (!sdf.hasClass('isInputVariable')) sdf.show().parent().show(); else sdf.parent().show();
				});
			}
			else {
				$(this).closest('.header').siblings('.items').find('.settingChkAllowSeparateExport').show();
				$(this).closest('.header').find("#varSubsetsProperties").show();
				$(this).closest('.header').find("#hfVsSubsetsBehavior").hide();
				$(this).closest('.header').find("#globalSettingsFilter").show();
				$(this).closest('.header').find("#divDynamicFilteringMoveDisabledToBottom").hide();
				$(this).closest('.header').siblings('.items').find('.settingChkItemHide').hide();
				$(this).closest('.header').siblings('.items').find('.settingHasNoSelection').hide();
				$(this).closest('.header').siblings('.items').find('.settingIsMultiSelect').hide();
				$(this).closest('.header').siblings('.items').find('.settingMinNoOfSelections').hide();
				$(this).closest('.header').siblings('.items').find('.settingMaxNoOfSelections').hide();
				$(this).closest('.header').siblings('.items').find('.settingBehaviour').hide();
				$(this).closest('.header').siblings('.items').find('.settingDefaultCompare').hide();
				$(this).closest('.header').siblings('.items').find('.settingSortOrderType').hide();
				$(this).closest('.header').siblings('.items').find('th.settingDynamicFiltering').hide();
				$(this).closest('.header').siblings('.items').find('.settingDynamicFiltering select').hide().parent().hide();
				$(this).closest('.header').siblings('.items').find('th.settingHFilterVsFilterBehavior').hide();
				$(this).closest('.header').siblings('.items').find('.settingHFilterVsFilterBehavior select').hide().parent().hide();
			}
		});
		$(".ddlFilterBehaviour").bind("change", function (evt) {
			GeneralSettingsAdmin.changeFilterBahaviour(evt.currentTarget);
			GeneralSettingsAdmin.updateBehaviourForAllSelect(evt.currentTarget);
		});
		$(".globalBehaviour").bind("change", function (evt) {
		   GeneralSettingsAdmin.changeGlobalBehaviour(evt.currentTarget);
		});
		$(".hidSettingType[value=1]").parent().find('#chbIsMultiSelect').bind("click", function (evt) {
			GeneralSettingsAdmin.toggleMultiSelection(evt.currentTarget);
		});

		$("#file-upload").bind("change", function(e){
          if($('#file-upload').val() != ''){
            importFile = e.target.files[0];

            $("#btn-import").attr("disabled", false)
          }
        });

        $("#btn-template").unbind("click").bind("click", function (evt) {
            if ($('#bulkUploadsAndEditsContainer').hasClass('excludeSlidesBulkEdit')) {
                GeneralSettingsAdmin.downloadHFilterSlideExclusionsTemplate(Helpers.getReportID());
            } else {
                GeneralSettingsAdmin.downloadHFilterSettingsTemplate(Helpers.getReportID());
            }
        });

        $("#btn-import").unbind("click").bind("click", function (evt) {
            if ($('#bulkUploadsAndEditsContainer').hasClass('excludeSlidesBulkEdit')) {
                GeneralSettingsAdmin.uploadHFilterSlideExclusionsTemplate(Helpers.getReportID(), importFile);
            } else {
                GeneralSettingsAdmin.uploadHFilterSettingsTemplate(Helpers.getReportID(), importFile);
            }
        });

		$("#ddlShownHFiltersType").bind("change", function () {
			$("li.DUITreeViewInlineMenuUncheckAll").trigger("click");
			$("#sbSettingHFilterTree li:not(.DUITreeViewInlineMenu) input").removeAttr("disabled");

          if ($("#ddlShownHFiltersType").val() != 2) {
        		$("#selectedNodes").css("display", "none");
          } else {
            $("#selectedNodes").css("display", "")
          }
			if ($("#ddlShownHFiltersType").val() == 1 || $("#ddlShownHFiltersType").val() == 3) {
				if ($("#ddlShownHFiltersType").val() == 1)
					$("li.DUITreeViewInlineMenuCheckAll").trigger("click");
				$("#sbSettingHFilterTree").css("visibility", "hidden");
			} else {
				$("#sbSettingHFilterTree").css("visibility", "visible");
				showHideHFilterQuickButtons();
			}
			$("#hFilterShownLevelsWrapper").css("display", $("#ddlShownHFiltersType").val() != 3 ? "none" : "");
          if($("#hFilterShownLevelsWrapper").css("display") === "none"){
            $("#sbSettingHFilterTree").css('height', '267px');
            $("#sbSettingHFilterTree").width('auto');
          } else {
            $("#sbSettingHFilterTree").css('height', '177px');
            $("#sbSettingHFilterTree").width('auto');
          }
		});
		var cbVsubset = $('.hidSettingType[type="hidden"][value="1"]').parent().find('#chbIsMultiSelect');
		GeneralSettingsAdmin.toggleMultiSelection(cbVsubset);

        $('#ddlExcludeSlides').bind('change', function() {
            Storyboard.GeneralSettings.clearEmptySlideExclusions();
            Storyboard.GeneralSettings.bindExcludeSlidesHFiltersAdmin();
        });
        $('#btnOpenGroupSlides').bind('click', function() {
            Storyboard.GeneralSettings.clearEmptySlideExclusions();
            GeneralSettingsAdmin.openGroupSlidesPopup();
        });
    }

    function unbindControls() {
        $(".AdminSetting .chbUseSetting").unbind();
        $(".AdminSetting .settingDefaultComp[type='radio']").unbind();
        $(".AdminSetting .chbIsSelected input").unbind();
        $(".AdminSetting .settingHasNoSelection input").unbind();
        $(".AdminSetting .settingDefaultSelection select").unbind();
        $(".AdminSetting .settingDynamicFiltering select").unbind();
        $(".AdminSetting .ddlDynamicFilteringSetting").unbind();
        $(".AdminSetting .settingIsMultiSelect input").unbind();
        $('.AdminSetting #btnsSetupType > .DUIButton').unbind();
        $('.AdminSetting #ddlSetupTypeInheritFromReport').unbind();
        $("#grdItems .checkAll").unbind();
        $("#btnSaveSettingsSetup").unbind();
        $("#btnHFilterSetupSave").unbind();
        $('#excludeSlidesBulkEdit').unbind();
		$("#btnExludeSlidesSetupSave").unbind();
		$("#btnRefDataSetupSave").unbind();
        $("#btnHFilterSetupCancel, #hfilterSettingsSetupContainer .DUI-Setup-close").unbind();
		$("#btnExludeSlidesSetupCancel, #excludeSlidesSetupContainer .DUI-Setup-close").unbind();
		$("#btnRefDataSetupCancel, #refDataSetupContainer .DUI-Setup-close").unbind();
        $('#btnMultiEditSettings').unbind();
        $('#btnHFilterMultiEdit').unbind();
        $(".addNewPeriodItem #btnAddNewPeriodItem").unbind();
        $("input:radio[name='rgHfilterSelectionMode']").unbind();
        $("#lbHfilterLayoutType").unbind();
        $("#btnSettingsCancel, #setupcontainer .DUI-Setup-close").unbind();
        $(".hidSettingType[value=5]").parent(".header").children('#varSubsetsProperties').find('label .chbHasNoSelection').first().unbind();
        $(".hidSettingType[value=5]").parent(".header").children('#varSubsetsProperties').find('label .chbIsMultiSelect').first().unbind();
        $(".hidSettingType[value=5]").parent().children('.splitFilterBoxes').children('.chbIsMultiSelect').unbind();
        $(".chbSplitBoxes").unbind();
        $(".ddlFilterBehaviour").unbind();
        $(".globalBehaviour").unbind();
        $(".hidSettingType[value=1]").parent().children('.splitFilterBoxes').children('.chbIsMultiSelect').unbind();
        $("#ddlShownHFiltersType").unbind();
        $('#ddlExcludeSlides').unbind();
        $('#btnOpenGroupSlides').unbind();
    }

	function showHideHFilterQuickButtons() {
		$("#sbSettingHFilterTree .DUITreeViewInlineMenu li").show();
		if ($("#ddlShownHFiltersType").val() == 4) {
			$("#sbSettingHFilterTree .DUITreeViewInlineMenu li").hide();
			$("li.DUITreeViewInlineMenuUncheckAll, li.DUITreeViewInlineMenuCheckLevel, li.DUITreeViewInlineMenuCheckSiblings").show();
		}
	}

	function saveSettings(storyboardSettings) {
		Storyboard.LayoutDesigner.destroyExportPanel();
		var params = {
			method: "SaveSettings",
			data: { storyboardSettings: storyboardSettings },
			message: "Saving settings",
			successCallback: saveSettingsCallback,
			service: "GeneralSettings"
		};
		Helpers.perfJSonCall(params);
	}

	function getSetting(setting, isHfilter) {
		if (setting.parent().hasClass("SettingsSetupControlTemplate"))
			return null;

		var storyboardSetting = {};
		storyboardSetting.name = setting.find("#txtName").val();
		storyboardSetting.showSetting = setting.find("#chbUseSetting").is(":checked");
		storyboardSetting.isSplitBoxes = setting.find("#chbSplitBoxes").is(":checked");
		storyboardSetting.settingType = parseInt(setting.find(".hidSettingType").val(), 10);
		storyboardSetting.isMultiSelect = setting.find("#chbIsMultiSelect").is(":checked");
		storyboardSetting.minNoOfSelections = isHfilter ? setting.find("#hfMinNoOfSelections").val() : setting.find("#vsMinNoOfSelections").val();
		storyboardSetting.maxNoOfSelections = isHfilter ? setting.find("#hfMaxNoOfSelections").val() : setting.find("#vsMaxNoOfSelections").val();
		storyboardSetting.hasNoSelection = setting.find("#chbHasNoSelection").is(":checked");
		storyboardSetting.NestCompare = setting.find("#cbNestCompareSeries").is(":checked");
		storyboardSetting.DynamicFiltering = setting.find("#ddlDynamicFilteringSetting").val() || 0;
		storyboardSetting.DynamicFilteringMoveDisabledToBottom = setting.find("#cbDynamicFilteringMoveDisabledToBottom").is(":checked");
		storyboardSetting.MaxCompareSeries = setting.find("#txtMaxCompareSeries").val() || 0;
		storyboardSetting.FilterBehaviour = setting.find('#ddlGlobalBehaviour option:selected').val();
		storyboardSetting.DefaultBehaviour = setting.find('#ddlGlobalDefaultBehaviour option:selected').val() == "1";
		storyboardSetting.hFilterVsSubsetsBehavior = setting.find('input[name="optHFilterVsSubsetsBehavior"]:checked').val() || 2;
		storyboardSetting.availableRefDataSetsType = 0;
		storyboardSetting.autoSelectInterval = setting.find('input.chbAutoSelectIntervalForTp').is(':checked') || false;
		
		var inheritSetting = setting.find('#btnsSetupType > button[value="inherit"]').hasClass('active');
		var inheritFromReportId = parseInt(setting.find('#ddlSetupTypeInheritFromReport').val(), 10);
		storyboardSetting.inheritedSettingsReportId = inheritSetting && inheritFromReportId > 0 ? inheritFromReportId : null;

		var $dateVariableSection = setting.find('.dateVariablesSection');

		if ($dateVariableSection.length)
		{
			storyboardSetting.AllowDateVariables = $dateVariableSection.find('#chbAllowDateVariablesSelection').is(':checked');
			storyboardSetting.DateVariablesName = $dateVariableSection.find('#txtDateVariablesName').val();
			storyboardSetting.DateVariables = [];
			$dateVariableSection.find('.dateVariablesItems tr[data-datevariableid]').each(function () {
				storyboardSetting.DateVariables.push({
					DateVariableId: parseInt($(this).attr('data-dateVariableId')),
					Text: $(this).find('label[for^="chbDateVariable_"]').html(),
					IsSelected: $(this).find('input[id^="chbDateVariable_"]').is(':checked'),
					IsDefault: $(this).find('input[id^="chbDateVariableDefault_"]').is(':checked')
				});
			});
		}

	    storyboardSetting.EnabledLevels = [];
	    if (storyboardSetting.settingType == 6) {
			storyboardSetting.ShownHFiltersType = $("#ddlShownHFiltersType").val();
			storyboardSetting.HideNonSelectableHFLevels = $('#rHFNonSelectableHide').is(':checked');
	    	$("input.shownHFilterLevel").each(function () {
			    if ($(this).is(":checked")) storyboardSetting.EnabledLevels.push($(this).val());
		    });
	    }

		var tree = setting.find('ul.DUITreeView');
		if (tree.length > 0) {
			storyboardSetting.settingItems = getSettingItemsHfilterTree(tree);
		} else {
			storyboardSetting.settingItems = getSettingItems(setting.find("#grdItems"), storyboardSetting);
		}

		return storyboardSetting;
	}

	function saveSettingsCallback(data) {
		var isChartCreator = window.ContentType > 0 && window.ContentType == Storyboard.Constants.itemTypes.CHART;
		var isCT2 = window.ContentType > 0 && window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE;
		if(!(isChartCreator || isCT2))
			loadFavoriteSettings();

		var hfilterLayout = parseInt($("#lbHfilterLayoutType").val(), 10);
		bindGeneralSettings(data, hfilterLayout);
		Storyboard.ReferenceDataFiltering.showHideRefDataSets(true);

		var hfilterSelectionMode = parseInt($("input:radio[name='rgHfilterSelectionMode']:checked").val(), 10);
		Storyboard.LayoutDesigner.setHFilterLayoutAndReload(hfilterLayout, hfilterSelectionMode);
		if (isChartCreator) {
            ChartCreatorSetup.loadContentForDeckSettings();
		}

		generalSettingsAdmin = null;
		Storyboard.EventBus.emit(Storyboard.Constants.Events.GENERAL_SETTINGS_SAVED);

		$.when(Storyboard.GeneralSettings.loadDefaultOptionalFilters())
			.done(function (settings) {
				sessionStorage.setItem('defaultOptionalFiltersSelection', JSON.stringify(settings.d));
			})
	}

	function saveHFilterSettings(storyboardSettings) {

		if (!storyboardSettings) {
			storyboardSettings = [];
			$("#hfilterSetupContainerPanel .AdminSetting").first().each(function () {
				var storyboardSetting = getSetting($(this), true);

				if (storyboardSetting && storyboardSetting.settingItems.length > 0)
					storyboardSettings.push(storyboardSetting);
			});
        }
		
		var hfLayout = parseInt($("#lbHfilterLayoutType").val(), 10);
		var hfLayoutSelectMode = parseInt($("input:radio[name='rgHfilterSelectionMode']:checked").val(), 10);
		// remove export panel to recreate later with correct layout and nodes
		Storyboard.LayoutDesigner.destroyExportPanel();

		Storyboard.LayoutDesigner.setHFilterLayoutVariable(hfLayout);
		Storyboard.LayoutDesigner.setHFilterSelectionModeVariable(hfLayoutSelectMode);
		var isChartCreator = window.ContentType > 0 && window.ContentType == Storyboard.Constants.itemTypes.CHART;
		var hfToSelect = isChartCreator ? ChartCreatorUIObj.GetSelectedHFilters() : [];

		var params = {
			method: "SaveHFilterSettings",
			data: {
				hFilterSetting: storyboardSettings,
				hfLayout: hfLayout,
				hfSelectMode: hfLayoutSelectMode,
				hfLevelSettings: getHFilterLevels(),
				hfToSelect: hfToSelect
			},
			message: "Saving settings",
			successCallback: saveSettingsCallback,
			service: "GeneralSettings"
		};
		Helpers.perfJSonCall(params);
	}

    function saveHFilterSlideExclusions(callback) {
        hFilterSlideExclusions = hFilterSlideExclusions.filter(function(dataObject) {
            return dataObject.SlideIDs.length > 0;
        });
        Helpers.perfJSonCall({
            service: "GeneralSettings",
            method: "SaveHFilterSlideExclusions",
            data: {
                hFilterSlideExlusions: hFilterSlideExclusions
            },
            message: "Saving settings",
            successCallback: function() {
                Storyboard.LayoutDesigner.hfilterSlideExclusionEnabled = true;
                loadHFilterSlideExclusions(callback, false);
            }
        });
	}

	function saveRefDataSettings() {
		Helpers.perfJSonCall({
			method: 'SaveRefDataSettings',
			data: {
				refDataSetting: getRefDataSettings()
			},
			service: 'GeneralSettings',
			message: 'Saving settings',
			successCallback: function (data) {
				refDataSettingsAdmin = null;
				GeneralSettingsAdmin.closeRefDataSettingsPanel();
				saveSettingsCallback(data);
			}
		});
	}

	function getRefDataSettings() {
		var refDataSetting = {
			name: $('#txtRefDataName').val(),
			showSetting: $('#chbEnableRefData').is(':checked'),
			settingItems: [],
			settingType: Storyboard.Constants.SettingTypes.RefDataFilter,
			hasNoSelection: $('#refDataAddNoSelection').is(':checked'),
			availableRefDataSetsType: $('#rbShowAllRefSets').is(':checked') ? 0 : HTMLHelpers.getBitFlags('.chbRefSetBy'),
			refSetHFilterMatchType: $('input[name=rbgMatchRefDataByHFType]:checked').val() || 1
		};

		$('#refDataSetupContainerPanel .refDataCategoryAdmin').each(function () {
			var categoryBox = $(this);
			
			var category = {
				displayId: categoryBox.find('#hidRefDataCategoryDisplayId').val(),
				name: categoryBox.find('#refDataCategoryNameAdmin').text(),
				subItems: [],
				alwaysShowChildren: categoryBox.find('#refDataIncludeAllFilterSets').is(':checked')
			};

			if (category.alwaysShowChildren)
				category.attributes = Storyboard.Constants.Attributes.IsUserEnabled;

			$('#tblRefDataFilterSets tr td input', categoryBox).each(function () {
				var filterSetChb = $(this);
				var filterSet = {
					displayId: filterSetChb.val(),
					name: filterSetChb.closest('tr').find('td label').text()
				};

				if (filterSetChb.is(':checked')) {
					filterSet.attributes = Storyboard.Constants.Attributes.IsUserEnabled;
					filterSet.excludeFromLimiting = $('#ddlRefDataAlwaysShownSets option[value="' + filterSet.displayId + '"]:selected').length === 1;
					category.attributes = Storyboard.Constants.Attributes.IsUserEnabled;
				}
				category.subItems.push(filterSet);
			});

			refDataSetting.settingItems.push(category);
		});

		return refDataSetting;
	}

	function getStoryBoardAccess() {
		Helpers.perfJSonCall({
			type: "POST",
			method: "GetStoryBoardAccess",
			synchronous: true,
			successCallback: function (result) {
				storyBoardAccess = result;
				sb.GeneralSettings.storyBoardAccess = storyBoardAccess;
			}
		});
	}

	function getHFilterLevels() {
		var hfLevels = [];

		var tableId = "tblHFLevelNames", rowTemplateClass = "hfLevelNameTemplateRow";

		$("#" + tableId + " > tbody > .levelNameRow:not('." + rowTemplateClass + "')").each(function () {
			var level = {
				name: $(this).find("#txtHFLevel").val(),
				selectMode: parseInt($(this).find("select").val()),
				reportId: Helpers.getReportID(),
				depth: $(this).find("#hidDepth").val()
			};

			hfLevels.push(level);
		});

		hfLevelSettings = hfLevels;

		return hfLevelSettings;
	}

	function restoreHFilterLevels() {
		var tableId = "tblHFLevelNames", rowTemplateClass = "hfLevelNameTemplateRow";
		$("#" + tableId + " > tbody > .levelNameRow:not('." + rowTemplateClass + "')").remove();

		var rowTemplate = $("." + rowTemplateClass);
		rowTemplate.show();

		$(hfLevelSettings).each(function () {
			var newRow = rowTemplate.clone();
			newRow.removeClass(rowTemplateClass);
			$("#" + tableId + " > tbody:last").append(newRow);
			if (newRow.index() == 1)
				newRow.find("label").text("Level 1 and 2");
			else
				newRow.find("label").text("Level " + (newRow.index() + 1));
			newRow.find("#txtHFLevel").val(this.Name);
			newRow.find("#hidDepth").val(this.Depth);
			newRow.find("select").val(this.SelectMode);
		});

		rowTemplate.hide();
	}

	function getSettingItemsHfilterTree(tree) {
		var settingItems = [];
		var admin = tree.attr("id") == "sbSettingHFilterTree";
		var filters = admin ? Storyboard.GeneralSettings.hFiltersAdmin : Storyboard.GeneralSettings.hFilters;
		var mode = $("#ddlShownHFiltersType").val();

		for (var i in filters) {
			var item = filters[i];
			var obj = {};
			obj.displayID = item.DisplayID;
			if (mode == 3) { // levels
				if ($("#cbShownHFilterLevel" + item.HFilterLevel).is(":checked")) {
					obj.Attributes = Storyboard.Constants.Attributes.IsUserEnabled;
				}
			} else {
				obj.Attributes = item.Attributes;
			}

			obj.AlwaysShowChildren = mode == 4 && item.AlwaysShowChildren;
			obj.AlwaysShowLevelBelow = item.AlwaysShowLevelBelow;
			obj.AlwaysShowParents = item.AlwaysShowParents;
			obj.AlwaysShowSiblings = item.AlwaysShowSiblings;
			settingItems.push(obj);
		}

		return settingItems;
	}

	function getSettingItems(settingGrid, storyboardSetting) {
		var settingItems = [];

		var sortorder = 0;
		settingGrid.find("> tbody > tr").each(function () {
			var settingItem = $(this);

			if (!settingItem.hasClass("settingItemTemplate") && !settingItem.hasClass("settingHeaderTemplate")) {
				var setting = {};
				setting.displayID = settingItem.find("#hidSettingDisplayID").val();

				if (settingItem.find("#chbIsSelected").is(":checked"))
					setting.Attributes |= Storyboard.Constants.Attributes.IsUserEnabled;
				else
					setting.Attributes &= ~Storyboard.Constants.Attributes.IsUserEnabled;

				var isDefault = false;
				if (storyboardSetting.isMultiSelect && storyboardSetting.settingType !== FILTER_SETTING)
					isDefault = settingItem.find("#chbDefault").is(":checked");
				else
					isDefault = settingItem.find("#rdbDefault").is(":checked");



				if (storyboardSetting.settingType === FILTER_SETTING) {
					setting.HasNoSelection = settingItem.find('#cbFHasNoSelection').is(':checked');
					setting.UseAsMultiSelect = settingItem.find('#cbFIsMultiSelect').is(':checked');
					setting.MinNoOfSelections = settingItem.find('#minNoOfSelections').val() || null;
					setting.MaxNoOfSelections = settingItem.find('#maxNoOfSelections').val() || null;
					setting.FilterBehaviour = settingItem.find('#ddlFilterBehaviour option:selected').val();
					setting.DefaultBehaviour = settingItem.find('#ddlDefaultBehaviour option:selected').val() == "1";
					setting.SortOrderType = settingItem.find('#ddlSortOrderType option:selected').val() || 0;
					setting.DynamicFiltering = settingItem.find('#ddlDynamicFiltering option:selected').val();
					setting.HFilterVsFilterBehavior = settingItem.find('#ddlHFilterVsFilterBehavior option:selected').val();

					var defaultSelectionArray = [];
					settingItem.find("select[id*='ddlDefaultSelection'] option:selected").each(function () {
						defaultSelectionArray.push($(this).val());
					});

					setting.DefaultSelection = ~defaultSelectionArray.indexOf('0-2') ? '0-2' : defaultSelectionArray.join();
					setting.IsHidden = settingItem.find('#chbHide').is(':checked');
					setting.UseDynamicWeighting = settingItem.find('#chbDynamicWeighting').is(":checked");
					setting.AllowSeparateExport = settingItem.find('#chbAllowSeparateExport').is(":checked");

					if (setting.DefaultSelection != "" && setting.DefaultSelection != "undefined" && setting.DefaultSelection != null)
						isDefault = true;
				}
				else {
					setting.HasNoSelection = false;
					setting.UseAsMultiSelect = false;
					setting.FilterBehaviour = 1;
					setting.DefaultBehaviour = false;
					setting.DefaultSelection = 0;
					setting.IsHidden = false;
				}

				if (isDefault)
					setting.Attributes |= Storyboard.Constants.Attributes.IsDefaultSelected;
				else
					setting.Attributes &= ~Storyboard.Constants.Attributes.IsDefaultSelected;

				setting.name = settingItem.find(".itemDisplayName").text();
				setting.sortOrder = sortorder++;
				setting.subItems = [];

				settingItems.push(setting);
			}
		});
		if (storyboardSetting.settingType == 3) ///3 is Floating Time Period
			settingItems = injectTimePeriod(settingGrid, settingItems);

		return settingItems;
	}


	function injectTimePeriod(settingGrid, settingItems) {
		var timePeriodSpanItem;
		var newItem;
		var timePeriodSettingItem = $(settingItems).filter(function () {
			return this.displayID == "27";
		});

		if (timePeriodSettingItem.length != 0 && timePeriodSettingItem[0].Attributes > 0) {
			$(settingGrid).find('table.selectDatePeriodTable').not(':first').find('tr').not(':first').each(function (i) {
				var isDefault = $(this).find("#rdbDefault").is(':checked');
				newItem = {};
				newItem.name = "Last" + " " +$(this).find('.periodNumber').val() + " " + $(this).find('.periodType :selected').text().trim();
				newItem.isDefault = isDefault ? "1" : "0";
				newItem.DefaultSelection = newItem.isDefault;
				newItem.timePeriodSpan = $(this).find('.periodType :selected').val();
				newItem.timePeriodSpanAmount = $(this).find('.periodNumber').val() || 1;
				newItem.displayID = $(this).find('.ofSettingDisplayID').val();
				newItem.isSelected = "1";
				if (isDefault)
					newItem.Attributes |= Storyboard.Constants.Attributes.IsDefaultSelected;
				else
					newItem.Attributes &= ~Storyboard.Constants.Attributes.IsDefaultSelected;

				settingItems.push(newItem);
			});
		}

		// prepared time periods (week/month/quarter/etc)
		var preparedPeriodSettingItem = $(settingItems).filter(function () {
			return this.displayID == "-3";
		});
		if (preparedPeriodSettingItem.length != 0) {
			var selected = $(settingGrid).find('.tblPreparedPeriodSettings').not(':first').find('input.chbPreparedPeriodType:checked').length > 0;
			if (selected)
				preparedPeriodSettingItem[0].Attributes |= Storyboard.Constants.Attributes.IsUserEnabled;
			else
				preparedPeriodSettingItem[0].Attributes &= ~Storyboard.Constants.Attributes.IsUserEnabled;

			if (preparedPeriodSettingItem[0].Attributes > 0) {
				$(settingGrid).find('.tblPreparedPeriodSettings').not(':first').find('tr').each(function () {
					var isSelected = $(this).find('input.chbPreparedPeriodType').is(':checked');
					if (isSelected) {
						var isDefault = $(this).find("#rdbDefault").is(':checked');

						newItem = {};
						newItem.name = $(this).find('td.tdPreparedPeriodText').text().trim() ;
						newItem.isDefault = isDefault ? '1' : '0';
						newItem.defaultSelection = newItem.isDefault;
						newItem.isSelected = "1";
						newItem.prepPeriodType = $(this).find('input.chbPreparedPeriodType').val();
						newItem.sortOrder = 1;
						if (isDefault) {
							preparedPeriodSettingItem[0].Attributes &= ~Storyboard.Constants.Attributes.IsDefaultSelected;
							newItem.Attributes |= Storyboard.Constants.Attributes.IsDefaultSelected;
						} else
							newItem.Attributes &= ~Storyboard.Constants.Attributes.IsDefaultSelected;

						settingItems.push(newItem);
					}
				});
			}
		}

		//Start and stop date items
		timePeriodSpanItem = $(settingItems).filter(function () {
			return this.displayID == "0";
		});

		if (timePeriodSpanItem.length != 0 && timePeriodSpanItem[0].Attributes > 0) {
			newItem = {};
			newItem.name = "Date range";
			newItem.isDefault = "0";
			newItem.DefaultSelection = newItem.isDefault;
			newItem.startDate = $(settingGrid).find("#hidSettingDisplayID[value='0']").closest(".settingItem").find('.startDate').val();
			newItem.stopDate = $(settingGrid).find("#hidSettingDisplayID[value='0']").closest(".settingItem").find('.stopDate').val();
			newItem.IsDatePeriod = true;
			//newItem.displayID = $(this).find('.ofSettingDisplayID').val();
			newItem.isSelected = "1";
			newItem.Attributes |= Storyboard.Constants.Attributes.IsDefaultSelected;
			newItem.dateFormat = getCurrentDateFormat().replace("yy", "yyyy").replace("mm","MM");
			settingItems.push(newItem);
		}

		//Start and stop date items
		timePeriodSpanItem = $(settingItems).filter(function () {
			return this.displayID == "-2";
		});

		if (timePeriodSpanItem.length != 0 && timePeriodSpanItem[0].Attributes > 0) {
			newItem = {};
			newItem.name = "Calendar control...";
			newItem.isDefault = "0";
			newItem.DefaultSelection = newItem.isDefault;
			newItem.startDate = $(settingGrid).find("#hidSettingDisplayID[value='-2']").closest(".settingItem").find('.startDate').val();
			newItem.stopDate = $(settingGrid).find("#hidSettingDisplayID[value='-2']").closest(".settingItem").find('.stopDate').val();
			newItem.IsDatePeriod = false;
			newItem.isSelected = "1";
			newItem.IsDynamic = true;
			newItem.dateFormat = getCurrentDateFormat().replace("yy", "yyyy").replace("mm", "MM");
			settingItems.push(newItem);
		}

		return settingItems;
	}

	function initializeResetFiltersButton() {

		if (Storyboard.LayoutDesigner?.useAutoUpdate) {
			$('#btnUpdateCharts').hide();
		}

		if ($('#resetOptionalFilterButton').length > 0) return;

		var numberOfOptionalFilters = $('#pnlSettingsPanel > .SettingsControl').length;
		var isHFilterPresent = $('#hfilterTree').is(':visible');
		if (isHFilterPresent == 0 && numberOfOptionalFilters == 0) {
			$('#resetOptionalFilterButton').remove();
			return;
		}

		if ($('#btnUpdateCharts').length > 0) {
			$('#btnUpdateCharts').parent().prepend('<div id="resetOptionalFilter"></div>');

			$('#resetOptionalFilter').
				append('<button type="button" id="resetOptionalFilterButton" title="' + locale.get('Reset Optional Filters to Default') + '"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="28"><path fill="#121821" fill-opacity=".6" d="M11.35 8.35A7.958 7.958 0 0 1 17 6a8 8 0 1 1 0 16c-3.73 0-6.84-2.55-7.73-6h2.08c.82 2.33 3.04 4 5.65 4a6 6 0 1 0 0-12c-1.66 0-3.14.69-4.22 1.78L16 13H9V6l2.35 2.35Z"/></svg></button>');

			$('#resetOptionalFilterButton').click(function () {

				$.when(
					Storyboard.GeneralSettings.loadDefaultOptionalFilters())
					.done(function (defaultOptionalFilters) {
						Storyboard.GeneralSettings.bindGeneralSettings(defaultOptionalFilters.d, Storyboard.LayoutDesigner.getHFilterLayout(), null, null, true);
						if (Storyboard.LayoutDesigner.getHFilterLayout() && Storyboard.LayoutDesigner.getHFilterSelectionMode()) {
							$(document).trigger('DAPI.hFilterLoaded');
						}
						GeneralSettings.getFiltersConnectedToHFilters();
					})

				Storyboard.LayoutDesigner.autoUpdateLayoutElements();
			});
		}
	}

	function initializeFavoriteSettings() {

		if ($('#favoriteSettings').length > 0) {
			return false;
		}

		$('#btnUpdateCharts').parent().prepend('<div id="favoriteSettings"></div>');

		$('#favoriteSettings').
			append('<button type="button" id="imgSaveFavoriteSetting" title="' + locale.get('Add favorite') +'"><img src="images/favorite_add.png"/></button>');
		$('#favoriteSettings').
			append('<button type="button" id="imgShowFavoriteSettings" title="' +locale.get('View favorites') +'"><img src="images/favorites.png"/></button>');

		loadFavoriteSettings();

		$('#imgSaveFavoriteSetting').click(function (event) {
			saveFavoriteSettingEventHandler(event);
		});


		$("#imgShowFavoriteSettings").click(function () {
			displayShowFavoriteSettingPopup();
		});
	}

	function deinitializeFavoriteSettings() {
		$('#favoriteSettings').remove();
	}

	function loadFavoriteSettings() {

		var reportId = Helpers.getReportID();

		var params = {
			method: "GetFavoriteSettings",
			message: locale.get("Loading..."),
			data: {
				reportId: reportId
			},
			successCallback: function (result) {
				favoriteSettings = result;
				favoriteSettings.sort(SortByName);
			},
			service: "GeneralSettings"
		};
		Helpers.perfJSonCall(params);
	}

	function restoreSettingsState(favoriteSettingId) {

		var favoriteSetting = $.grep(favoriteSettings, function (e) {
			return e.FavoriteSettingID == favoriteSettingId;
		});

		var favoriteSettingItems = {};
		favoriteSettingItems = favoriteSetting[0].StoryboardFavoriteSettingItems;

		var favoriteSettingsNonHFilterItems = $.grep(favoriteSettingItems, function (e) {
			return e.TypeID !== 6;
		});

		var favoriteSettingsHFilterItem = $.grep(favoriteSettingItems, function (e) {
			return e.TypeID === 6;
		});

		for (var i = 0; i < favoriteSettingsNonHFilterItems.length; i++) {

			var favoriteSettingItem = favoriteSettingItems[i];

			if (favoriteSettingItem.TypeID === 1 && favoriteSettingsHFilterItem.length === 0) {
				restoreVariableSubsetState(favoriteSettingItem);
			}
			else {
				restoreGenericOptionalSettingStateFromFavorite(favoriteSettingItem);
			}
		}

		// No hFilter settings -> click the 'Update' button immediately.
		if (favoriteSettingsHFilterItem.length === 0) {
			if (Storyboard.DynamicFiltering.isEnabled()) {
				$.when(Storyboard.DynamicFiltering.reportLoadDynamicFiltering()).then(function () { $('#btnUpdateCharts').click(); });
			}
			else {
				$('#btnUpdateCharts').click();
			}
		} else {
			var fVarsubsetItem = $.grep(favoriteSettingItems, function (e) { return e.TypeID === 1; });
			restoreHFilterState(favoriteSettingsHFilterItem[0], fVarsubsetItem.length > 0 ? fVarsubsetItem[0] : null);
		}
	}

	function restoreVariableSubsetState(favoriteSettingItem) {
		
		var selectedValues = (favoriteSettingItem.SettingSelection ? favoriteSettingItem.SettingSelection : favoriteSettingItem.SelectedSettings).split(',');
		$('#lbSetting_1').val('');

		for (var i = 0; i < selectedValues.length; i++) {

			$('#lbSetting_1').find('option[value="' +
				selectedValues[i] + '"]').attr('selected', true);
		}

		$('#lbSetting_1').multiselect('refresh');
	}

	function restoreHFilterState(favoriteSettingItem, varSubsetItem) {
		if (Storyboard.DynamicFiltering.isEnabled()) {
			refreshHFilter(favoriteSettingItem.SettingSelection, varSubsetItem, function () {
					$.when(Storyboard.DynamicFiltering.reportLoadDynamicFiltering()).then(function () { $('#btnUpdateCharts').click(); });
			});
		}
		else {
			refreshHFilter(favoriteSettingItem.SettingSelection);
		}
		
	}

	function enableInMemory() {
		var params = {
			method: "enableInMemory",
			data: {},
			message: locale.get("Loading..."),
			successCallback: function (data) {
				return data.d;
			},
			service: "GeneralSettings"
		};
		Helpers.perfJSonCall(params);
	}

	function projectNotUsingInMemory(callback) {
		var params = {
			method: "checkIfProjectUsingInMemory",
			data: {},
			message: locale.get("Loading..."),
			successCallback: function (data) {
				if (!data) callback();
			},
			service: "GeneralSettings"
		};
		Helpers.perfJSonCall(params);
	}

	function refreshHFilter(selectedHFilterIDs, varSubsetItem, dynamicFilteringCallback) {

		var params = {
			method: "SetSelectedHFilters",
			data: {
				selectedHFilterIDs: selectedHFilterIDs
			},
			message: locale.get("Loading Filters..."),
			successCallback: function () {
				var hFilterLayout = Storyboard.LayoutDesigner.getHFilterLayout();
				var hFilterSelectionMode = Storyboard.LayoutDesigner.getHFilterSelectionMode();
				
				var data = null;
				var url;
				if (hFilterLayout === Storyboard.Constants.HFilterLayouts.HFILTERLIST) {
					data = { startIndex: 0, forceAll: false };
					url = "RHViewStoryboard.aspx/GetHFiltersForList";
				} else
					url = "RHViewStoryboard.aspx/GetHFilters";

				Helpers.performJSonCall(url, data, function (hfilters) {
					if (varSubsetItem && Storyboard.GeneralSettings.hfilterVsVarSubsetActive) {
						favSettingsRestoreInProgress = true;
						$(document).bind("varSubsetCallbackFinished", function () {
							if (favSettingsRestoreInProgress) {
								restoreVariableSubsetState(varSubsetItem);
								$('#btnUpdateCharts').click();
								favSettingsRestoreInProgress = false;
							}
						});
					}

					GeneralSettings.loadHFilter(hFilterLayout, hfilters);
					GeneralSettings.reloadHFilter(hFilterLayout, hFilterSelectionMode);

					if (!varSubsetItem || !Storyboard.GeneralSettings.hfilterVsVarSubsetActive)
						dynamicFilteringCallback ? dynamicFilteringCallback() : $('#btnUpdateCharts').click();
				}, null, true);                
			},
			service: "GeneralSettings"
		};

		Helpers.perfJSonCall(params);
	}

	function restoreGenericOptionalSettingState(favoriteSettingItem) {

		var selectedValue = '';
		var typeId = favoriteSettingItem.TypeID ? favoriteSettingItem.TypeID : favoriteSettingItem.SettingType;

		var listBoxIdPrefix = 'lbSetting_' + typeId;
		var $lstBoxes = $('select[id^="' + listBoxIdPrefix + '"]');
  
		$lstBoxes.find("option:selected").removeAttr("selected"); // remove previous selection
		$lstBoxes.find('option[value="0-0"]').attr('selected', true); // set all on 'no selection'
		$lstBoxes.multiselect('refresh');
		var selectedValues = (favoriteSettingItem.SettingSelection ? favoriteSettingItem.SettingSelection : favoriteSettingItem.SelectedSettings).split(',');
	
		var valuesForSelect = $.grep(selectedValues, function (a) { return a.lastIndexOf('0-0') !== 0; });

		for (var i = 0; i < valuesForSelect.length; i++) {
			selectedValue = valuesForSelect[i];

			var addCompare = false;

			if (typeId == 5) {

				// Filter - trim 'add compare' substring
				addCompare = selectedValue.charAt(selectedValue.length - 1) == "1";
				selectedValue = selectedValue.substr(0, selectedValue.length - 2);
				var filterId = selectedValue.split("-")[0];

				var $currentCompareSpan = $("#" + listBoxIdPrefix + '_' + filterId).
					parent().find('span[id^="spanCompare"]:visible').first();

				if ($currentCompareSpan.length > 0) {
					if (addCompare) {
						$currentCompareSpan.find("input:radio[value='1']").
							attr('checked', true);
					}
					else {
						$currentCompareSpan.find("input:radio[value='0']").
							attr('checked', true);
					}
				}
			} else if (typeId == 3) {
				var settingControl = $lstBoxes.closest(".SettingsControl");
				settingControl.find("select").change();
				if (favoriteSettingItem.SelectedSettings === "-2") { // select start and stop date
					settingControl.find(".selectOptDateSelection").show();
					//translate controls
					settingControl.find("#lblStartDate").text(locale.get("Start date:"));
					settingControl.find("#lblEndDate").text(locale.get("Stop date:"));
					settingControl.find(".optCustomPeriodStart").datepicker('setDate', new Date(favoriteSettingItem.StartDate));
					settingControl.find(".optCustomPeriodEnd").datepicker('setDate', new Date(favoriteSettingItem.EndDate));
				} else
					settingControl.find(".selectOptDateSelection").hide();
			}

			$lstBoxes.each(function () {
				var $currentListBox = $(this);
				if (selectedValue != '0-0' && $currentListBox.find('option[value="' + selectedValue + '"]').length > 0) {
					// if has value, remove 'no selection' and set value
					$currentListBox.find('option[value="0-0"]').attr('selected', false);
					$currentListBox.find('option[value="' + selectedValue + '"]').attr('selected', true);
				}
			});
		}

		$lstBoxes.each(function () {
			if (this.length === 0) {
				this.find('option[value="0-0"]').attr('selected', true);
			}
			$(this).multiselect('refresh');
		});
	}

	function restoreGenericOptionalSettingStateFromFavorite(favoriteSettingItem) {

		var selectedValue = '';
		var typeId = favoriteSettingItem.TypeID ? favoriteSettingItem.TypeID : favoriteSettingItem.SettingType;

		var listBoxIdPrefix = 'lbSetting_' + typeId;
		var $lstBoxes = $('select[id^="' + listBoxIdPrefix + '"]');
		
	
		var selectedValues = (favoriteSettingItem.SettingSelection ? favoriteSettingItem.SettingSelection : favoriteSettingItem.SelectedSettings).split(',');
	
		var valuesForSelect = $.grep(selectedValues, function (a) { return a.lastIndexOf('0-0') !== 0; });

		if(typeId != 5) {
			$lstBoxes.find("option:selected").removeAttr("selected"); // remove previous selection
			$lstBoxes.find('option[value="0-0"]').attr('selected', true); // set all on 'no selection'
			$lstBoxes.multiselect('refresh');
		}
		else {
			var map = {};
			for (var idx = 0; idx < valuesForSelect.length; idx++) {
				var settingId = valuesForSelect[idx].split("-")[0];
				if(settingId && settingId !== "0")
					map[settingId] = map[settingId] || settingId;         
			}

			$lstBoxes.each(function(idx,elem){
				var $filterBox = $(elem);

				var splitBoxId = $filterBox.attr("id").split('_');
				var filterDisplayId = splitBoxId.length > 2 ? splitBoxId[2] : "0";
				
				if($filterBox.find('option[value="0-0"]').length){
					$filterBox.find("option:selected").removeAttr("selected"); // remove previous selection
					$filterBox.find('option[value="0-0"]').attr('selected', true); // set all on 'no selection'
					$filterBox.multiselect('refresh');
				} else {
					if(map[filterDisplayId]){
						$filterBox.find("option:selected").removeAttr("selected"); 
						$filterBox.multiselect('refresh');
					}
				}
			})
		}
		

		for (var i = 0; i < valuesForSelect.length; i++) {
			selectedValue = valuesForSelect[i];

			var addCompare = false;

			if (typeId == 5) {
	
				// Filter - trim 'add compare' substring
				addCompare = selectedValue.charAt(selectedValue.length - 1) == "1";
				selectedValue = selectedValue.substr(0, selectedValue.length - 2);
				var filterId = selectedValue.split("-")[0];

				var $currentCompareSpan = $("#" + listBoxIdPrefix + '_' + filterId).
					parent().find('span[id^="spanCompare"]:visible').first();

				if ($currentCompareSpan.length > 0) {
					if (addCompare) {
						$currentCompareSpan.find("input:radio[value='1']").
							attr('checked', true);
					}
					else {
						$currentCompareSpan.find("input:radio[value='0']").
							attr('checked', true);
					}
				}
			} else if (typeId == 3) {
				var settingControl = $lstBoxes.closest(".SettingsControl");
				settingControl.find("select").change();
				var selectedSettings = favoriteSettingItem.SelectedSettings ? favoriteSettingItem.SelectedSettings : favoriteSettingItem.SettingSelection;
				if (selectedSettings === "-2") { // select start and stop date			
					settingControl.find(".selectOptDateSelection").show();
					//translate controls
					settingControl.find("#lblStartDate").text(locale.get("Start date:"));
					settingControl.find("#lblEndDate").text(locale.get("Stop date:"));
					settingControl.find(".optCustomPeriodStart").datepicker('setDate', new Date(favoriteSettingItem.StartDate));
					settingControl.find(".optCustomPeriodEnd").datepicker('setDate', new Date(favoriteSettingItem.EndDate));
				} else
					settingControl.find(".selectOptDateSelection").hide();
				if (favoriteSettingItem.DateVariableID != null) {
					$('#lbSetting_3_DateVariable').val(favoriteSettingItem.DateVariableID);
				}
			}

			$lstBoxes.each(function () {
				var $currentListBox = $(this);
				if (selectedValue != '0-0' && $currentListBox.find('option[value="' + selectedValue + '"]').length > 0) {
					// if has value, remove 'no selection' and set value
					$currentListBox.find('option[value="0-0"]').attr('selected', false);
					$currentListBox.find('option[value="' + selectedValue + '"]').attr('selected', true);
				}
			});
		}

		$lstBoxes.each(function () {
			var $currentListBox = $(this);
			if ($currentListBox.length === 0) {
				$currentListBox.find('option[value="0-0"]').attr('selected', true);
			}
			$currentListBox.multiselect('refresh');
		});
	}

	function saveFavoriteSetting(favoriteSettingId, name) {

		if (favoriteSettingId) {
			updateFavoriteSettingName(favoriteSettingId, name);
		} else {
			insertFavoriteSetting(name);
		}
	}

	function updateFavoriteSettingName(favoriteSettingId, name) {

		var reportId = Helpers.getReportID();

		var params = {
			method: "UpdateFavoriteSettingName",
			data: {
				favoriteSettingId: favoriteSettingId,
				reportId: reportId,
				name: name
			},
			message: locale.get("Updating favorite setting..."),
			successCallback: function () {
				loadFavoriteSettings();
				DUImessage.show(locale.get('Successfully updated.'), 'Message-success', 5000);
			},
			service: "GeneralSettings"
		};
		Helpers.perfJSonCall(params);
	}

	function insertFavoriteSetting(name) {

		var reportId = Helpers.getReportID();
		var favoriteSettingItems = new Array();

		var favoriteSetting = new Object();
		favoriteSetting.ReportID = reportId;
		favoriteSetting.Name = name;

		$(GeneralSettings.getSelectedSettings()).each(function () {
			if ($(this)[0].SelectedSettings.length > 0 &&
				$(this)[0].SettingType != "7") {
				var favoriteSettingItem = new Object();
				favoriteSettingItem.FavoriteSettingID = 0;
				favoriteSettingItem.TypeID = $(this)[0].SettingType;
				favoriteSettingItem.SettingSelection = $(this)[0].SelectedSettings;
				favoriteSettingItem.StartDate = $(this)[0].StartDate;
				favoriteSettingItem.EndDate = $(this)[0].EndDate;
				if ($(this)[0].SettingType == 3) {
					favoriteSettingItem.DateVariableID = $(this)[0].DateVariableId;
				}
				favoriteSettingItems.push(favoriteSettingItem);
			}
		});

		favoriteSetting.StoryboardFavoriteSettingItems = favoriteSettingItems;

		var params = {
			method: "SaveFavoriteSetting",
			data: {
				favoriteSetting: favoriteSetting
			},
			message: locale.get("Saving favorite setting..."),
			successCallback: function () {
				loadFavoriteSettings();
				DUImessage.show(locale.get('Successfully saved.'), 'Message-success', 5000);
			},
			service: "GeneralSettings"
		};
		Helpers.perfJSonCall(params);
	}

	function deleteFavoriteSetting(favoriteSettingId) {

		var reportId = Helpers.getReportID();

		var params = {
			method: "DeleteFavoriteSetting",
			data: {
				favoriteSettingId: favoriteSettingId, reportId: reportId
			},
			message: locale.get("Deleting favorite setting..."),
			successCallback: function () {
				loadFavoriteSettings();
				DUImessage.show(locale.get('Successfully deleted.'), 'Message-success', 5000);
			},
			service: "GeneralSettings"
		};
		Helpers.perfJSonCall(params);
	}


	
	function createHtmlForFavoriteSettingsPopup() {

		function getErrorsByType(favorite, matchingErrorType){
			return favorite.MatchingErrors.filter(function(error){
				return error.MatchingErrorType === matchingErrorType
			});
		}

		function getMessagesFormatedBySettingType(favorites){
			var settingTypes = {
				1 : 'Variable Subsets' ,
				2 : 'Intervals',
				3 : 'Time Periods',
				4 : 'Moving Averages',
				5 : 'Filters',
				6 : 'Hierarchical Filters'
			}
			
			var mesageDictionary = favorites.reduce(function(agg, nextError){
				agg[settingTypes[nextError.SettingType]] = agg[settingTypes[nextError.SettingType]] || [];
				agg[settingTypes[nextError.SettingType]].push(nextError.OptionName);

				return agg;
			},{});

			var messages = [];
			for (var prop in mesageDictionary) {
				if (mesageDictionary.hasOwnProperty(prop)) {
					messages.push(prop + ": " + mesageDictionary[prop].join(', '));
				}
			}

			return messages;
		}

		function extractTooltipInfo(favorite, favoriteTooltipInfo) {
			var FavoriteErrorType = {
				NoError : 0,
				FilteringTypeMissingInReport : 1,
				FavoriteMissingInReport : 2,
				FavoriteUsedAsMultipleSelection : 3,
				FavoriteUsedAsCompare : 4,
				FavoriteUsedAsFilter : 5
			};

			var messages = [];

			var typesMissingInReport = getErrorsByType(favorite, FavoriteErrorType.FilteringTypeMissingInReport)
				.map(function(error){ return error.OptionName; });

			var missingInReport = getMessagesFormatedBySettingType(getErrorsByType(favorite, FavoriteErrorType.FavoriteMissingInReport));
			var usedAsMultiple = getMessagesFormatedBySettingType(getErrorsByType(favorite, FavoriteErrorType.FavoriteUsedAsMultipleSelection));
			var usedAsCompare = getMessagesFormatedBySettingType(getErrorsByType(favorite, FavoriteErrorType.FavoriteUsedAsCompare));
			var usedAsFilter = getMessagesFormatedBySettingType( getErrorsByType(favorite, FavoriteErrorType.FavoriteUsedAsFilter));
			
			typesMissingInReport.length && messages.push('<br /><strong>Filtering types not used in this report:</strong> <br />' + typesMissingInReport.join(', '));
			missingInReport.length && messages.push('<br /><strong>Not used in report:</strong> <br />' + missingInReport.join('<br />'));
			usedAsMultiple.length && messages.push('<br /><strong>Saved as multiselect: </strong><br />' + usedAsMultiple.join('<br />'));
			usedAsCompare.length && messages.push('<br /><strong>Saved as compare: </strong><br />' + usedAsCompare.join('<br />'));
			usedAsFilter.length && messages.push('<br /><strong>Saved as filter: </strong><br />' + usedAsFilter.join('<br />'));

			favoriteTooltipInfo[favorite.FavoriteSettingID] = { 
				errors: messages.join(''),
				reportName: favorite.ReportName,
				name: favorite.Name
			}; 
		}

		var html = '<div id="favoriteSettingsPopup">' + '<table class="DUITable">';

		var favoriteTooltipInfo = {};

		if (favoriteSettings.length > 0) {
			
			html += '<table class="DUITable">';

			for (var i = 0; i < favoriteSettings.length; i++) {
				var favorite = favoriteSettings[i]; 
				var name = shortenStringIfNecessary(favorite.Name, 60);

				extractTooltipInfo(favorite, favoriteTooltipInfo);

				html += '<tr id="' + favorite.FavoriteSettingID + '" class="favoriteSettingPopupItemRow">' +
						(
							favoriteTooltipInfo[favorite.FavoriteSettingID] && favoriteTooltipInfo[favorite.FavoriteSettingID].errors ?
							( 
								'<td class="favoriteSettingsMatchingError">' +
									'<i class="DUI-icon DUI-icon-warning" style="color:red;font-size: 15px !important"></i>' +
								'</td>'
							) 
							: ('<td></td>')
						)    +
						'<td class="favoriteSettingsPopupItemNameCell">' +
							'<label title="' + favorite.Name + '">' + HTMLHelpers.htmlEncode(name) +
							'</label>' +
						'</td>' +
						'<td class="favoriteSettingPopupItemEditCell"><a>' + locale.get('Edit') + '</a>' +
						'</td>' +
						'<td class="favoriteSettingPopupItemDeleteCell"><a>' + locale.get('Delete')+'</a>' +
						'</td>' +
					'</tr>';
			}

			html += '</table>';
		} else {
			html += '<div class="card card-inset p-y-1">'+
						'<div class="card-body">'+
							'<i class="DUI-icon DUI-icon--c DUI-icon-info text-muted"></i>'+
							'<p class="text-xl">'+ locale.get('You don\'t have any created favorites yet') +'</p>'+
							'<button type="button" class="linkButton favoriteSettingSaveFirstFavorite">'+
								locale.get('Save your first favorite')+
							'</button>'+
						'</div>'+
					'</div>';
		}

		html += '</div>';

		$('#favoriteSettingsPopupPlaceholder').empty();
		$('#favoriteSettingsPopupPlaceholder').html(html);

		if($('.favoriteSettingsMatchingError').length){
			$('.DUI-WINDOW-BUTTONS').prepend(
				'<span style="float:left">'
					+ '<i class="DUI-icon DUI-icon-warning" style="color:red;font-size: 15px !important"></i>' +
					' = Some filters in this Favorite are not available in the current report.' +
				'</span>');


			$('.favoriteSettingsMatchingError > i').each(function(){
				var favoriteId = $(this).closest('.favoriteSettingPopupItemRow').attr('id');

				new Tooltip({
					target: $(this)[0],
					content: '<div><span>Favorite <strong>'+ favoriteTooltipInfo[favoriteId].name 
						+ '</strong> saved in report <strong>'+ favoriteTooltipInfo[favoriteId].reportName 
						+'</strong> has mismatch with current report:</span><br />' +  favoriteTooltipInfo[favoriteId].errors + '</div>',
					position: "bottom left",
					classes: 'tooltip-theme-favorites'
				});
			});
		}

	}

	function displayShowFavoriteSettingPopup() {
		var popUp = new DUIwindow2({
			title: "<h2>" + locale.get("My Favorites") + "</h2>",
			width: 500,
			padding: 36,
			buttonsHeight: 50,
			cssClass: "show-favorite-settings",
			buttons: [
				{
					text: locale.get('Close'),
					onClick: function () {
						return false;
					}
				}
			],
			html: '<div id="favoriteSettingsPopupPlaceholder"></div>',
			modal: true,
			preWrapSpace: false
		});

		createHtmlForFavoriteSettingsPopup();
		$('.favoriteSettingPopupItemEditCell').bind('click', function () {
			var favoriteSettingId = $(this).parent().attr('id');
			displaySaveFavoriteSettingPopup(locale.get('Update'), locale.get('Update favorite setting'),
				locale.get('New name:'), favoriteSettingId);
			popUp.close();
		});

		$('.favoriteSettingsPopupItemNameCell').bind('click', function () {
			var favoriteSettingId = $(this).parent().attr('id');
			restoreSettingsState(favoriteSettingId);
			popUp.close();
		});

		$('.favoriteSettingPopupItemDeleteCell').bind('click', function () {
			var favoriteSettingId = $(this).parent().attr('id');
			$(this).parent().remove();
			deleteFavoriteSetting(favoriteSettingId);
		});

		$('.favoriteSettingSaveFirstFavorite').bind('click', function () {
			saveFavoriteSettingEventHandler();
			popUp.close();
		});
	}

	function saveFavoriteSettingEventHandler(event) {
		if (!sb.LayoutDesigner.checkFilterSelection())
			return;

		displaySaveFavoriteSettingPopup('Save', locale.get('Save favorite setting'), locale.get('Favorite setting name:'));
	}

	function displaySaveFavoriteSettingPopup(action, title, label, favoriteSettingId) {
		new DUIwindow2({
			title: '<h2>' + title + '</h2>',
			width: 400,
			cssClass: "save-favorite-settings",
			buttons: [
				{
					text: locale.get(action),
					focused: true,
					onClick: function (event) {
						var name = $('#favoriteSettingName').val();
						if (name.length > 0) {
							saveFavoriteSetting(favoriteSettingId, name);
						} else {
							$('#saveFavAsterisk').show();
							event.stopPropagation();
						}
					}
				},
				{
					text: locale.get('Cancel'),
					onClick: function () {
						return false;
					}
				}
			],
			html: '<label for="favoriteSettingName" class="settingsFieldSetLabel m-b-1">' + label + '</label>' +
					'<input type="text" id="favoriteSettingName" class="settingControlFull"></input>' +
					'<span id="saveFavAsterisk" style="display:none;">*</span>',
			modal: true,
			preWrapSpace: false,
			afterShow: function () {
				$('#favoriteSettingName').focus();
			}
		});
	}

	function shortenStringIfNecessary(string, lengthLimit) {
		if (string.length > lengthLimit) {
			return string.slice(0, lengthLimit) + "...";
		}
		return string;
	}

	function SortByName(a, b) {
		var aName = a.Name.toLowerCase();
		var bName = b.Name.toLowerCase();
		return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
	}

	function loadFilterNoSelectionLabel() {
		var params = {
			method: "GetFilterNoSelectionLabel"
		};
		return Helpers.perfJSonCall(params);
	}

	function loadRespondents(filter) {
		var params = {
			method: "LoadRespondentsList",
			data: { filter: filter }
		};
		return Helpers.perfJSonCall(params);
	}

	function hasHFilter() {
		var hfsetting = GeneralSettings.getSettingByType(generalSettings, HFILTER_SETTING);
		return hfsetting ? true : false;
	}

	function hasFilter() {
		var hfsetting = GeneralSettings.getSettingByType(generalSettings, FILTER_SETTING);
		return hfsetting ? true : false;
	}

    function loadGeneralSettingsHash() {
        return Helpers.perfJSonCall({
            method: "GetStoryboardSettingsHash",
            service: "GeneralSettings"
        });
    }

    function setStoryboardSettingsFromCache(settings) {
        generalSettings = settings;
        Storyboard.LayoutControls.hideLoadingBar();
        $(document).trigger('DAPI.hashedSettingsLoaded');
        Storyboard.EventBus.emit(Storyboard.Constants.Events.GENERAL_SETTINGS_LOADED, settings);
	}

	function projectHasDrilldownReports() {
		return $('#hidProjectHasDrilldownReports').val() == "true";
    }

    function projectHasFormReports() {
        return $('#hidProjectHasFormReports').val() == "true";
    }
    
    function bindExcludeSlides(selectEl) {
        var allSlides = Storyboard.LayoutDesigner.getLayoutSlides();
        var slideGroupsIDsArr = hFilterSlideExclusions
            .filter(function(exclusion) {
                return exclusion.SlideIDs.length > 1;
            }).map(function(exclusion) {
                return exclusion.SlideIDs;
            });
        var allGropedSlidesIDs = slideGroupsIDsArr.flat();

        var groups = slideGroupsIDsArr
            .map(function(slideGroupsIDs) {
                return slideGroupsIDs.map(function(slideID) {
                    return Storyboard.LayoutDesigner.getSlideById(slideID);
                })
            })
            .map(function(slidesGroup) {
                return {
                    isGroup: true,
                    slideIndex: slidesGroup[0].slideIndex,
                    slideName: slidesGroup.map(function(slide) {
                        if (slide.slideName) {
                            return 'Slide ' + slide.slideIndex + ' (id '+ slide.slideId +')' + ' - ' + slide.slideName;
                        } else {
                            return 'Slide ' + slide.slideIndex + ' (id '+ slide.slideId +')';
                        }
                    }).join(', '),
                    slideId: slidesGroup.map(function(slide) { return slide.slideId; }).join(',')
                }
            });

        var slides = allSlides.filter(function(slide) {
            return slide.isBackground !== true &&
                    slide.slideId > 0 &&
                    !allGropedSlidesIDs.includes(slide.slideId);
        });

        slides = slides.concat(groups);

        slides.sort(function(a, b) { return a.slideIndex - b.slideIndex; });

        var slidesHTML = slides.map(function(slide) {
            var text = '';

            if (slide.slideName) {
                if (slide.isGroup) {
                    text = slide.slideName;
                } else {
                    text = 'Slide ' + slide.slideIndex + ' (id '+ slide.slideId +')' + ' - ' + slide.slideName;
                }
            } else {
                text = 'Slide ' + slide.slideIndex + ' (id '+ slide.slideId +')';
            }

            return '<option value="'+ slide.slideId +'">'+ text +'</option>';
        });

        var keepSelection = $(selectEl).val();

        $(selectEl).html(slidesHTML.join(''));

        if (keepSelection) {
            if (typeof keepSelection === 'string') {
                keepSelection = keepSelection.split(',')[0];
            }

            keepSelection = $(selectEl).find('option')
                .map(function() { return $(this).val(); }).toArray()
                .find(function(ids) { return ids.split(',').includes(keepSelection); });

            $(selectEl).val(keepSelection);
        }
    }

    function setExcludeSlidesDefaultValue() {
        // Set current selected slide to default selected
        var currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
        if (currentSlide.slideId > 0) {
            var defaultValue = $('#ddlExcludeSlides option')
                .map(function() { return $(this).val(); })
                .toArray()
                .find(function(ids) {
                    return ids.split(',').map(Number).includes(currentSlide.slideId);
                });
            
                if (defaultValue) {
                    $('#ddlExcludeSlides').val(defaultValue);
                }
        }
    }

    function clearEmptySlideExclusions() {
        hFilterSlideExclusions = hFilterSlideExclusions.filter(emptySlideExclusionsFilter);
    }

    function emptySlideExclusionsFilter(exclusion) {
        return exclusion.HFilterSlideExclusionID > 0 ||
                exclusion.Include !== false ||
                exclusion.HFilterSelectionType !== 1 ||
                exclusion.SelectedHFilterIDs.length > 0 ||
                exclusion.SlideIDs.length > 1;
    }

    function groupHFilterExclusionSlides() {
        var selectedValues = $('#ddlGroupSlides').val().map(function(slideIds) {
            return slideIds.split(',').map(function(id) {
                return Number(id);
            });
        });
        
        var allSelectedIDs = selectedValues.flat();

        var selectedExclusions = hFilterSlideExclusions.filter(function(exclusion) {
            return exclusion.SlideIDs.some(function(id) { return allSelectedIDs.includes(id); });
        });

        if (selectedExclusions.length === 0) {
            hFilterSlideExclusions.push({
                HFilterSlideExclusionID: 0,
                Include: false,
                HFilterSelectionType: 1,
                SelectedHFilterIDs: [],
                SelectedLevels: [],
                SlideIDs: allSelectedIDs
            });
            hFilterSlideExclusionsUnsaved = true;
        } else if (selectedExclusions.length === 1) {
            selectedExclusions[0].SlideIDs = allSelectedIDs;
            hFilterSlideExclusionsUnsaved = true;
        } else if (selectedExclusions.length > 1) {
            new DUIwindow2({
                width: 500,
                html: '<p class="Message Message-warning">Selected slides/groups have defined exclusion rules already.</p>'+
                        '<p>Select exclutions to be used in the new group:</p>'+
                        '<select id="ddlSelectExistingExclusions"></select>',
                buttons: [
                    {
                        text: locale.get('Select'),
                        focused: true,
                        onClick: function() {
                            var selectedValues = $('#ddlSelectExistingExclusions').val()
                                .split(',')
                                .map(function(slideIds) {
                                    return slideIds.split(',').map(function(id) {
                                        return Number(id);
                                    });
                                });

                            var hFilterSlideExclusion = hFilterSlideExclusions.find(function(exclusion) {
                                return exclusion.SlideIDs.sort().join(",") === selectedValues.sort().join(",");
                            });

                            hFilterSlideExclusions = hFilterSlideExclusions.filter(function(exclusion) {
                                return !selectedExclusions.includes(exclusion);
                            });

                            hFilterSlideExclusions.push(Object.assign({}, hFilterSlideExclusion, {
                                HFilterSlideExclusionID: 0,
                                SlideIDs: allSelectedIDs
                            }));
                            hFilterSlideExclusionsUnsaved = true;
                            
                            Storyboard.GeneralSettings.bindExcludeSlides('#ddlGroupSlides');
                            $('#ddlGroupSlides').attr('size', $('#ddlGroupSlides').find('option').length);

                            return true;
                        }
                    },
                    {
                        text: locale.get('Cancel'),
                    }
                ],
                modal: true,
                preWrapSpace: false,
                afterShow: function() {
                    $('#ddlSelectExistingExclusions').html($('#ddlGroupSlides option:selected').clone());
                }
            });
        }

        Storyboard.GeneralSettings.bindExcludeSlides('#ddlGroupSlides');
        $('#ddlGroupSlides').attr('size', $('#ddlGroupSlides').find('option').length);
        $("#ddlGroupSlides").val("")
    }

    function ungroupHFilterExclusionSlides() {
        var selectedGroups = $('#ddlGroupSlides').val().map(function(slideIds) {
            return slideIds.split(',').map(function(id) {
                return Number(id);
            });
        }).filter(function(slideIds) {
            return slideIds.length > 1;
        });

        selectedGroups.forEach(function(groupsSlideIDs) {
            var hFilterSlideExclusion = hFilterSlideExclusions.find(function(exclusion) {
                return exclusion.SlideIDs.sort().join(",") === groupsSlideIDs.sort().join(",");
            });

            if (hFilterSlideExclusion) {
                groupsSlideIDs.forEach(function(slideId) {
                    hFilterSlideExclusions.push(Object.assign({}, hFilterSlideExclusion, {
                        HFilterSlideExclusionID: 0,
                        SlideIDs: [slideId]
                    }));
                });

                hFilterSlideExclusions = hFilterSlideExclusions.filter(function(exclusion) {
                    return exclusion !== hFilterSlideExclusion
                });
            }

            hFilterSlideExclusionsUnsaved = true;
        });

        Storyboard.GeneralSettings.bindExcludeSlides('#ddlGroupSlides');
        $('#ddlGroupSlides').attr('size', $('#ddlGroupSlides').find('option').length);
        $("#ddlGroupSlides").val("")
	}

	function insertHashDataScript(id, hash, callback) {
		var script = document.createElement("script");
		script.id = id;
		script.type = "text/javascript";
		script.src = 'HashedDataHandler.ashx?hash=' + hash + "&callback=" + callback;
		document.getElementsByTagName("head")[0].appendChild(script);
	}

    sb.GeneralSettings.loadFilterNoSelectionLabel = loadFilterNoSelectionLabel;
	sb.GeneralSettings.loadGeneralSettings = loadGeneralSettings;
	sb.GeneralSettings.loadDefaultOptionalFilters = loadDefaultOptionalFilters;
    sb.GeneralSettings.loadGeneralSettingsWithRenew = loadGeneralSettingsWithRenew;
    sb.GeneralSettings.loadHFilterLevelSettings = loadHFilterLevelSettings;
    sb.GeneralSettings.loadGeneralSettingsForReport = loadGeneralSettingsForReport;
    sb.GeneralSettings.savePreloadSettingsForReport = savePreloadSettingsForReport;
    sb.GeneralSettings.getPreloadCalculations = getPreloadCalculations;
	sb.GeneralSettings.getGeneralSettings = getGeneralSettings;

	sb.GeneralSettings.loadGeneralSettingsHash = loadGeneralSettingsHash;
	sb.GeneralSettings.setStoryboardSettingsFromCache = setStoryboardSettingsFromCache;
	sb.GeneralSettings.loadReportListForInheritedSettings = loadReportListForInheritedSettings;
	sb.GeneralSettings.loadStoryboardSettingBasedOnType = loadStoryboardSettingBasedOnType;
	sb.GeneralSettings.loadHFilterInheritedSettingsAdmin = loadHFilterInheritedSettingsAdmin;

	sb.GeneralSettings.bindGeneralSettingsAdmin = bindGeneralSettingsAdmin;
	sb.GeneralSettings.loadGeneralSettingsAdmin = loadGeneralSettingsAdmin;
	sb.GeneralSettings.saveSettings = saveSettings;
	sb.GeneralSettings.bindControls = bindControls;
	sb.GeneralSettings.unbindControls = unbindControls;

	sb.GeneralSettings.bindGeneralSettings = bindGeneralSettings;
	sb.GeneralSettings.NO_SELECTION_ID = NO_SELECTION_ID;

	sb.GeneralSettings.hFilters = hFilterList;
	sb.GeneralSettings.getStoryBoardAccess = getStoryBoardAccess;

	sb.GeneralSettings.initializeResetFiltersButton = initializeResetFiltersButton;
	sb.GeneralSettings.initializeFavoriteSettings = initializeFavoriteSettings;
	sb.GeneralSettings.deinitializeFavoriteSettings = deinitializeFavoriteSettings;
	sb.GeneralSettings.refreshHFilter = refreshHFilter;

	sb.GeneralSettings.projectNotUsingInMemory = projectNotUsingInMemory;
	sb.GeneralSettings.enableInMemory = enableInMemory;

	sb.GeneralSettings.loadHFiltersAdmin = loadHFiltersAdmin;
	sb.GeneralSettings.bindHFilterSettingsAdmin = bindHFilterSettingsAdmin;
	sb.GeneralSettings.saveHFilterSettings = saveHFilterSettings;
	sb.GeneralSettings.getHFilterLevels = function () { return hfLevelSettings; };
	sb.GeneralSettings.getHFilterSlideExclusions = function() { return hFilterSlideExclusions; }

	sb.GeneralSettings.loadRespondents = loadRespondents;
	sb.GeneralSettings.filterNoSelectionLabel = filterNoSelectionLabel;

	sb.GeneralSettings.conditionalVisibilityForFilters = conditionalVisibilityForFilters;
	sb.GeneralSettings.loadStorySlideSettings = loadStorySlideSettings;
	sb.GeneralSettings.restoreVariableSubsetState = restoreVariableSubsetState;
	sb.GeneralSettings.restoreGenericOptionalSettingState = restoreGenericOptionalSettingState;

	sb.GeneralSettings.hasHFilter = hasHFilter;
	sb.GeneralSettings.hasFilter = hasFilter;
    sb.GeneralSettings.hfilterVsVarSubsetActive = hfilterVsVarSubsetActive;
    sb.GeneralSettings.hfilterVsFiltersActive = hfilterVsFiltersActive;
    sb.GeneralSettings.filterLazyRenderCount = filterLazyRenderCount;
    sb.GeneralSettings.singleBoxes = singleBoxes;
	sb.GeneralSettings.storeSingleObjectExports = storeSingleObjectExports;
	sb.GeneralSettings.respondentBlockCheckInterval = respondentBlockCheckInterval;
	sb.GeneralSettings.collaborationVersionCheckInterval = collaborationVersionCheckInterval;
    sb.GeneralSettings.getLoadedFilterOptionIds = getLoadedFilterOptionIds;
	sb.GeneralSettings.addExtraOptionsToLoadedOptions = addExtraOptionsToLoadedOptions;
    sb.GeneralSettings.hasDrilldownReports = projectHasDrilldownReports;
    sb.GeneralSettings.hasFormReports = projectHasFormReports;
    
    sb.GeneralSettings.bindExcludeSlides = bindExcludeSlides;
    sb.GeneralSettings.setExcludeSlidesDefaultValue = setExcludeSlidesDefaultValue;
    sb.GeneralSettings.loadHFilterSlideExclusions = loadHFilterSlideExclusions;
    sb.GeneralSettings.loadExcludeSlidesHFiltersAdmin = loadExcludeSlidesHFiltersAdmin;
    sb.GeneralSettings.bindExcludeSlidesHFiltersAdmin = bindExcludeSlidesHFiltersAdmin;
    sb.GeneralSettings.groupHFilterExclusionSlides = groupHFilterExclusionSlides;
    sb.GeneralSettings.ungroupHFilterExclusionSlides = ungroupHFilterExclusionSlides;
    sb.GeneralSettings.saveHFilterSlideExclusions = saveHFilterSlideExclusions;
	sb.GeneralSettings.clearEmptySlideExclusions = clearEmptySlideExclusions

	sb.GeneralSettings.loadRefDataSettingsAdmin = loadRefDataSettingsAdmin;
	sb.GeneralSettings.bindRefDataSettingsAdmin = bindRefDataSettingsAdmin;
	sb.GeneralSettings.saveRefDataSettings = saveRefDataSettings;

	sb.GeneralSettings.loadPreparedTimePeriods = loadPreparedTimePeriods;
	sb.GeneralSettings.onPreparedTimePeriodsLoaded = onPreparedTimePeriodsLoaded;
	sb.GeneralSettings.insertHashDataScript = insertHashDataScript;
	sb.GeneralSettings.getSetting = getSetting;
	sb.GeneralSettings.showHideAutoSelectIntervalOption = showHideAutoSelectIntervalOption;

	sb.GeneralSettings.drilldownSettingsGuid = drilldownSettingsGuid;
})(window.Storyboard = (window.Storyboard || {}));

window.GeneralSettingsAdmin = {
	addAsDialog: function () {
		$('#lblMinMaxValidationMessage').html('').hide();
		Storyboard.GeneralSettings.loadGeneralSettingsAdmin();
		$('html').addClass('DUISetup-lock');
		$("#setupcontainer").css('display', 'block').parent().addClass('DUISetupOuter DUISetupOverlay');
		$("#setupcontainer #SetupContainerPanel").remove();
	},
	hFilterSetupAsDialog: function () {
		$('#lblHFMinMaxValidationMessage').html('').hide();
		Storyboard.GeneralSettings.loadHFiltersAdmin();
		$('html').addClass('DUISetup-lock');
		$("#hfilterSettingsSetupContainer").css('display', 'block').parent().addClass('DUISetupOuter DUISetupOverlay');
	},
	excludeSlidesSetupAsDialog: function () {
        Storyboard.GeneralSettings.loadExcludeSlidesHFiltersAdmin();
        $('html').addClass('DUISetup-lock');
        $("#excludeSlidesSetupContainer").css('display', 'block').parent().addClass('DUISetupOuter DUISetupOverlay');
        Storyboard.GeneralSettings.unbindControls();
        Storyboard.GeneralSettings.bindControls();
	},
	referenceDataSetupAsDialog: function () {
		Storyboard.GeneralSettings.loadRefDataSettingsAdmin();
		$('html').addClass('DUISetup-lock');
		$("#refDataSetupContainer").css('display', 'block').parent().addClass('DUISetupOuter DUISetupOverlay');
		Storyboard.GeneralSettings.unbindControls();
		Storyboard.GeneralSettings.bindControls();
	},
    checkRadioButtons: function (sender) {
        $(sender).parents("tr").siblings().find("input[type='radio']").each(function () {
            $(this).removeAttr("checked");
        });
    },
    disableDefault: function (sender) {//Disables the default checkbox/radiobutton
        if ($(sender).is(":checked")) {
			$(sender).parents("td").siblings().find("> .settingDefaultComp").not('.dynamicFilteringNoSelection').removeAttr("disabled");
            $(sender).parents("td").siblings(".settingDefaultSelection").find("select.ui-multiselect-element").multiselect('enable').multiselect('refresh');
            if ($(sender).closest(".settingItem").find('#hidSettingDisplayID').val() === "0" ||
				$(sender).closest(".settingItem").find('#hidSettingDisplayID').val() === "-2") {
				$(sender).closest(".settingItem").find(".selectDateSelection").show();
			}
			if ($(sender).parent().parent().siblings().find('.itemDisplayName').text().toLowerCase() === "select last x periods...") {
				$(sender).parent().parent().siblings().find(".selectDatePeriod").show();
				$(sender).parent().parent().siblings().find(".addNewPeriodItem").show();
			}

			var $chbDynamicWeighting = $(sender).closest('tr').find('#chbDynamicWeighting');
			if($chbDynamicWeighting.data("IsConnectedToWeights")){
				$chbDynamicWeighting.removeAttr("disabled");
			}

		}
		else {
			$(sender).parents("td").siblings().find(".settingDefaultComp").attr("disabled", "disabled");
			$(sender).parents("td").siblings(".settingDefaultSelection").find("select.ui-multiselect-element").multiselect('refresh').multiselect('disable');
			if ($(sender).closest(".settingItem").find('#hidSettingDisplayID').val() === "0" ||
				$(sender).closest(".settingItem").find('#hidSettingDisplayID').val() === "-2") {
				$(sender).closest(".settingItem").find(".selectDateSelection").hide();
			}
			if ($(sender).parent().parent().siblings().find('.itemDisplayName').text().toLowerCase() === "select last x periods...") {
				$(sender).parent().parent().siblings().find(".selectDatePeriod").hide();
				$(sender).parent().parent().siblings().find(".addNewPeriodItem").hide();
			}
		}
	},
	setDefaultSelected: function (sender) {//Sets the default selected item if the aren't any selected
		var visibleTemp = $(sender).closest(".grdSettings > tbody").find(".settingItem").find("#chbDefault, #rdbDefault")
		var visibleDefault = visibleTemp.filter(function() { return $(this).parent("td").css("display") !== "none"; });
		if ($(visibleDefault).filter("input:checked:not(:disabled)").length == 0) {
			$(visibleDefault).filter(":disabled:checked").removeAttr("checked");
			$(visibleDefault).not(":disabled").first().attr("checked", "checked");
		}
	},
	doNothing: function(event){
		// don't you just love doing nothing
		event.preventDefault();
	},
	checkFirstItemOnly: function($dropdown){
		$dropdown.find("option").removeAttr("selected").removeAttr('disabled');
		$dropdown.find("option[value='0-0']").attr('selected', 'selected');
		$dropdown.multiselect('refresh');
	},
	checkLastItemOnly: function($dropdown){
		$dropdown.find("option").removeAttr("selected").removeAttr('disabled');
		$dropdown.find("option[value='0-1']").attr('selected', 'selected');
		$dropdown.multiselect('refresh');
	},
	checkRegularFilterItem: function($dropdown, currentSelectedValue){
		$dropdown
			.find("option[value^='0-']:selected")
			.each(function(idx,elem){
				$(elem).removeAttr("selected");
			});
		
		$dropdown.find("option[value='" + currentSelectedValue + "']").attr('selected', 'selected');
		$dropdown.multiselect('refresh');
	},
	checkAllAndFuture: function($dropdown) {
		$dropdown.find("option").each(function(idx,elem){
			if(!$(elem).val().startsWith("0-"))
				$(elem).attr("selected","selected").attr('disabled','disabled');
			else   
				$(elem).removeAttr("selected");
		});

		$dropdown.find("option[value='0-2']").attr("selected","selected");
		$dropdown.multiselect('refresh');
	},
	unCheckAllAndFuture: function($dropdown) {
		$dropdown.find("option").each(function(idx,elem){ 
			 $(elem).removeAttr('selected');
		});

		GeneralSettingsAdmin.enableRegularOptions($dropdown)

		$dropdown.find("option[value='0-0']").attr("selected","selected");
		$dropdown.multiselect('refresh');
	},
	enableRegularOptions: function($dropdown){
		$dropdown.find("option").each(function(idx,elem){ 
			$(elem).removeAttr('disabled'); 
	   });
	},
	changeDefaultSelection: function (event, ui) {//logic for multiple selection
		var currentSelectedValue = ui.value;
		var isChecked = ui.checked;

		var $currentDropdown = $(event.currentTarget);
		
		var allUnchecked = $currentDropdown.find("option:selected").length === 1 && currentSelectedValue !== '0-0' && !isChecked; 
		if (allUnchecked) 
			return GeneralSettingsAdmin.checkFirstItemOnly($currentDropdown);

		var firstItemUnchecked = $currentDropdown.find("option[value='0-0']:selected").length === 1 && currentSelectedValue === '0-0' && !isChecked;
		if (firstItemUnchecked)
			return GeneralSettingsAdmin.doNothing(event);
		
		var firstItemChecked = $currentDropdown.find("option[value='0-0']:selected").length === 0 && currentSelectedValue === '0-0';
		if (firstItemChecked)
			return GeneralSettingsAdmin.checkFirstItemOnly($currentDropdown);
		
		var lastItemChecked = currentSelectedValue === '0-1' && isChecked; 
		if (lastItemChecked) 
			return GeneralSettingsAdmin.checkLastItemOnly($currentDropdown);
		
		var allAndFutureUnchecked = $currentDropdown.find("option[value='0-2']:selected").length === 1 && !isChecked;
		if (allAndFutureUnchecked) 
			return GeneralSettingsAdmin.unCheckAllAndFuture($currentDropdown);

		var allAndFutureChecked = currentSelectedValue === '0-2' && isChecked
		if(allAndFutureChecked)
			return GeneralSettingsAdmin.checkAllAndFuture($currentDropdown)

		var regularFilterItemChecked = !currentSelectedValue.startsWith("0-") && isChecked 
		if(regularFilterItemChecked) 
			return GeneralSettingsAdmin.checkRegularFilterItem($currentDropdown, currentSelectedValue);

	},
	changeDefaultSelectionForDynamicFiltering: function(defaultSelectionBox){
		var $defaultSelectionBox = $(defaultSelectionBox);
			var isDynamicFiltering =  $defaultSelectionBox.closest('tr.settingItemInline').find('#ddlDynamicFiltering').val() != "0";
			
			if(isDynamicFiltering){
				var $defaultSelectionsForDynamicFilters = $defaultSelectionBox
					.closest('tr.settingItemInline')
					.siblings('tr.settingItemInline')
					.find("#ddlDynamicFiltering")
					.filter(function(idx,elem){ return $(elem).val() != "0" })
					.map(function(idx, elem){ return  $(elem).closest('tr').find('.settingDefaultSelection select').first()})

				$defaultSelectionsForDynamicFilters
					.each(function(idxSel,$elemSel){
						$elemSel.find('option').each(function(idxOpt, elemOpt){
							var optionValue =  $(elemOpt).val();
							$(elemOpt).removeAttr('disabled');

							var $li = $('#li_' + $elemSel.attr('id') + '-' + optionValue);
							$li.removeClass('ui-multiselect-disabled');
							$li.find('label').removeClass('ui-state-disabled');

							var inputField = $li.find('input').first();
							
							if(optionValue == "0-0"){        
								inputField.attr('checked','checked');
							}
							else{
								inputField.removeAttr('checked').removeAttr('disabled').removeAttr('aria-disabled')
							}

						});

						$elemSel.val("0-0").multiselect("update");
					});
			  
			}
	},
	changeMultiselectDefaultSelection: function (sender) {
		var isMultiSelect = $(sender).is(':checked');
		var isNoSelection = $(sender).closest('tr').find('#cbFHasNoSelection').is(':checked');
		if(!isMultiSelect){
			$(sender).parents("td").siblings(".settingDefaultSelection").find("select option[value='0-2']").remove();
			GeneralSettingsAdmin.enableRegularOptions($(sender).parents("td").siblings(".settingDefaultSelection"));
		}else{
			var optionSelector = isNoSelection ? "select option[value='0-0']" : "select option[value='0-1']";
			$(sender)
				.parents("td").siblings(".settingDefaultSelection").find(optionSelector)
				.after('<option value="0-2">All existing and future items</option>');
		}
   
		var defSel = $(sender).parents("td").siblings(".settingDefaultSelection").find("select").first();
		var renderOnDemandStep = Storyboard.GeneralSettings.filterLazyRenderCount;
		var renderOnDemand = renderOnDemandStep > 0;
		if ($(sender).is(":checked")) {
			defSel.multiselect("destroy").attr("multiple", "multiple").multiselect({
				header: false,
				minWidth: null,
				classes: 'DUI-multiselect',
				multiple: true,
				selectedList: 2,
				renderOnDemand: renderOnDemand,
				renderOnDemandStep: renderOnDemandStep
			});
		} else {
			if (defSel.val() !== null)
			defSel.val(defSel.val().length > 1 ? defSel.val()[0] : defSel.val());
			defSel.multiselect("destroy").removeAttr("multiple").multiselect({
				header: false,
				minWidth: null,
				classes: 'DUI-multiselect',
				multiple: false,
				selectedList: 1,
				renderOnDemand: renderOnDemand,
				renderOnDemandStep: renderOnDemandStep
			});
		}
	},
	changeNoSelectionItemDefaultSelection: function (sender, alwaysSelectNoSelection) {
		if ($(sender).is(":checked")) {
			$(sender).parents("td").siblings(".settingDefaultSelection").find("select option[value='0-0']").text('No selection');
			$(sender).parents("td").siblings(".settingDefaultSelection").find("select option[value='0-1']").remove();

			if(alwaysSelectNoSelection){
				$(sender).parents("td").siblings(".settingDefaultSelection").find("select").val("0-0");
				GeneralSettingsAdmin.enableRegularOptions($(sender).parents("td").siblings(".settingDefaultSelection"))
			}

		} else {
			var firstItemWillBeSelected = $(sender).parents("td").siblings(".settingDefaultSelection").find("select option[value='0-0']");
			firstItemWillBeSelected.text('First item will be selected');
			var lastItemWillBeSelected = $('<option value="0-1">Last item will be selected</option>');

			let isMultiselect = $(sender).closest('.settingItemInline').find("#cbFIsMultiSelect").is(':checked');
			let minSelVal = $(sender).closest('.settingItemInline').find("#minNoOfSelections").val();
			if (isMultiselect && minSelVal != null && minSelVal != '' && parseInt(minSelVal) > 1) {
				firstItemWillBeSelected.text(`First ${minSelVal} items will be selected`);
				lastItemWillBeSelected = $(`<option value="0-1">Last ${minSelVal} items will be selected</option>`);
            }
				
			lastItemWillBeSelected.insertAfter(firstItemWillBeSelected);
		}
		$(sender).parents("td").siblings(".settingDefaultSelection").find("select.ui-multiselect-element").multiselect("refresh");
	},
	changeFilterBahaviour: function(sender) {
		var behaviour = parseInt($(sender).val(), 10);

		var defaultBehavoiurDdl = $(sender).closest("tr").find("#ddlDefaultBehaviour");
		var selectedVal = defaultBehavoiurDdl.find('option:selected').val();
		defaultBehavoiurDdl.find("option").remove();
		if (behaviour == 1 || behaviour == 3) // Filter or Filter and Compare
			defaultBehavoiurDdl.append("<option value='0'>Filter</option>");

		if (behaviour == 2 || behaviour == 3) // Compare or Filter and Compare
			defaultBehavoiurDdl.append("<option value='1'>Compare</option>");

		if (behaviour == 3)
			setDefaultSelected(defaultBehavoiurDdl, selectedVal);

		if ((behaviour == 2) && (!document.getElementById("compareFiltersMsg"))) {
			$(sender).closest('.items').before('<p id="compareFiltersMsg" class="Message Message-info" style="margin-top: -1em;">Please note: Compare filters will not apply on Cross tabs, Scatter and Bubble charts, Dynamic icons</p>');
		}
	},
	changeGlobalBehaviour: function(sender) {
		 var behaviour = parseInt($(sender).val(), 10);

		var defaultBehavoiurDdl = $(sender).closest("div").find("#ddlGlobalDefaultBehaviour");

		var selectedVal = defaultBehavoiurDdl.find('option:selected').val();
		defaultBehavoiurDdl.find("option").remove();

		if (behaviour == 1 || behaviour == 3) // Filter or Filter and Compare
			defaultBehavoiurDdl.append("<option value='0'>Filter</option>");

		if (behaviour == 2 || behaviour == 3) // Compare or Filter and Compare
			defaultBehavoiurDdl.append("<option value='1'>Compare</option>");

		if (behaviour == 3)
			setDefaultSelected(defaultBehavoiurDdl, selectedVal);

		if ((behaviour == 2) && (!document.getElementById("compareFiltersMsg"))) {
			$(sender).closest('.header').after('<p id="compareFiltersMsg" class="Message Message-info" style="margin-top: -1em;">Please note: Compare filters will not apply on Cross tabs, Scatter and Bubble charts</p>');
		}
	},
	setSetupType: function(sender) {
		const inherit = $(sender).is('[value="inherit"]');
		const adminSettingEl = $(sender).closest('.AdminSetting');
		const settingType = parseInt(adminSettingEl.find('.hidSettingType').val(), 10);

		adminSettingEl.find('#btnsSetupType > button.active').removeClass('active');

		if (inherit) {
			adminSettingEl.find('#btnsSetupType > button[value="inherit"]').addClass('active');
			adminSettingEl.find('.setup-type-inherit-reports').removeClass('hidden');
			adminSettingEl.find('#ddlSetupTypeInheritFromReport').val(0);

			Storyboard.GeneralSettings.loadReportListForInheritedSettings(settingType).then(() => {
				GeneralSettingsAdmin.bindListOfReportsToInheritFrom(adminSettingEl);
			});
		} else {
			adminSettingEl.find('#btnsSetupType > button[value="report-specific"]').addClass('active');
			adminSettingEl.find('.setup-type-inherit-reports').addClass('hidden');
			adminSettingEl.find('#ddlSetupTypeInheritFromReport').val(0);
			adminSettingEl.find('fieldset.header, fieldset.items').removeAttr('disabled');
		}
	},
	bindSetupTypeParent: function(adminSettingEl) {
		adminSettingEl.find('#btnsSetupType > button').attr('disabled', 'disabled');
		adminSettingEl.find('#btnsSetupType > button.active').removeClass('active');
		adminSettingEl.find('.setup-type-inherit-reports').addClass('hidden');
		adminSettingEl.find('.setup-type').addClass('hidden');
		adminSettingEl.find('.setup-type').next('.setup-type-parent').remove();
		adminSettingEl.find('.setup-type').after('<p class="Message Message-info setup-type-parent" style="margin: 5px 0;">These settings serve as the parent for other reports, thus any changes made here will affect all reports inheriting its settings. Keep in mind that adjustments made here have wider implications.</p>');
	},
	bindListOfReportsToInheritFrom(adminSettingEl) {
		var settingType = parseInt(adminSettingEl.find(".hidSettingType").val());
		var ddlInheritFromReport = adminSettingEl.find("#ddlSetupTypeInheritFromReport");
		
		Storyboard.GeneralSettings.loadReportListForInheritedSettings(settingType).then(function(reports) {
			HTMLHelpers.bindSelect(
				ddlInheritFromReport,
				reports,
				'ReportId',
				'ReportName'
			);
			ddlInheritFromReport.prepend('<option value="0" disabled selected hidden>Select report</option>');
			ddlInheritFromReport.val(ddlInheritFromReport.attr('data-default-value') ?? 0);
			ddlInheritFromReport.removeAttr('data-default-value');
		});
	},
	changeInheritedSettingsReport: function(sender) {
		var reportId = parseInt($(sender).val());
		var adminSettingEl = $(sender).closest('.AdminSetting');
		var settingType = parseInt(adminSettingEl.find(".hidSettingType").val());

		if (reportId === 0) {
			GeneralSettingsAdmin.setSetupType(adminSettingEl.find('#btnsSetupType > button[value="report-specific"]'));
			return;
		}

		$("#setupTabsContainer").attr('open-setting-type', settingType);

		if (settingType === 6) {
			Storyboard.GeneralSettings.loadHFilterInheritedSettingsAdmin(reportId);
		} else {
			Storyboard.GeneralSettings.loadStoryboardSettingBasedOnType(reportId, settingType);
		}
	},
	confirmInheritFromAnotherReport: function(callback) {
		new DUIwindow2({
			title: "<h2>" + locale.get("Inherit from another report") + "</h2>",
			width: 500,
			padding: 36,
			buttonsHeight: 50,
			buttons: [
				{
					text: locale.get('Yes'),
					focused: true,
					onClick: function () {
						callback();
						return true;
					}
				},
				{
					text: locale.get('No'),
					onClick: function () {
						return false;
					}
				}
			],
			html: '<p>All report-specific settings will be cleared. <br/>If you later re-enable report-specific settings, you will need to redefine them.<br/>Please note that the change is not finalized until you save the changes.</p><p class="m-y-1">Do you want to continue?</p>',
			modal: true,
			preWrapSpace: false
		});
	},
 	checkInMemory: function () {
		Storyboard.GeneralSettings.projectNotUsingInMemory(function () {
			new DUIwindow2({
				title: "<h2>" + locale.get("Note") + "</h2>",
				width: 500,
				padding: 36,
				buttonsHeight: 50,
				buttons: [
					{
						text: locale.get('Yes'),
						focused: true,
						onClick: function () {
							Storyboard.GeneralSettings.enableInMemory();
							return true;
						}
					},
					{
						text: locale.get('No'),
						onClick: function () {
							return false;
						}
					}
				],
				html: '<p>Dynamic filtering can only be used when the in-memory data model is enabled.  Do you want to enable the in-memory data model now?</p>',
				modal: true,
				preWrapSpace: false
			});
		});
	},
	toggleMoveDisabledToBottom: function (sender) {
		var onDisableOptionsWithNoData = Storyboard.Constants.DynamicFilteringStatus.OnDisableOptionsWithNoData;
		var anyOnDisableOptionsWithNoData = $(sender).closest(".AdminSetting")
			.find('.settingDynamicFiltering, .ddlDynamicFilteringSetting')
			.filter(function() { return Number(this.value) == onDisableOptionsWithNoData; })
			.length;

		if (anyOnDisableOptionsWithNoData) {
			$(sender).closest(".AdminSetting").find('#divDynamicFilteringMoveDisabledToBottom').show();
		} else {
			$(sender).closest(".AdminSetting").find('#divDynamicFilteringMoveDisabledToBottom').hide();
		}
	},
	setDynamicFilteringDefaultSelections: function(sender){
		var $sender = $(sender);
		var isDynamicFilteringEnabled = Number($(sender).val()) !== 0;

		let $settingItem = $sender.closest('.settingItemInline')
		let $cbFHasNoSelection = $settingItem.find('#cbFHasNoSelection');
        if (isDynamicFilteringEnabled) {
			$cbFHasNoSelection.attr('checked', 'checked').attr('disabled', 'disabled').addClass('.dynamicFilteringNoSelection');
			$settingItem.find('#minNoOfSelections').attr('disabled', 'disabled').val('');
			$settingItem.find('#maxNoOfSelections').attr('disabled', 'disabled').val('');
			let sss = [Storyboard.GeneralSettings.getSetting($('#setupPanel_1')), Storyboard.GeneralSettings.getSetting($('#setupPanel_5'))];
			$.when(GeneralSettingsAdmin.validateMinMaxSelections(sss))
				.then(function (validationData) {
					$('#lblMinMaxValidationMessage').html('').hide();
					$('#setupPanel_5 .validateMinMaxOnLeave').css('border-color', '')
					$('#setupPanel_5 .validateMinMaxOnLeave').siblings('button').css('border-color', '');
					GeneralSettingsAdmin.showMinMaxValidation(validationData, false, true);
				});
            GeneralSettingsAdmin.changeNoSelectionItemDefaultSelection($cbFHasNoSelection.get(), true);
        } else {
            $cbFHasNoSelection.removeAttr('disabled').removeClass('.dynamicFilteringNoSelection')
        }
    },
    closeSettingsPanel: function () {
        $('#DUI-ST-R-SHOWFILTERPANEL').removeClass('ribbonItemChecked');
        $('html').removeClass('DUISetup-lock');
        $("#setupcontainer").css('display', 'none').parent().removeClass('DUISetupOuter DUISetupOverlay');
    },
    closeHFilterSettingsPanel: function () {
        $('#DUI-ST-R-SHOWHFILTERSSETUP').removeClass('ribbonItemChecked');
        $('html').removeClass('DUISetup-lock');
        $("#hfilterSettingsSetupContainer").css('display', 'none').parent().removeClass('DUISetupOuter DUISetupOverlay');
    },
    closeExcludeSlidesPanel: function () {
        $('#DUI-ST-R-EXCLUDESLIDES').removeClass('ribbonItemChecked');
        $('html').removeClass('DUISetup-lock');
        $("#excludeSlidesSetupContainer").css('display', 'none').parent().removeClass('DUISetupOuter DUISetupOverlay');
	},
	closeRefDataSettingsPanel: function () {
		$('#DUI_ST_R_REFERENCEDATASETUP').removeClass('ribbonItemChecked');
		$('html').removeClass('DUISetup-lock');
		$("#refDataSetupContainer").css('display', 'none').parent().removeClass('DUISetupOuter DUISetupOverlay');
	},
    showSettings: function (sender) {
        if ($(sender).is(":checked")) {
			$(sender).closest(".header").siblings(".items").show();

			var $dateVarSection = $(sender).closest(".header").siblings(".dateVariablesSection");
			if ($dateVarSection.children('.items').find('tr').length > 1)
				$dateVarSection.show();
			else
				$dateVarSection.hide();

			if ($(sender).siblings(".hidSettingType").val() === "5" || // Filters
				$(sender).siblings(".hidSettingType").val() === "1") // Variable subset
				$(sender).siblings(".splitFilterBoxes").show();

			// Variable subset
			if ($(sender).closest('.header').find(".hidSettingType").val() === "1")
				$(sender).closest(".header").find("#varSubsetsProperties").show();
		}
		else {
			$(sender).closest(".header").siblings(".items").hide();
			$(sender).closest(".header").siblings(".dateVariablesSection").hide();

			if ($(sender).siblings(".hidSettingType").val() === "5" || // Filters
				$(sender).siblings(".hidSettingType").val() === "1") // Variable subset
				$(sender).siblings(".splitFilterBoxes").hide();

			// Variable subset
			if ($(sender).closest('.header').find(".hidSettingType").val() === "1")
				$(sender).closest(".header").find("#varSubsetsProperties").hide();
		}

		if ($(sender).closest(".header").find(".hidSettingType").val() === "2")
			Storyboard.GeneralSettings.showHideAutoSelectIntervalOption();
	},
	initTabs: function() {
		var openSettingType = $("#setupTabsContainer").attr('open-setting-type');
		var tabIndex = $('#setupTabsContainer .tabs > li > a[href="#setupPanel_'+ openSettingType +'"]')
			.parent('li').index();

		$("#setupTabsContainer").tabs("destroy");
		$('#setupTabsContainer').removeClass('ui-widget');
		$("#setupTabsContainer").tabs({ selected: tabIndex > -1 ? tabIndex : 0 });
	},
	initShowSettings: function () {
		$(".SettingsControl #chbUseSetting").each(function () { if (!$(this).is(":checked")) $(this).closest('.header').siblings(".items").css("display", "none") });
		$('.settingItemInline .ddlFilterBehaviour').trigger('change');
		$('.settingItemInline .globalBehaviour').trigger('change');
		$(".settingItemSelected #chbIsSelected").each(function () { GeneralSettingsAdmin.disableDefault(this); });
	},
	saveSettings: function () {
		let hasValidSettings = GeneralSettingsAdmin.validateSettings();
		if (hasValidSettings) {
			let storyboardSettings = [];
			$("#setupcontainer .AdminSetting").each(function () {
				var storyboardSetting = Storyboard.GeneralSettings.getSetting($(this));

				if (storyboardSetting)
					storyboardSettings.push(storyboardSetting);
			});

			$.when(GeneralSettingsAdmin.validateMinMaxSelections(storyboardSettings))
				.then(function (validationData) {
					$('#lblMinMaxValidationMessage').html('').hide();
					if (!validationData || (Object.keys(validationData).length === 0 && Object.getPrototypeOf(validationData) === Object.prototype)) {
						GeneralSettingsAdmin.closeSettingsPanel();
						Storyboard.GeneralSettings.saveSettings(storyboardSettings);
					} else {
						GeneralSettingsAdmin.showMinMaxValidation(validationData);
					}
				});
		}
	},
	saveHFilterSettings: function () {
		let hasValidSettings = GeneralSettingsAdmin.validateSettings();
		if (hasValidSettings) {
			var storyboardSettings = [];
			$("#hfilterSetupContainerPanel .AdminSetting").first().each(function () {
				var storyboardSetting = Storyboard.GeneralSettings.getSetting($(this), true);

				if (storyboardSetting && storyboardSetting.settingItems.length > 0)
					storyboardSettings.push(storyboardSetting);
			});

			$.when(GeneralSettingsAdmin.validateMinMaxSelections(storyboardSettings))
				.then(function (validationData) {
					$('#lbHFlMinMaxValidationMessage').html('').hide();
					if (!validationData || (Object.keys(validationData).length === 0 && Object.getPrototypeOf(validationData) === Object.prototype)) {
						GeneralSettingsAdmin.closeHFilterSettingsPanel();
						Storyboard.GeneralSettings.saveHFilterSettings(storyboardSettings);
					} else {
						GeneralSettingsAdmin.showMinMaxValidation(validationData, true);
					}
				});
		}
    },
    saveHFilterSlideExclusions: function(callback) {
        Storyboard.GeneralSettings.saveHFilterSlideExclusions(callback);
	},
	saveRefDataSettings: function () {
		if (GeneralSettingsAdmin.validateRefDataSettings())
			Storyboard.GeneralSettings.saveRefDataSettings();
	},
	showHideRefDataSettings: function () {
		var enabled = $('#chbEnableRefData').is(':checked');
		$('#refDataSetupContainerPanel #txtRefDataName').parent().toggle(enabled);
		$('#refDataSetupContainerPanel #refDataCustomRules, #refDataSetupContainerPanel #refDataSettingsAdmin').toggle(enabled);

		GeneralSettingsAdmin.showHideLimitRefDataSettings();
		GeneralSettingsAdmin.validateRefDataSettings();
	},
	showHideLimitRefDataSettings: function () {
		var limitPossible = Storyboard.GeneralSettings.hasHFilter() || Storyboard.GeneralSettings.hasFilter();
		$('input[name="rbgLimitRefSets"]').closest('.settingItem').toggle(limitPossible);
		$('.shownRefFilterSetsType').toggle(limitPossible && $('#rbShowLimitedRefSets').is(':checked'));		
		if (!Storyboard.GeneralSettings.hasHFilter()) {
			$('.shownRefFilterSetsType.hfilteroption').hide();
		}
		if (!Storyboard.GeneralSettings.hasFilter()) {
			$('.shownRefFilterSetsType.filteroption').hide();
			$('#lblRefDataHFiltersIndependentOfFilters').text('Show Filter sets of Hierarchical filter selections');
		} else
			$('#lblRefDataHFiltersIndependentOfFilters').text('Show Filter sets of Hierarchical filter selections independent of Optional filter selections');
	},
	showHideMatchRefDataByHFType: function () {
		var show = $('#rbShowLimitedRefSets').is(':checked') && Storyboard.GeneralSettings.hasHFilter() &&
			$('.chbRefSetBy[value="1"]:checked, .chbRefSetBy[value="2"]:checked').length > 0;
		$('.matchRefDataByHFType').toggle(show);
	},
	showHideSelectFilterSetsToShow: function () {
		if ($('#chbShowSpecificFilterSets').is(':checked'))
			$('#ddlRefDataAlwaysShownSets').multiselect('enable');
		else
			$('#ddlRefDataAlwaysShownSets').multiselect('disable');
	},
	validateRefDataSettings: function () {
		var message = '';

		var noneEnabled = $('#chbEnableRefData').is(':checked') && $('#refDataSetupContainerPanel .refDataIncludeAllFilterSets:checked').length === 0 &&
			$('#refDataSetupContainerPanel table .refDataFilterSetEnabledAdmin:checked').length === 0;
		if (noneEnabled) {
			message = 'Please enable at least one Filter set';
		}

		if (message === '') {
			$('#btnRefDataSetupSave').removeAttr('disabled');
			$('#lblRefDataSetupMessage').text('').hide();
			return true;
		} else {
			$('#btnRefDataSetupSave').attr('disabled', 'disabled');
			$('#lblRefDataSetupMessage').text(message).show();
			return false;
		}
	},
	validateSettings: function () {
		var noneSelected = [];
		var dateVariablesValidation = {
			areValid: true,
			message: ''
		};
		$(".SettingsControl").each(function () {
			if ($(this).find("#chbUseSetting").is(":checked")) {
				var hasSelectedItems = false;
				$(this).find(".items #chbIsSelected, li > input").each(function () {
					if ($(this).is(":checked") && !hasSelectedItems) {
						hasSelectedItems = true;
					}
				});

				if (!hasSelectedItems && $(this).attr('id') === 'setupPanel_3')
					$(this).find("input.chbPreparedPeriodType").each(function () {
						if ($(this).is(":checked") && !hasSelectedItems) {
							hasSelectedItems = true;
						}
					});

				if ($(this).find("#ddlShownHFiltersType").length > 0 && $(this).find("#ddlShownHFiltersType").val() == 3) // levels
					hasSelectedItems = $("#hFilterShownLevelsWrapper .shownHFilterLevel:checked").length > 0;

				var settingName = $(this).find("#txtName").val();
				if (!hasSelectedItems) {
					var item = {};
					item.settingName = settingName;
					item.hasSelectedItems = hasSelectedItems;
					noneSelected.push(item);
				}

				var $allowDateVariablesSection = $(this).find('#chbAllowDateVariablesSelection');
				if ($allowDateVariablesSection.length > 0 && $allowDateVariablesSection.is(':checked')) {
					var items = $('.dateVariablesSection').siblings('.items');
					var checkedItems = items.find('.settingItem').filter(function() { return this.style.display !== "none"; }).find('.settingItemSelected #chbIsSelected:checked');
					var preparedPeriodItems = items.find('.nohovertr .chbPreparedPeriodType');
					var preparedPeriodCheckedItems = preparedPeriodItems.filter(":checked");

					if ($('#setupcontainer .dateVariablesItems').find('input[id^="chbDateVariable_"]:checked').length === 0) {
						dateVariablesValidation.areValid = false;
						dateVariablesValidation.message = 'Date variable selection: At least 1 variable need to be ticked';
					} else if (checkedItems.length === 0 && preparedPeriodCheckedItems.length === 0) {
						dateVariablesValidation.areValid = false;
						dateVariablesValidation.message = 'Time periods is missing selected options, unselect setting or select options';
					}
				}
			}
		});
		$(noneSelected).each(function () { alert(this.settingName + " is missing selected options, unselect setting or select options"); });

		if (!dateVariablesValidation.areValid && dateVariablesValidation.message !== '')
			alert(dateVariablesValidation.message);

		return noneSelected.length === 0 && dateVariablesValidation.areValid;
	},
	validateMinMaxSelections: function (storyboardSettingss) {
		let $deferred = $.Deferred();

		let storyboardSettings = JSON.parse(JSON.stringify(storyboardSettingss));
		Helpers.fixDotnetCasing(storyboardSettings);

		let filteredSettings = storyboardSettings.filter(el => el.minNoOfSelections || el.maxNoOfSelections || el.settingItems.some(si => si.minNoOfSelections || si.maxNoOfSelections));
		if (!filteredSettings.length) {
			$deferred.resolve({});
		} else {
			let params = {
				method: "ValidateMinMaxSelections",
				data: { storyboardSettings: filteredSettings },
				message: "Validating Min/Max options",
				successCallback: function (validationData) {
					$deferred.resolve(validationData);
				},
				service: "GeneralSettings"
			};

			Helpers.perfJSonCall(params);
		}

		return $deferred;
	},
	showMinMaxValidation: function (validationData, isHfilter, omitAlert) {
		const minMaxValidationFlags = {
			None: 0,
			MinHigherThanMax: 1,
			MinHigherThanSelectedOptions: 2,
			MaxLowerThanSelectedOptions: 4,
			MinHigherThanAvailableOptions: 8
		}

		function hasFlag(obj, flag) { return (obj & flag) == flag; }

		let dmsgs = [];

		function createMessage(item, isForHfilter) {
			let msg = `<span style="display:block"><b>${item.ItemName}: </b><span>{0}</span></span>`;
			let msg1 = '';

			if (hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanMax))
				msg1 = 'Minimum selections is higher than Maximum selections.';
			else if (hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanSelectedOptions) || hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanAvailableOptions))
				msg1 = 'Minimum selections is higher than number of ' + (isForHfilter ? 'available nodes' : 'selected default options') + '.';
			else if (hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MaxLowerThanSelectedOptions))
				msg1 = 'Maximum selections is lower than number of ' + (isForHfilter ? 'available nodes' : 'selected default options') + '.';

			dmsgs.push(msg.replace('{0}', msg1));
		}

		function markControls(item) {
			let $itemRow = $(`#setupPanel_5 .settingItemSelected #hidSettingDisplayID[value="${item.SettingDisplayId}"]`).closest('.settingItemInline');

			let markMinInput = hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanMax) || hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanSelectedOptions) || hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanAvailableOptions);
			$itemRow.find('#minNoOfSelections').css('border-color', markMinInput ? 'red' : '');

			let markMaxInput = hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanMax) || hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MaxLowerThanSelectedOptions);
			$itemRow.find('#maxNoOfSelections').css('border-color', markMaxInput ? 'red' : '');

			let markDefaultSelections = !hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanMax) && (hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MinHigherThanSelectedOptions) || hasFlag(item.MinMaxValidationFlags, minMaxValidationFlags.MaxLowerThanSelectedOptions));
			$itemRow.find('.settingDefaultSelection > button').css('border-color', markDefaultSelections ? 'red' : '');
		}

		if (validationData.Filter)
			for (const item of validationData.Filter) {
				markControls(item);
				createMessage(item);
            }	

        if (validationData.VariableSubset)
			for (const item of validationData.VariableSubset)
				createMessage(item);

		if (validationData.HFilter)
			for (const item of validationData.HFilter)
				createMessage(item, true);
		
		if (dmsgs.length) {
            if (isHfilter)
				$('#lblHFMinMaxValidationMessage').html(dmsgs.join('\r\n')).show();
            else
				$('#lblMinMaxValidationMessage').html(dmsgs.join('\r\n')).show();

			if(!omitAlert)
				alert('Please correct all validation errors!');
        }
    },
	checkAll: function (sender) {
		var checked = $(sender).is(":checked");
		$(sender).closest(".grdSettings").find(".chbIsSelected input, input.chbPreparedPeriodType").each(function () {
			$(this).attr("checked", checked);
			GeneralSettingsAdmin.disableDefault(this);
		});
	},
	updateCheckAllCheckbox: function(sender) {
		var items = $(sender).closest(".grdSettings").find(".settingItemInline").find("#chbIsSelected");
		var checkedItems = items.filter(":checked");
		var allChecked = items.length > 0 && items.length === checkedItems.length;
		$(sender).closest(".grdSettings").find("#checkAll").attr("checked", allChecked);
	},
	addNoSelectionForAll: function(sender) {
		var checked = $(sender).is(":checked");
		$(sender).closest(".grdSettings").find("td.settingHasNoSelection input:not(:disabled)").each(function () {
			$(this).attr("checked", checked);
			GeneralSettingsAdmin.changeNoSelectionItemDefaultSelection(this);

			if (!checked && $(this).closest('.settingHasNoSelection').siblings('.settingIsMultiSelect').find('#cbFIsMultiSelect').is(':checked')) {
				$(this).closest('.settingHasNoSelection').siblings('.settingMinNoOfSelections').find('#minNoOfSelections').removeAttr('disabled');
				$(this).closest('.settingHasNoSelection').siblings('.settingMaxNoOfSelections').find('#maxNoOfSelections').removeAttr('disabled');
			} else {
				$(this).closest('.settingHasNoSelection').siblings('.settingMinNoOfSelections').find('#minNoOfSelections').attr('disabled', 'disabled');
			}
		});
	},
	updateAddNoSelectionForAllCheckbox: function(sender) {
		var items = $(sender).closest(".grdSettings").find(".settingItemInline").find("#cbFHasNoSelection");
		var checkedItems = items.filter(":checked");
		var allChecked = items.length > 0 && items.length === checkedItems.length;
		$(sender).closest(".grdSettings").find(".chbHasNoSelectionForAll").attr("checked", allChecked);
	},
	setMultiselectForAll: function (sender) {
		var checked = $(sender).is(":checked");
		$(sender).closest(".grdSettings").find("td.settingIsMultiSelect input:not(:disabled)").each(function () {
			$(this).attr("checked", checked);
			GeneralSettingsAdmin.changeMultiselectDefaultSelection(this);

			let $minNoOfSelections = $(this).closest('.settingIsMultiSelect').siblings('.settingMinNoOfSelections').find('#minNoOfSelections');
			let $maxNoOfSelections = $(this).closest('.settingIsMultiSelect').siblings('.settingMaxNoOfSelections').find('#maxNoOfSelections');
			let $ddlDefaultSelection = $(this).closest('.settingIsMultiSelect').siblings('.settingDefaultSelection').find('select');
			let hasNoSelection = $(this).closest('.settingIsMultiSelect').siblings('.settingHasNoSelection').find('#cbFHasNoSelection').is(':checked');

			if (checked) { 
				if (!hasNoSelection)
					$minNoOfSelections.removeAttr('disabled');
				$maxNoOfSelections.removeAttr('disabled');

				if ($minNoOfSelections.val() > 1 && !hasNoSelection) {
					$ddlDefaultSelection.find("option[value='0-0']").text(`First ${$minNoOfSelections.val()} items will be selected`);
					$ddlDefaultSelection.find("option[value='0-1']").text(`Last ${$minNoOfSelections.val()} items will be selected`);
				} else {
					$ddlDefaultSelection.find("option[value='0-0']").text(`First item will be selected`);
					$ddlDefaultSelection.find("option[value='0-1']").text(`Last item will be selected`);
				}
			} else {
				$minNoOfSelections.attr('disabled', 'disabled');
				$maxNoOfSelections.attr('disabled', 'disabled');
				if (!hasNoSelection) {
					$ddlDefaultSelection.find("option[value='0-0']").text(`First item will be selected`);
					$ddlDefaultSelection.find("option[value='0-1']").text(`Last item will be selected`);
				}
			}
		});
	},
	updateMultiselectForAllCheckbox: function(sender) {
		var items = $(sender).closest(".grdSettings").find(".settingItemInline").find("#cbFIsMultiSelect");
		var checkedItems = items.filter(":checked");
		var allChecked = items.length > 0 && items.length === checkedItems.length;
		$(sender).closest(".grdSettings").find(".chbIsMultiSelectForAll").attr("checked", allChecked);
	},
	setBehaviourForAll: function(sender) {
		var value = $(sender).val();
		if (value == -1) return;
		$(sender).closest(".grdSettings").find("td.settingBehaviour select:not(:disabled)").each(function () {
			setDefaultSelected($(this), value);
			GeneralSettingsAdmin.changeFilterBahaviour(this);
		});
	},
	updateBehaviourForAllSelect: function(sender) {
		var items = $(sender).closest(".grdSettings").find(".settingItemInline").find("#ddlFilterBehaviour");
		var selectedValues = items.toArray().reduce(function(acc, curr) {
			var value = $(curr).val();
			acc[value] = acc[value] ? acc[value] + 1 : 1;
			return acc;
		}, {});
		var selectedValue = Object.keys(selectedValues).filter(function(key) { return selectedValues[key] === items.length; });
		var selectControl = $(sender).closest(".grdSettings").find(".ddlFilterBehaviourForAll");

		if (selectedValue.length === 1) selectControl.val(selectedValue[0]);
		else selectControl.val(-1);
	},
	setDefaultBehaviourForAll: function(sender) {
		var value = $(sender).val();
		if (value == -1) return;
		$(sender).closest(".grdSettings").find("td.settingDefaultCompare select:not(:disabled)").each(function () {
			setDefaultSelected($(this), value);
		});
	},
	updateDefaultBehaviourForAllSelect: function(sender) {
		var items = $(sender).closest(".grdSettings").find(".settingItemInline").find("#ddlDefaultBehaviour");
		var selectedValues = items.toArray().reduce(function(acc, curr) {
			var value = $(curr).val();
			acc[value] = acc[value] ? acc[value] + 1 : 1;
			return acc;
		}, {});
		var selectedValue = Object.keys(selectedValues).filter(function(key) { return selectedValues[key] === items.length; });
		var selectControl = $(sender).closest(".grdSettings").find(".ddlDefaultBehaviourForAll");

		if (selectedValue.length === 1) selectControl.val(selectedValue[0]);
		else selectControl.val(-1);
	},
	setDynamicFilteringForAll: function(sender) {
		var value = $(sender).val();
		if (value == -1) return;
		$(sender).closest(".grdSettings").find("td.settingDynamicFiltering select:visible:not(:disabled)").each(function () {
		   setDefaultSelected($(this), value);
		   GeneralSettingsAdmin.setDynamicFilteringDefaultSelections(this);
		});
	},
	updateDynamicFilteringForAllSelect: function(sender) {
		var items = $(sender).closest(".grdSettings").find(".settingItemInline").find("#ddlDynamicFiltering");
		var selectedValues = items.toArray().reduce(function(acc, curr) {
			var value = $(curr).val();
			acc[value] = acc[value] ? acc[value] + 1 : 1;
			return acc;
		}, {});
		var selectedValue = Object.keys(selectedValues).filter(function(key) { return selectedValues[key] === items.length; });
		var selectControl = $(sender).closest(".grdSettings").find(".ddlDynamicFilteringForAll");

        if (selectedValue.length === 1) selectControl.val(selectedValue[0]);
        else selectControl.val(-1);
    },
    setHFilterVsFilterBehaviorForAll: function(sender) {
        var value = $(sender).val();
        if (value < 1) return;
        $(sender).closest(".grdSettings").find("td.settingHFilterVsFilterBehavior select:visible:not(:disabled)").each(function () {
           setDefaultSelected($(this), value);
        });
    },
    updateHFilterVsFilterBehaviorForAllSelect: function(sender) {
        var items = $(sender).closest(".grdSettings").find(".settingItemInline").find("#ddlHFilterVsFilterBehavior");
        var selectedValues = items.toArray().reduce(function(acc, curr) {
            var value = $(curr).val();
            acc[value] = acc[value] ? acc[value] + 1 : 1;
            return acc;
        }, {});
        var selectedValue = Object.keys(selectedValues).filter(function(key) { return selectedValues[key] === items.length; });
        var selectControl = $(sender).closest(".grdSettings").find(".ddlHFilterVsFilterBehaviorForAll");

		if (selectedValue.length === 1) selectControl.val(selectedValue[0]);
		else selectControl.val(-1);
	},
	toggleMultiSelection: function (sender) {
		var settingType = parseInt($(sender).parents('.AdminSetting').find('.hidSettingType').val(), 10);

		if (settingType === 1) {
			const isChecked = $(sender).is(":checked");
			$(sender).parents(".AdminSetting").find(".vsSelectionRange").toggle(isChecked);
			$(sender).parents(".AdminSetting").find("#grdItems .settingRdbItemDefault input").parent().toggle(!isChecked);
			$(sender).parents(".AdminSetting").find("#grdItems .settingChbItemDefault input").parent().toggle(isChecked);
		}
		else {
			var isMultiSelect = $(sender).parent().find('#chbIsMultiSelect').is(':checked');
			var isSplitBoxes = $(sender).parent().find('#chbSplitBoxes').is(':checked');

			if (isMultiSelect || isSplitBoxes) {
				$(sender).parents(".AdminSetting").find("#grdItems .settingRdbItemDefault input").hide();
				$(sender).parents(".AdminSetting").find("#grdItems .settingChbItemDefault input").show();
			}
			else {
				$(sender).parents(".AdminSetting").find("#grdItems .settingRdbItemDefault input").show();
				$(sender).parents(".AdminSetting").find("#grdItems .settingChbItemDefault input").hide();
			}
		}

		$(sender).parents(".AdminSetting").find("#grdItems .chbIsSelected input").each(function () {
			GeneralSettingsAdmin.disableDefault(this);
		});
	},
	toggleSplitboxes: function (sender) {
		var settingType = parseInt($(sender).parents('.AdminSetting').find('.hidSettingType').val(), 10);
		if (settingType === 5) {
			if ($(sender).is(":checked")) {
				$(sender).parents(".AdminSetting").find("#grdItems .settingRdbItemDefault input").hide();
			}
			else {
				$(sender).parents(".AdminSetting").find("#grdItems .settingRdbItemDefault input").show();
			}
		}
	},
	appendTimePeriodToOptionalFilters: function (sender) {
		var templateRow = $(sender).closest('tr').find('.periodTableTemplate').clone();
		templateRow.css('display', '');
		templateRow.removeClass('periodTableTemplate');
		templateRow.find('.ofSettingDisplayID').val('');
		templateRow.find('.settingDefaultComp').attr('checked', false);
		var table = $(sender).closest('tr').find('#selectDatePeriodTable');
		table.append(templateRow);
	},
	isNumberKey: function (evt) {
		var charCode = (evt.which) ? evt.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57))
			return false;

		return true;
	},
    openGroupSlidesPopup: function() {
        new DUIwindow2({
            title: "<h2>" + locale.get("Group slides") + "</h2>",
            width: 500,
            buttons: [],
            html: '<div>'+
                    '<p>Slides with the same exclusion rules can be grouped for a more efficient setup as the rules are set for the group instead of each individual slide</p>'+
                    '<div>'+
                        '<button type="button" id="btnGroupSlides" class="DUIbutton" disabled>Group selected slides</button>'+
                        '<button type="button" id="btnUngroupSlides" class="DUIbutton m-x-1" disabled>Ungroup slides</button>'+
                    '</div>'+
                    '<select id="ddlGroupSlides" class="settingControlFull m-t-1 group-slides-select" multiple></select>'+
                '</div>',
            modal: false,
            afterShow: function() {
                $(this.windowEl).find('.DUI-WINDOW-BODY').css('padding-top', 0);
                Storyboard.GeneralSettings.bindExcludeSlides('#ddlGroupSlides');
                $('#ddlGroupSlides').attr('size', $('#ddlGroupSlides').find('option').length);

                $('#ddlGroupSlides').bind('change', GeneralSettingsAdmin.enableDisabledGroupSlidesButtons);
                $('#btnGroupSlides').bind('click', Storyboard.GeneralSettings.groupHFilterExclusionSlides);
                $('#btnUngroupSlides').bind('click', Storyboard.GeneralSettings.ungroupHFilterExclusionSlides);
            },
            beforeClose: function() {
                Storyboard.GeneralSettings.bindExcludeSlides('#ddlExcludeSlides');
                Storyboard.GeneralSettings.bindExcludeSlidesHFiltersAdmin();
            }
        });
    },
    enableDisabledGroupSlidesButtons: function() {
        var selected = $('#ddlGroupSlides').val();
        
        if (selected && selected.length > 0) {
            $('#btnGroupSlides').attr('disabled', selected.length < 2);
            $('#btnUngroupSlides').attr('disabled', !selected.some(function(slideIds) {
                return slideIds.split(',').length > 1;
            }));
        } else {
            $('#btnGroupSlides, #btnUngroupSlides').attr('disabled', true);
        }
    },
    openExcludeSlidesBulkEdit: function() {
        var hFilterSlideExclusions = Storyboard.GeneralSettings.getHFilterSlideExclusions();
        var anyCustomNodeSelections = hFilterSlideExclusions.some(function(exclusion) {
            return exclusion.HFilterSelectionType === 0;
        });

        $('#btn-template').attr('disabled', !anyCustomNodeSelections);

        $("#bulkUploadsAndEditsContainer")
            .css("display", "block").addClass('excludeSlidesBulkEdit')
            .parent().addClass("DUISetupOuter");
    },
    downloadHFilterSettingsTemplate: function(reportId) {
        var iframe = document.createElement("iframe");
        iframe.src = $('input[id$="hidBaseUrl"]').val() + '/Storyboard/FileHandler.ashx?DownloadHFilterSettingsTemplate=true&Rpid=' + reportId;
        iframe.style.display = "none";
        document.body.appendChild(iframe);
    },
    downloadHFilterSlideExclusionsTemplate: function(reportId) {
        var iframe = document.createElement("iframe");
        iframe.src = $('input[id$="hidBaseUrl"]').val() + '/Storyboard/FileHandler.ashx?DownloadHFilterSlideExclusionsTemplate=true&Rpid=' + reportId;
        iframe.style.display = "none";
        document.body.appendChild(iframe);
    },
    uploadHFilterSettingsTemplate: function(reportId, data){
        var url = $('input[id$="hidBaseUrl"]').val() + '/Storyboard/FileHandler.ashx?uploadHFilterSettingsTemplate=true&Rpid=' + reportId;
        var formData = new FormData();
  
        formData.append('myFile', data);
        var loadingBar = Storyboard.LayoutControls.showLoadingBar('Uploading template...');
  
        return $.ajax({
            type: 'POST',
            url: url,
            processData: false,
            contentType: false,
            data: formData,
            success: function (data, status, xhr) {
              var importResponse = JSON.parse(xhr.responseText)
              Storyboard.LayoutControls.hideLoadingBar(loadingBar);
              if (importResponse.status.statusCode === 'ERROR' || 
                  importResponse.status.statusCode === 'VALIDATION_ERROR') {
                  DUImessage.show(importResponse.status.messages[0], 'Message-error', 5000)
              } else if (importResponse.status.statusCode === 'SUCCESS') {
                  var message = importResponse.status.messages[0] + '<br/>Shown rows with this import: ' + importResponse.data.countInserted + ".<br/>Hidden rows with this import: " + importResponse.data.countDeleted + '.'
                  DUImessage.show(message, 'Message-success', 5000)
                  $("#bulkUploadsAndEditsContainer").css('display', 'none').parent().removeClass("DUISetupOuter");
                  $("#file-upload").val(null);
                  $("#btn-import").attr('disabled', true);
                  Storyboard.GeneralSettings.loadHFiltersAdmin(null, true);
              }
            },
            error: function (xhr, status, error) {
                var errObj = JSON.parse(xhr.responseText);
                Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                Storyboard.LayoutControls.showError(errObj.Message || 'Unknown error occured');
                console.log(error)
            }
        });
    },
    uploadHFilterSlideExclusionsTemplate: function(reportId, data){
        var url = $('input[id$="hidBaseUrl"]').val() + '/Storyboard/FileHandler.ashx?uploadHFilterSlideExclusionsTemplate=true&Rpid=' + reportId;
        var formData = new FormData();
  
        formData.append('myFile', data);
        var loadingBar = Storyboard.LayoutControls.showLoadingBar('Uploading template...');
  
        return $.ajax({
            type: 'POST',
            url: url,
            processData: false,
            contentType: false,
            data: formData,
            success: function (data, status, xhr) {
              var importResponse = JSON.parse(xhr.responseText)
              Storyboard.LayoutControls.hideLoadingBar(loadingBar);
              if (importResponse.status.statusCode === 'ERROR' || 
                  importResponse.status.statusCode === 'VALIDATION_ERROR') {
                  DUImessage.show(importResponse.status.messages[0], 'Message-error', 5000)
              } else if (importResponse.status.statusCode === 'SUCCESS') {
                  DUImessage.show(importResponse.status.messages[0], 'Message-success', 5000)
                  $("#bulkUploadsAndEditsContainer").css('display', 'none').removeClass('excludeSlidesBulkEdit').parent().removeClass("DUISetupOuter");
                  $("#file-upload").val(null);
                  $("#btn-import").attr('disabled', true);
                  Storyboard.GeneralSettings.loadHFilterSlideExclusions();
              }
            },
            error: function (xhr, status, error) {
                var errObj = JSON.parse(xhr.responseText);
                Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                Storyboard.LayoutControls.showError(errObj.Message || 'Unknown error occured');
                console.log(error)
            }
        });
	}
};

window.inIframe = function () {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
};

$(document).ready(function () {

	//translate part
	if (window.IsStoryboard || window.IsFormReport || window.IsMyStories) {
		if (self !== top && !isCrossOrigin()) {
			$("#btnOpenExportPanel").text(parent.locale.get("Export"));
			$("#btnUpdateCharts").text(parent.locale.get("Update"));
			$("#sbTextSlide").text(parent.locale.get("Slide"));
			$("#sbTextSlideOf").text(parent.locale.get("of"));
			$("#btnPrintPreviewClose").text(parent.locale.get("Cancel"));
			$("#btnPrintStory").text(parent.locale.get("Print"));
		} else {
			$("#btnOpenExportPanel").text(locale.get("Export"));
			$("#btnUpdateCharts").text(locale.get("Update"));
			$("#sbTextSlide").text(locale.get("Slide"));
			$("#sbTextSlideOf").text(locale.get("of"));
			$("#btnPrintPreviewClose").text(locale.get("Cancel"));
			$("#btnPrintStory").text(locale.get("Print"));
		}
	}

	if (window.IsStoryboard) {
		if (window.ContentType > 0) {
			Storyboard.GuiEvents.setupSingleObjectMode(window.ContentType);
			$("#updGeneralSettings .ribbonMenu, #updGeneralSettings .ribbonHeader, #ADMIN_RH_PREVIEWMODE_PANEL, #DUI-ST-USAGE-STATS, "+
				"#btnSaveLayout, #btnPreviewMode, #DUI_ST_NAVIGATOR").hide();
			$("#hfilterSetupContainerPanel").detach().appendTo("#fsHfiltersContentWrapper");
			$("#lbHfilterLayoutType").val(4).attr("disabled", "disabled").hide();
			$("#fsDeviceLimitation").detach().appendTo("#fsDeviceLimitSettings");
			$("#fsReportDocFormat").detach().appendTo("#fsReportDocFormatSettingsWrapper");
			if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
				$("#presentationControls").hide();
			}
			if (window.ContentType === Storyboard.Constants.itemTypes.CHART) {
				$(".showPPTTemplate").detach().appendTo("#fsReportDocFormatSettingsWrapper");
			}
			$("#fsExportOptions").detach().appendTo("#fsReportExportFormatSettings");
			$("#sfDocFormatImageQuality").detach().appendTo("#fsReportExportFormatSettings");
		}

		if (Storyboard.LayoutDesigner.isMyStoryMode()) {

			$(document).bind("hFilterCallbackFinished", function () {
				$('#btnUpdateCharts').click();
			});

            $('#btnMyStory').remove();
            $('#btnPreviewMode').remove();
            $('#btnChangeStoryboard').remove();
            $('#poweredby').remove();
            $('#ADMIN_RH_PREVIEWMODE_PANEL').hide();
            $('.SettingsControl').remove();
            $('.ribbonMenu, .ribbonHeader').remove();
            $('.save').remove();
            $('#reportTabStripWrapper').remove();
            $('#StorytellerObjectsToolbar').remove();
            $('#adminToolbar').css('display', 'none');
            $('html.admin').removeClass('admin');
		}

		$.when(
			Storyboard.GeneralSettings.loadGeneralSettingsHash(),
			Storyboard.LayoutDesigner.loadLayout(true),
			Storyboard.GeneralSettings.loadStorySlideSettings(),
			Storyboard.GeneralSettings.loadDefaultOptionalFilters())
			.done(function (sbHashData, layoutData, storySlideSettings, settings) {
				var layoutInfo = layoutData[0].d;
				var waitOnHashedData = 2;

				function loadFiltering() {
					$.when(
						Storyboard.DynamicFiltering.reportLoadDynamicFiltering(true),
						Storyboard.ReferenceDataFiltering.showHideRefDataSets(true)
					)
					.then(continueWithLoadCooridnatesComplete);
				}
				
				function hashedDataLoaded() {
					waitOnHashedData--;
					if (waitOnHashedData > 0)
						return;

					$(document).unbind("DAPI.hashedSettingsLoaded");
					$(document).unbind("DAPI.hashedLayoutGridLoaded");

					// Optional filters
					Storyboard.GeneralSettings.storyBoardAccess = layoutInfo.storyboardAccess;
					Storyboard.GeneralSettings.hfilterVsVarSubsetActive = layoutInfo.hfilterVsVarSubsetsActive;
					Storyboard.GeneralSettings.filterLazyRenderCount = layoutInfo.filterLazyRenderCount;
					Storyboard.GeneralSettings.storeSingleObjectExports = layoutInfo.storeSingleObjectExports;
					Storyboard.GeneralSettings.respondentBlockCheckInterval = layoutInfo.respondentBlockCheckInterval;
					Storyboard.GeneralSettings.collaborationVersionCheckInterval = layoutInfo.collaborationVersionCheckInterval;
                    Storyboard.GeneralSettings.filterNoSelectionLabel = layoutInfo.noSelectionLabel.Item1 === false ? locale.get("No selection") : layoutInfo.noSelectionLabel.Item2;
                    Storyboard.LayoutDesigner.setHFilterLayout(layoutInfo.settings.HFilterLayout, layoutInfo.settings.HFilterSelectionMode);
					Storyboard.GeneralSettings.bindGeneralSettings(null, layoutInfo.settings.HFilterLayout, layoutInfo.hFilterLevelSettings, layoutInfo.hfilters);
					Storyboard.GeneralSettings.conditionalVisibilityForFilters = layoutInfo.conditionalVisibilityForFilters;

					layoutInfo.layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();

					if (storySlideSettings) {
						var storySettings = storySlideSettings[0].d;
						for (var i = 0; i < storySettings.length; i++) {
							var settingItem = storySettings[i];

							if (settingItem.SettingType === 1) {
								Storyboard.GeneralSettings.restoreVariableSubsetState(settingItem);
							}
							else if (settingItem.SettingType === 6) {
								Storyboard.GeneralSettings.refreshHFilter(settingItem.SelectedSettings);
							}
							else {
								Storyboard.GeneralSettings.restoreGenericOptionalSettingState(settingItem);
							}
						}
					}

					if (Storyboard.DynamicFiltering.isEnabled() || Storyboard.ReferenceDataFiltering.isEnabled()) {
						if (Storyboard.GeneralSettings.prepPeriodItemsLoading) {
							$(document).bind("DAPI.hashedPreparedTimePeriodsLoaded", function () {
								loadFiltering();
							});
						} else {
							loadFiltering();
						}
					} else {
						continueWithLoadCooridnatesComplete();
					}
				}

				function continueWithLoadCooridnatesComplete() {
					// Layout
					if (Storyboard.GeneralSettings.hfilterVsVarSubsetsActive || 
						Storyboard.GeneralSettings.hfilterVsFiltersActive) {

						$.when(
							GeneralSettings.fillVariableSubsetList(),
							GeneralSettings.getFiltersConnectedToHFilters()
						)
						.then(function() {
							layoutInfo.hFilterConnectionsLoaded = true;
							Storyboard.LayoutDesigner.loadCoordinatesComplete(layoutInfo);
						});
					} else {
						Storyboard.LayoutDesigner.loadCoordinatesComplete(layoutInfo);
					}

					// Old MyStories logic
					if (Storyboard.LayoutDesigner.isMyStoryMode()) {
						if (!Storyboard.HFilterLayout.hasHFilterNodes()) {
							$('#pnlSettingsPanel').hide();
							$('#btnUpdateCharts').click();
						}
						else {
							var selectedHFilterIDs = Helpers.getURLParameter('selectedmystoryhfilters');
							if (selectedHFilterIDs && selectedHFilterIDs.length > 0) {
								Storyboard.GeneralSettings.refreshHFilter(selectedHFilterIDs);
							}
						}
					}
					if (Storyboard.GeneralSettings.storyBoardAccess.MyStories && $("#btnMyStory").length > 0)
						Storyboard.MyStory.InitializeMyStory();
				}

				$(document).bind("DAPI.hashedSettingsLoaded", hashedDataLoaded);
				$(document).bind("DAPI.hashedLayoutGridLoaded", hashedDataLoaded);

				Storyboard.LayoutControls.showLoadingBar(locale.get("Loading filters"));
				Storyboard.GeneralSettings.insertHashDataScript("generalSettingsCacheScript", sbHashData[0].d, "Storyboard.GeneralSettings.setStoryboardSettingsFromCache");
				Storyboard.LayoutControls.showLoadingBar(locale.get("Loading layout"));
				Storyboard.GeneralSettings.insertHashDataScript("layoutGridCacheScript", layoutInfo.layoutHash, "Storyboard.LayoutDesigner.setLayoutGrid");

				Storyboard.LayoutDesigner.setFontSettings(layoutInfo.fontSettings);

				if (typeof initTinyMce == 'function') {
					initTinyMce();
				}

				// StoryboardAccess
				Storyboard.GeneralSettings.storyBoardAccess = layoutInfo.storyboardAccess;
				if (!Storyboard.GeneralSettings.storyBoardAccess.MyStories) {
					$('#btnMyStory').attr('disabled', 'disabled');
					$('#btnMyStory').unbind("click");
				}
				if (!Storyboard.GeneralSettings.storyBoardAccess.HeatMap) {
					$('#DUI_ST_R_ADDON_HEATMAP').attr('disabled', 'disabled');
					$("#DUI_ST_R_ADDON_HEATMAP").unbind("click");
				}
				if (typeof (Storyboard.GeneralSettings.storyBoardAccess.HtmlBox) != 'undefined' &&
					!Storyboard.GeneralSettings.storyBoardAccess.HtmlBox) {
					$('#DUI_ST_R_ADDCOMPONENT_RICHCONTENT').attr('disabled', 'disabled').attr('id', 'DUI_ST_R_ADDCOMPONENT_RICHCONTENT_disabled');
					$("#DUI_ST_R_ADDCOMPONENT_RICHCONTENT").unbind("click");
				}

				Storyboard.EventBus.emit(Storyboard.Constants.Events.LAYOUT_INFO_LOADED, layoutInfo);
			});

		//$(document).bind("DAPI.dynamicFilteringLoaded", function () {
		//	Storyboard.LayoutDesigner.checkFilterSelection({checkMinMaxSelectionsOnly:true});
		//});
	}

	if (window.IsFormReport) {
		$(['#DUI_ST_NAVIGATOR'].join(',')).remove();
		$('#GeneralControl, #divFormSettings').show();
		$('#pnlSettingsPanel > div').not("#divFormSettings").not("#languageContainer").remove();
		$('#languageContainer').prependTo('#divFormSettings');

        var isCreateActionPlan = false;
        var respondentId = '';
        if (window.inIframe()) {
            // hide settings when report is open from respondent table
            $('#divFormSettings').hide();

            isCreateActionPlan = new URLSearchParams(window.location.search).get('actPlnFilters') != null;

            if (window.name == "print-frame")
                respondentId = $('#ddlFormRespondents', window.parent.document).val();
        }

        var configureRespondentForm = function(respondentsData) {
            if (isCreateActionPlan || (respondentsData.d && respondentsData.d.length > 0)) {

                if (!isCreateActionPlan)
                    HTMLHelpers.bindSelect($('#ddlFormRespondents'), respondentsData.d, 'RespondentID', 'Name');

                if (self != top && window.name == "print-frame") { // restore selections in print preview
                    let respondentId = Helpers.readCookie('selectedRespondentId');
                    if (respondentId != null) {
                        $('#ddlFormRespondents').val(respondentId);
                    }
                }

                DataFieldSetup.previousRespondentId = $('#ddlFormRespondents').val();
                if (self == top) {// not inside iframe

                    // check if url has respondent id
                    if (new RegExp('[?&amp;]respondent=([^&amp;#]*)').exec(window.location.href) != null) {
                        let respondentId = new RegExp('[?&amp;]respondent=([^&amp;#]*)').exec(window.location.href)[1];
                        $('#ddlFormRespondents').val(respondentId);
                    }

                    $('#ddlFormRespondents').multiselect({ multiple: false, selectedList: 3 }).multiselectfilter();

                    $('.ui-multiselect-filter input').each(function () {
                        $("<input type='text' />").attr('id', 'respondentFilterBox').insertBefore(this);
                    }).remove();

                    $('#respondentFilterBox').bind('keyup', function () {
                        var filter = $('#respondentFilterBox').val();
                        var params = {
                            method: "LoadRespondentsList",
                            data: { filter: filter },
                            successCallback: function (respondentsList) {
                                HTMLHelpers.bindSelect($('#ddlFormRespondents'), respondentsList, 'RespondentID', 'Name');
                                $('#ddlFormRespondents').multiselect('refresh');
                            }
                        };
                        Helpers.perfJSonCall(params);
                    });
                }

                $.when(Storyboard.LayoutDesigner.loadLayout(true), Storyboard.LayoutDesigner.loadFontSettings())
                    .done(function (data) {
                        if (typeof initTinyMce == 'function') {
                            initTinyMce();
                        }
                        Storyboard.GeneralSettings.storeSingleObjectExports = data[0].d.storeSingleObjectExports;
                        Storyboard.GeneralSettings.respondentBlockCheckInterval = data[0].d.respondentBlockCheckInterval;
                        Storyboard.LayoutDesigner.loadCoordinatesComplete(data[0].d);
                        if (window.location.pathname.substring(
                            window.location.pathname.length - 15,
                            window.location.pathname.length) === 'FormReport.aspx')
                            Helpers.ThrottleQueue.reportProgress();
                    });
            } else {
                $("#lMsg").html("<p class='Message Message-error'>" +
                    locale.get("There is no data available in this view") +
                    "</p>");
                $("#divRespondentsContainer").css("display", "none");
            }
        }

        if (isCreateActionPlan)
            configureRespondentForm();
        else
            $.when(Storyboard.GeneralSettings.loadRespondents(respondentId)).done(configureRespondentForm);
    }

	if (window.IsMyStories) {
		MyStoriesProxy.loadUserStories(function(stories) {
			myStories = stories;

			var yourStories = stories.filter(function(myStory) { return myStory.isShared === false; });
			var sharedStories = stories.filter(function(myStory) { return myStory.isShared === true; });

			function renderMyStoriesList() {

				var fragment = document.createDocumentFragment();

				function createMyStoriesOptgroup(myStoriesArr, optGroupTitle) {
					var optgroup = document.createElement('optgroup');
					optgroup.label = optGroupTitle;

					myStoriesArr.forEach(function(myStory) {
						var option = document.createElement('option');
						option.innerText = myStory.name;
						option.value = myStory.storyId;
						option.title = myStory.name;
						optgroup.appendChild(option);
					});

					return optgroup;
				}

				if (yourStories.length > 0) fragment.appendChild(createMyStoriesOptgroup(yourStories, locale.get('Your Stories')));
				if (sharedStories.length > 0) fragment.appendChild(createMyStoriesOptgroup(sharedStories, locale.get('Shared Stories')));

				return fragment;
			}

			if (sharedStories.length > 0) {
				$("#ddlMyStories").html(renderMyStoriesList(stories));
			} else {
				HTMLHelpers.bindSelect($("#ddlMyStories"), stories, "storyId", "name");
			}

			if (stories.length > 0) {
				if (self != top && window.name == "print-frame") { // Print MyStory
					var myStoryId = Helpers.readCookie('ddlMyStories');
					$("#ddlMyStories").val(myStoryId);
				} else {
					$("#divStoriesContainer").css('display', 'inline-block');
					$("#divStoriesSetupButtons").css('display', 'inline-block');
					$("#lnkDeleteMyStoriesSlide, #lnkMyStoriesSourceSlide").css('display', '');
					if (yourStories.length == 0) {
						$("#lnkDeleteMyStoriesSlide").css('display', 'none');
					}

					for (var i = 0; i < stories.length; i++)
						if (stories[i].slides.length > 0) {
							$("#ddlMyStories").val(stories[i].storyId);
							break;
						}

					$("#ddlMyStories").multiselect({ multiple: false, selectedList: 1, beforeoptgrouptoggle: function() { return false; } }).multiselectfilter();
				}
				Storyboard.MyStories.updateShareButtonContent();

				$.when(Storyboard.LayoutDesigner.loadLayout(true), Storyboard.LayoutDesigner.loadFontSettings())
					.done(function(data) {
						Storyboard.GeneralSettings.storeSingleObjectExports = data[0].d.storeSingleObjectExports;
						Storyboard.GeneralSettings.respondentBlockCheckInterval = data[0].d.respondentBlockCheckInterval;
						Storyboard.LayoutDesigner.loadCoordinatesComplete(data[0].d);
						setTimeout(Storyboard.LayoutDesigner.loadMyStoryContent, 200);
					});
			} else {
				$("#storySlideSettingsInfo").html("<p class='Message Message-error'>" +
					locale.get("There are no My Stories available yet") +
					"</p>");
				$("#btnOpenExportPanel, #StorytellerPagesizeViewport").css("display", "none");

				$.when(Storyboard.LayoutDesigner.loadLayout(true), Storyboard.LayoutDesigner.loadFontSettings())
					.done(function(data) {
						Storyboard.GeneralSettings.storeSingleObjectExports = data[0].d.storeSingleObjectExports;
						Storyboard.GeneralSettings.respondentBlockCheckInterval = data[0].d.respondentBlockCheckInterval;
						Storyboard.LayoutDesigner.loadCoordinatesComplete(data[0].d);
					});
			}

			$(document).trigger('DAPI.userStoriesLoaded', [stories]);
		});
	}
});
